const carData = {
  2010: [
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "649.27",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBS",
      "CO2 (g/mi)": "612.598",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide",
      "CO2 (g/mi)": "564.225",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 Vantage",
      "CO2 (g/mi)": "587.74",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 QUATTRO",
      "CO2 (g/mi)": "239",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "302",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 AVANT QUATTRO",
      "CO2 (g/mi)": "237.6059476",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 QUATTRO",
      "CO2 (g/mi)": "320",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A5 quattro",
      "CO2 (g/mi)": "340",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "227.6235304",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 QUATTRO",
      "CO2 (g/mi)": "274",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8 L",
      "CO2 (g/mi)": "449",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "EOS",
      "CO2 (g/mi)": "323",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "PASSAT WAGON",
      "CO2 (g/mi)": "342",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Audi",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "287",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "546",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "349.8094472",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4",
      "CO2 (g/mi)": "373",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "435",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S6",
      "CO2 (g/mi)": "516",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TIGUAN",
      "CO2 (g/mi)": "382",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TIGUAN 4MOTION",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "464",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT COUPE QUATTRO",
      "CO2 (g/mi)": "219",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "286",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Arnage",
      "CO2 (g/mi)": "764.7413",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "CONTINENTAL GTC",
      "CO2 (g/mi)": "716",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Continental Supersports",
      "CO2 (g/mi)": "612",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i",
      "CO2 (g/mi)": "355.17",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i Convertible",
      "CO2 (g/mi)": "230.3951358",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i",
      "CO2 (g/mi)": "407.14",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135iA",
      "CO2 (g/mi)": "404.53",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci Convertible",
      "CO2 (g/mi)": "439.3",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328CiA Convertible",
      "CO2 (g/mi)": "241.98",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "409.13",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xi",
      "CO2 (g/mi)": "441.29",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xiA",
      "CO2 (g/mi)": "245.65",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci Convertible",
      "CO2 (g/mi)": "424.66",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335d",
      "CO2 (g/mi)": "349.8435909",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i",
      "CO2 (g/mi)": "385.43",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive",
      "CO2 (g/mi)": "424.86",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "394.58",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528xi",
      "CO2 (g/mi)": "394.28",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "435.18",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "368.24",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535iA",
      "CO2 (g/mi)": "422.26",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535xi",
      "CO2 (g/mi)": "458.1",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535xiA",
      "CO2 (g/mi)": "265.31",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "471.57",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i GT",
      "CO2 (g/mi)": "482.77",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "484.94",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive GranTurismo",
      "CO2 (g/mi)": "456.19",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650Ci",
      "CO2 (g/mi)": "479",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650Ci Convertible",
      "CO2 (g/mi)": "511.18",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750 Li xDrive",
      "CO2 (g/mi)": "518.59",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "304.5860911",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "760Li",
      "CO2 (g/mi)": "341.2947673",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid X6",
      "CO2 (g/mi)": "432.44",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "308.29",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3 Convertible",
      "CO2 (g/mi)": "497.13",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "633.427875",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6",
      "CO2 (g/mi)": "352.37",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "612.12",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive30i",
      "CO2 (g/mi)": "426.85",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive30i",
      "CO2 (g/mi)": "463",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "453.8707307",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive48i",
      "CO2 (g/mi)": "529.29",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDriveM",
      "CO2 (g/mi)": "600.3461826",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "299.35",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "558.94",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDriveM",
      "CO2 (g/mi)": "553.27",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive30i",
      "CO2 (g/mi)": "363.09",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35i",
      "CO2 (g/mi)": "252.2494495",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper",
      "CO2 (g/mi)": "240.36",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "283.05",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper JCW",
      "CO2 (g/mi)": "275.06",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper JCW Clubman",
      "CO2 (g/mi)": "282.92",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S",
      "CO2 (g/mi)": "263.67",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini John Cooper Works Convertible",
      "CO2 (g/mi)": "278.66",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Bugatti",
      "Represented Test Veh Model": "Veyron",
      "CO2 (g/mi)": "934",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 AWD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300/SRT-8",
      "CO2 (g/mi)": "248.627809",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "ASPEN 4WD",
      "CO2 (g/mi)": "357.6718523",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "P T Cruiser",
      "CO2 (g/mi)": "374.374951",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "SEBRING",
      "CO2 (g/mi)": "436.90872",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "CALIBER",
      "CO2 (g/mi)": "336.583006",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "CARAVAN FWD",
      "CO2 (g/mi)": "435.30652",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "CHALLENGER",
      "CO2 (g/mi)": "528.2941273",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "CHARGER",
      "CO2 (g/mi)": "544.55898",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "CHARGER AWD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "DAKOTA PICKUP 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "DAKOTA PICKUP 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "222.371",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Nitro",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "NITRO 2WD",
      "CO2 (g/mi)": "448.80537",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "NITRO 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram 1500 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 4WD",
      "CO2 (g/mi)": "558.2",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "VIPER COUPE",
      "CO2 (g/mi)": "568.50009",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMMANDER 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMMANDER 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee",
      "CO2 (g/mi)": "307.918",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8 AWD",
      "CO2 (g/mi)": "690.55",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot",
      "CO2 (g/mi)": "301.31835",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "WRANGLER 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "WRANGLER 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Magnum",
      "Represented Test Veh Model": "Magnum",
      "CO2 (g/mi)": "259.874936",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "458 Italia Spyder",
      "CO2 (g/mi)": "614.09",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "599 GTB FIORANO",
      "CO2 (g/mi)": "686.7",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "612 Scaglietti",
      "CO2 (g/mi)": "753.99",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California",
      "CO2 (g/mi)": "576.733",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "CROWN VIC POL FFV",
      "CO2 (g/mi)": "496.2349854",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE FWD",
      "CO2 (g/mi)": "400.497",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "ESCAPE 4X2",
      "CO2 (g/mi)": "229.992",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape 4x2 FFV",
      "CO2 (g/mi)": "367.89",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape 4X4",
      "CO2 (g/mi)": "349.429",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "ESCAPE AWD",
      "CO2 (g/mi)": "395.813",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "ESCAPE HEV 4x2",
      "CO2 (g/mi)": "195.586",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "EXPEDITION 4X2 FFV",
      "CO2 (g/mi)": "520.554",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER 4WD",
      "CO2 (g/mi)": "549.812",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "EXPLORER 4X2",
      "CO2 (g/mi)": "515.7689819",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "EXPLORER 4X4",
      "CO2 (g/mi)": "541.817",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "F150 2WD FFV",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "F150 4WD FFV",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
      "CO2 (g/mi)": "322.399",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "F150 PICKUP 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "F150 PICKUP 4X2",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "F150 PICKUP 4X4",
      "CO2 (g/mi)": "508.342",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "447.462",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FLEX FWD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FUSION",
      "CO2 (g/mi)": "322.9870391",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MUSTANG",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MUSTANG V6",
      "CO2 (g/mi)": "394.458",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER 4X2",
      "CO2 (g/mi)": "360.553009",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER 4X4",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER PICKUP 2WD",
      "CO2 (g/mi)": "383.226",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER PICKUP 4WD",
      "CO2 (g/mi)": "519.7813159",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
      "CO2 (g/mi)": "418.769",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FWD",
      "CO2 (g/mi)": "236.723",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TRANSIT CONNECT",
      "CO2 (g/mi)": "253.86",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT AWD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT.",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "FUSION",
      "CO2 (g/mi)": "299.381",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "GRAND MARQUIS",
      "CO2 (g/mi)": "444.6759949",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "LINCOLN MKS",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "MILAN",
      "CO2 (g/mi)": "313.274",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "TOWN CAR",
      "CO2 (g/mi)": "286.167",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MERCURY",
      "Represented Test Veh Model": "MARINER HEV 4X4",
      "CO2 (g/mi)": "223.717",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1TD48",
      "CO2 (g/mi)": "294.057",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1TD69",
      "CO2 (g/mi)": "269.246",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4GB69",
      "CO2 (g/mi)": "212.5592956",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4GM69",
      "CO2 (g/mi)": "245.6248302",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4GT69",
      "CO2 (g/mi)": "412.583",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4HP69",
      "CO2 (g/mi)": "390.192",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ZR14526",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DC29",
      "CO2 (g/mi)": "480.229",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DM69",
      "CO2 (g/mi)": "231.041",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DN69",
      "CO2 (g/mi)": "626.564",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DP35",
      "CO2 (g/mi)": "399.586",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6K10706",
      "CO2 (g/mi)": "505.115",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6KD69",
      "CO2 (g/mi)": "467.289",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6KJ69",
      "CO2 (g/mi)": "391.543",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6NG26",
      "CO2 (g/mi)": "392.24",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6NL26",
      "CO2 (g/mi)": "451.408",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1AK37",
      "CO2 (g/mi)": "284.174",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1AS46",
      "CO2 (g/mi)": "293.394",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1AT46",
      "CO2 (g/mi)": "324.28",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1AU46",
      "CO2 (g/mi)": "221.8162",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1EF37",
      "CO2 (g/mi)": "379.669",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ES37",
      "CO2 (g/mi)": "447.074",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LH26",
      "CO2 (g/mi)": "316.042",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LK26",
      "CO2 (g/mi)": "348.28",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1WC19",
      "CO2 (g/mi)": "416.375",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1WT19",
      "CO2 (g/mi)": "368.8",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1YY07",
      "CO2 (g/mi)": "439.324",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1YY67",
      "CO2 (g/mi)": "483.791",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1YY87",
      "CO2 (g/mi)": "531.908",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ZF69",
      "CO2 (g/mi)": "266.239",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ZG69",
      "CO2 (g/mi)": "323.942",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "2ZG69",
      "CO2 (g/mi)": "313.587",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "6K10906",
      "CO2 (g/mi)": "596.586",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10703",
      "CO2 (g/mi)": "467.011",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10706",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10903",
      "CO2 (g/mi)": "551.472",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC15703",
      "CO2 (g/mi)": "511.255",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CG13406",
      "CO2 (g/mi)": "357.907",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CS15643",
      "CO2 (g/mi)": "426.795",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CS15653",
      "CO2 (g/mi)": "387.29",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CT15643",
      "CO2 (g/mi)": "489.064",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "339.866",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TC10543",
      "CO2 (g/mi)": "550.757",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TC10706",
      "CO2 (g/mi)": "333.093",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TS15653",
      "CO2 (g/mi)": "383.932",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "ZR14526",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "ZZS69",
      "CO2 (g/mi)": "322.67",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "ZZV69",
      "CO2 (g/mi)": "404.116",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "6K10906",
      "CO2 (g/mi)": "596.586",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CC10706",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CS15643",
      "CO2 (g/mi)": "456.314",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TC10543",
      "CO2 (g/mi)": "550.757",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HUMMER",
      "Represented Test Veh Model": "RN15306",
      "CO2 (g/mi)": "354.525",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "PONTIAC",
      "Represented Test Veh Model": "2MB67",
      "CO2 (g/mi)": "381.083",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "PONTIAC",
      "Represented Test Veh Model": "2MG69",
      "CO2 (g/mi)": "366.752",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "PONTIAC",
      "Represented Test Veh Model": "2ZM69",
      "CO2 (g/mi)": "435.398",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "7SF69",
      "CO2 (g/mi)": "394.042",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-5 SEDAN AWD",
      "CO2 (g/mi)": "417.538",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "FCB69",
      "CO2 (g/mi)": "374.992",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "FCH69+F46",
      "CO2 (g/mi)": "418.036",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "FCJ69",
      "CO2 (g/mi)": "333",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SATURN",
      "Represented Test Veh Model": "1LQ26",
      "CO2 (g/mi)": "426.389",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SATURN",
      "Represented Test Veh Model": "ZLF26",
      "CO2 (g/mi)": "371.39",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SATURN",
      "Represented Test Veh Model": "ZLG26",
      "CO2 (g/mi)": "451.308",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SATURN",
      "Represented Test Veh Model": "ZLR26",
      "CO2 (g/mi)": "448.865",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SATURN",
      "Represented Test Veh Model": "ZLT26",
      "CO2 (g/mi)": "279.861",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "448.9",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX BASE/TECH",
      "CO2 (g/mi)": "279.46",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RL",
      "CO2 (g/mi)": "442.88",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 2WD",
      "CO2 (g/mi)": "393.14",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 4WD",
      "CO2 (g/mi)": "420.75",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TSX V6",
      "CO2 (g/mi)": "382.46",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TSX/TSX Premium",
      "CO2 (g/mi)": "209.69",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ZDX 4WD",
      "CO2 (g/mi)": "431.3152958",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD CROSSTOUR 2WD EX-L",
      "CO2 (g/mi)": "391.11",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD CROSSTOUR 4WD EX-L",
      "CO2 (g/mi)": "418.5885981",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX-L COUPE",
      "CO2 (g/mi)": "373.31",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX/EX-L COUPE",
      "CO2 (g/mi)": "325.46",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX/EX-L SEDAN",
      "CO2 (g/mi)": "316.11",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX/LX+ SEDAN",
      "CO2 (g/mi)": "322.66",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC EX",
      "CO2 (g/mi)": "276.3597732",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC GX",
      "CO2 (g/mi)": "215.43",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HYBRID",
      "CO2 (g/mi)": "162.9530451",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC LX/DX",
      "CO2 (g/mi)": "170.01",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC SI",
      "CO2 (g/mi)": "218.4",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD LX/VP/EX/EXL",
      "CO2 (g/mi)": "331.15",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EX/EXL",
      "CO2 (g/mi)": "344.2",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD LX/VP/EX/EXL",
      "CO2 (g/mi)": "337.02",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ELEMENT 2WD",
      "CO2 (g/mi)": "257.91",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ELEMENT 4WD",
      "CO2 (g/mi)": "263.97",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FCX Clarity",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "243.01",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT SPORT",
      "CO2 (g/mi)": "252.04",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT",
      "CO2 (g/mi)": "163.46",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT TOP",
      "CO2 (g/mi)": "164.6967336",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY EX",
      "CO2 (g/mi)": "451.7042022",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY EXL",
      "CO2 (g/mi)": "418.14",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT EX",
      "CO2 (g/mi)": "422.07",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT LX/EX-L/TOURING",
      "CO2 (g/mi)": "278.6",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT LX/EX/EX-L/TOURING",
      "CO2 (g/mi)": "443.12",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE RT/RTS/LX/EX/RTL/EX-L",
      "CO2 (g/mi)": "475.61",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ACCENT",
      "CO2 (g/mi)": "258.37",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ACCENT BLUE",
      "CO2 (g/mi)": "268.8824794",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "AZERA",
      "CO2 (g/mi)": "249.6327396",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA",
      "CO2 (g/mi)": "265.43",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA BLUE",
      "CO2 (g/mi)": "273.63",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA TOURING",
      "CO2 (g/mi)": "303.1",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS",
      "CO2 (g/mi)": "427.81",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS COUPE",
      "CO2 (g/mi)": "340.68",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SANTA FE",
      "CO2 (g/mi)": "352.07",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA",
      "CO2 (g/mi)": "197.6326163",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "TUCSON",
      "CO2 (g/mi)": "308.17",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "VERACRUZ",
      "CO2 (g/mi)": "446.61",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "453.5",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XF V8 5.0",
      "CO2 (g/mi)": "443.46",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XF-R",
      "CO2 (g/mi)": "475.95",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "446.87",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Convertible",
      "CO2 (g/mi)": "454.5",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Coupe",
      "CO2 (g/mi)": "446.73",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK-R",
      "CO2 (g/mi)": "477.44",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "BORREGO",
      "CO2 (g/mi)": "432.39",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE",
      "CO2 (g/mi)": "259.41",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA",
      "CO2 (g/mi)": "321.46",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RIO",
      "CO2 (g/mi)": "256.32",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RONDO",
      "CO2 (g/mi)": "240.204697",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SEDONA",
      "CO2 (g/mi)": "429.16",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SOUL",
      "CO2 (g/mi)": "290.15",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SPORTAGE",
      "CO2 (g/mi)": "352.53",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "MURCIELAGO",
      "CO2 (g/mi)": "509",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR2",
      "CO2 (g/mi)": "293.8",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR3",
      "CO2 (g/mi)": "576.48",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "583.16",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "569.97",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport Supercharged",
      "CO2 (g/mi)": "612.43",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Supercharged",
      "CO2 (g/mi)": "621.48",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "Elise/Exige",
      "CO2 (g/mi)": "334.036",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "EVORA",
      "CO2 (g/mi)": "450.519",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO",
      "CO2 (g/mi)": "575.6",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "585.031",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO S AUTOMATIC",
      "CO2 (g/mi)": "592.539",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE",
      "CO2 (g/mi)": "618.639",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "609.864",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-7",
      "CO2 (g/mi)": "412",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA CX-9 4x2",
      "CO2 (g/mi)": "454.2479858",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA CX-9 4x4",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "329",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda5",
      "CO2 (g/mi)": "316",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "420.4970093",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazdaspeed3",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "RX-8",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mecedes-Benz",
      "Represented Test Veh Model": "C 350",
      "CO2 (g/mi)": "415.1501764",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mecedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "399.15",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "400.54",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350",
      "CO2 (g/mi)": "414.6",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 63 AMG",
      "CO2 (g/mi)": "616.21",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C300",
      "CO2 (g/mi)": "382.12",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 550 4MATIC",
      "CO2 (g/mi)": "510.12",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 600",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 63 AMG",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 65 AMG",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "509.6",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG",
      "CO2 (g/mi)": "610.44",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "243.14",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "432.2",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 Coupe",
      "CO2 (g/mi)": "401.38",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (coupe)",
      "CO2 (g/mi)": "468.85",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 4MATIC",
      "CO2 (g/mi)": "464.53",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG",
      "CO2 (g/mi)": "564.18",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 55 AMG",
      "CO2 (g/mi)": "669.9",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "632.88",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC",
      "CO2 (g/mi)": "480.53",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "557.01",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "579.22",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350",
      "CO2 (g/mi)": "437.38",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350 4MATIC",
      "CO2 (g/mi)": "455.54",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 57 Zeppelin",
      "CO2 (g/mi)": "408.17",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 57S",
      "CO2 (g/mi)": "719.92",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 62",
      "CO2 (g/mi)": "717.95",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "453.34",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 BLUETEC",
      "CO2 (g/mi)": "437.93",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 550 4MATIC",
      "CO2 (g/mi)": "546.57",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "695.91",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML450 HYBRID 4MATIC",
      "CO2 (g/mi)": "329",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 4MATIC",
      "CO2 (g/mi)": "341.54",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 BLUETEC",
      "CO2 (g/mi)": "452.32",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 400 HYBRID",
      "CO2 (g/mi)": "248.8401166",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "470.92",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "505.53",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "646.51",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG",
      "CO2 (g/mi)": "638.84",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG",
      "CO2 (g/mi)": "655.32",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "539.34",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 300",
      "CO2 (g/mi)": "379.87",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "426.97",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 55 AMG",
      "CO2 (g/mi)": "503.27",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart ForTwo (coupe)",
      "CO2 (g/mi)": "201.26",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
      "CO2 (g/mi)": "317.26355",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER EVOLUTION",
      "CO2 (g/mi)": "431.72992",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER SPORTBACK",
      "CO2 (g/mi)": "406.34686",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "328.91966",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "343.92675",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE",
      "CO2 (g/mi)": "349.70065",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE SPYDER",
      "CO2 (g/mi)": "433.96802",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ENDEAVOR 2WD",
      "CO2 (g/mi)": "453.55163",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ENDEAVOR AWD",
      "CO2 (g/mi)": "472.6996",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "GALANT",
      "CO2 (g/mi)": "332.14356",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX35 AWD JOURNEY",
      "CO2 (g/mi)": "441",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX35 RWD JOURNEY",
      "CO2 (g/mi)": "432",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX35 AWD",
      "CO2 (g/mi)": "460",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX35 RWD",
      "CO2 (g/mi)": "437",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX50 AWD",
      "CO2 (g/mi)": "338",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Journey",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Sport 6MT",
      "CO2 (g/mi)": "270",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Journey",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Sport 6MT",
      "CO2 (g/mi)": "434.7349456",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37X COUPE AWD",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M35",
      "CO2 (g/mi)": "427",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M35x AWD",
      "CO2 (g/mi)": "451",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M45x AWD",
      "CO2 (g/mi)": "514",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "M45",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA SE 5.6L 4x4",
      "CO2 (g/mi)": "584",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING CAB XE",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING CAB XE 4X2",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING PRO4X4",
      "CO2 (g/mi)": "497",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "INFINITI QX56 4x4",
      "CO2 (g/mi)": "590",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z ROADSTER Touring",
      "CO2 (g/mi)": "397",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5 S",
      "CO2 (g/mi)": "297",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5S",
      "CO2 (g/mi)": "301",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 3.5 SR",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA COUPE 2.5 S",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA HYBRID 4-DOOR SEDAN",
      "CO2 (g/mi)": "187",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Nissan Armada SE 5.6l 4x4",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 S",
      "CO2 (g/mi)": "214",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 SL",
      "CO2 (g/mi)": "260.0463617",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB PRO-4X",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB PRO-4X 4X4",
      "CO2 (g/mi)": "466",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE",
      "CO2 (g/mi)": "450",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE 4X2",
      "CO2 (g/mi)": "474",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE 4X4",
      "CO2 (g/mi)": "461",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 3.5SV",
      "CO2 (g/mi)": "375",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 4-DOOR SEDAN 3.5S",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD LE",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO FWD SL",
      "CO2 (g/mi)": "404",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER LE 4X4",
      "CO2 (g/mi)": "512",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER SE 4X2",
      "CO2 (g/mi)": "486",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER SE 4X4",
      "CO2 (g/mi)": "325",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0",
      "CO2 (g/mi)": "207",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0SL",
      "CO2 (g/mi)": "257",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SE-R",
      "CO2 (g/mi)": "295",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.6 Sedan",
      "CO2 (g/mi)": "191",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.8S",
      "CO2 (g/mi)": "288",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.8SL",
      "CO2 (g/mi)": "248",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER SE 4X4",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD SL",
      "CO2 (g/mi)": "329",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA SE-R  Spec V",
      "CO2 (g/mi)": "333",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE LWB",
      "CO2 (g/mi)": "607",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE SWB",
      "CO2 (g/mi)": "596",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE-SWB",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "PONTIAC",
      "Represented Test Veh Model": "VIBE",
      "CO2 (g/mi)": "345.9220369",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 3.6L",
      "CO2 (g/mi)": "377.42156",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S 3.8L",
      "CO2 (g/mi)": "374.54376",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "523.31615",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3 RS",
      "CO2 (g/mi)": "527.8473",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo",
      "CO2 (g/mi)": "442.64438",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S",
      "CO2 (g/mi)": "260.00128",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "497.9767",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "347.576",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "336.5331",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "611",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman",
      "CO2 (g/mi)": "347.3957",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman S",
      "CO2 (g/mi)": "358.5128",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "437.9727",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "478.3673",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "564.76",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "618.13",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "474.9",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Spyker",
      "Represented Test Veh Model": "C8",
      "CO2 (g/mi)": "517.7",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER AWD",
      "CO2 (g/mi)": "355.9677",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA AWD",
      "CO2 (g/mi)": "370.1757",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WGN/OUTBACK SPT AWD",
      "CO2 (g/mi)": "356.4178",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN 4WD",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN AWD",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "326",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "TRIBECA AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA",
      "CO2 (g/mi)": "401.2166",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA 4WD",
      "CO2 (g/mi)": "460.131",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI AWD",
      "CO2 (g/mi)": "314.8266",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI FWD",
      "CO2 (g/mi)": "301.6482",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 2WD",
      "CO2 (g/mi)": "296.8269",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 4WD",
      "CO2 (g/mi)": "218.8333",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "366.3549782",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "242.267912",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "251.7888799",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "248.3311144",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 460",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "469.5413422",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "HS 250h",
      "CO2 (g/mi)": "189.2263987",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250",
      "CO2 (g/mi)": "332.084014",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250 AWD",
      "CO2 (g/mi)": "362.0641955",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250/IS 250C",
      "CO2 (g/mi)": "347.337651",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS F",
      "CO2 (g/mi)": "276.6657778",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.3656149",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "256.1145167",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "293.8015854",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "571.3069442",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "386.0582324",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "398.1514626",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "215.3292345",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "217.1822011",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "SC 430",
      "CO2 (g/mi)": "430.9403978",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "407.5022803",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "421.6376489",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "359.8382148",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID",
      "CO2 (g/mi)": "194.9142506",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "211.154089",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA MATRIX",
      "CO2 (g/mi)": "345.9091036",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 2WD",
      "CO2 (g/mi)": "292.952708",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 4WD",
      "CO2 (g/mi)": "303.8880426",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 2WD",
      "CO2 (g/mi)": "399.4831975",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 4WD",
      "CO2 (g/mi)": "412.0325346",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID 4WD",
      "CO2 (g/mi)": "248.2408102",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "130.8100637",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 2WD",
      "CO2 (g/mi)": "365.067935",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 4WD",
      "CO2 (g/mi)": "372.314168",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION tC",
      "CO2 (g/mi)": "342.0658973",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xB",
      "CO2 (g/mi)": "318.8867968",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xD",
      "CO2 (g/mi)": "250.892098",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "523.547681",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "554.9918017",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA 2WD",
      "CO2 (g/mi)": "394.8914261",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA 4WD",
      "CO2 (g/mi)": "443.7290137",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TACOMA 2WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TACOMA 4WD",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TUNDRA 2WD",
      "CO2 (g/mi)": "339.9346533",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TUNDRA 4WD",
      "CO2 (g/mi)": "523.7861032",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA",
      "CO2 (g/mi)": "334.773498",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "342.3781331",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "184.8605225",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "323",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "310",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "350",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Jetta / Sportwagen",
      "CO2 (g/mi)": "357",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Jettta",
      "CO2 (g/mi)": "261",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "310",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "542.0295171",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C30 T5 FWD",
      "CO2 (g/mi)": "308",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C70 T5 FWD",
      "CO2 (g/mi)": "326",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S40 2.4i  FWD",
      "CO2 (g/mi)": "345",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S40 2.4i FWD",
      "CO2 (g/mi)": "354",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S40 T5 AWD",
      "CO2 (g/mi)": "232",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD",
      "CO2 (g/mi)": "409",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 T6 AWD",
      "CO2 (g/mi)": "444",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 V8 AWD",
      "CO2 (g/mi)": "469",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V50 T5 AWD",
      "CO2 (g/mi)": "374",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD",
      "CO2 (g/mi)": "461",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 AWD",
      "CO2 (g/mi)": "451.3",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "501",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 AWD",
      "CO2 (g/mi)": "464",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 AWD",
      "CO2 (g/mi)": "469",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 FWD",
      "CO2 (g/mi)": "439",
    },
    {
      "Model Year": "2010",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 V8 AWD",
      "CO2 (g/mi)": "542",
    },
  ],
  2011: [
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "649.27",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBS",
      "CO2 (g/mi)": "612.598",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide",
      "CO2 (g/mi)": "564.225",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE",
      "CO2 (g/mi)": "551.4037",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE S",
      "CO2 (g/mi)": "529.36",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 QUATTRO",
      "CO2 (g/mi)": "239",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "327",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 QUATTRO",
      "CO2 (g/mi)": "390",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "351",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 QUATTRO",
      "CO2 (g/mi)": "274",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "460",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "PASSAT WAGON",
      "CO2 (g/mi)": "342",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Audi",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "287",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "468",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "605",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4",
      "CO2 (g/mi)": "373",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "435",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S6",
      "CO2 (g/mi)": "516",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT Coupe",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT COUPE QUATTRO",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "TIGUAN",
      "CO2 (g/mi)": "430",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental Supersports",
      "CO2 (g/mi)": "693",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Mulsanne",
      "CO2 (g/mi)": "697",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "1 Series Active E",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i",
      "CO2 (g/mi)": "355.17",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i Convertible",
      "CO2 (g/mi)": "230.3951358",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i",
      "CO2 (g/mi)": "222.83",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i Convertible",
      "CO2 (g/mi)": "375.08",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci",
      "CO2 (g/mi)": "230.94",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci Convertible",
      "CO2 (g/mi)": "439.3",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328CiA Convertible",
      "CO2 (g/mi)": "241.98",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "409.13",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xi",
      "CO2 (g/mi)": "441.29",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xiA",
      "CO2 (g/mi)": "245.65",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci",
      "CO2 (g/mi)": "351.51",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci Convertible",
      "CO2 (g/mi)": "225.95",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci xDrive",
      "CO2 (g/mi)": "236.01",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335CiA",
      "CO2 (g/mi)": "363.43",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335d",
      "CO2 (g/mi)": "349.8435909",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i",
      "CO2 (g/mi)": "369.38",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive",
      "CO2 (g/mi)": "384.93",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335is Convertible",
      "CO2 (g/mi)": "398.12",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335is Coupe",
      "CO2 (g/mi)": "389.37",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "318.11",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "206.37",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "371.6",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive",
      "CO2 (g/mi)": "353.28",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "230.1",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535iA",
      "CO2 (g/mi)": "343.28",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "250.16",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i GT",
      "CO2 (g/mi)": "482.77",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive",
      "CO2 (g/mi)": "454.82",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "484.94",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive GranTurismo",
      "CO2 (g/mi)": "466.94",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li",
      "CO2 (g/mi)": "254.84",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750 Li xDrive",
      "CO2 (g/mi)": "518.59",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "304.5860911",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "760Li",
      "CO2 (g/mi)": "341.2947673",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7",
      "CO2 (g/mi)": "408.61",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7 L",
      "CO2 (g/mi)": "266.3503316",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid X6",
      "CO2 (g/mi)": "329.2391497",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB",
      "CO2 (g/mi)": "490.23",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB xDrive",
      "CO2 (g/mi)": "530.89",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "308.29",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3 Convertible",
      "CO2 (g/mi)": "497.13",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "368.03",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "250.2012308",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "453.8707307",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "274.576399",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "521.68",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDriveM",
      "CO2 (g/mi)": "600.3461826",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "262.19",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "499.95",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDriveM",
      "CO2 (g/mi)": "553.27",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive30i",
      "CO2 (g/mi)": "351.83",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35i",
      "CO2 (g/mi)": "378.69",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35is",
      "CO2 (g/mi)": "235.78",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Clubman",
      "CO2 (g/mi)": "248.85",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper",
      "CO2 (g/mi)": "242.77",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "256.62",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "194.0098079",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "210.72",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper JCW",
      "CO2 (g/mi)": "275.06",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper JCW Clubman",
      "CO2 (g/mi)": "282.92",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S",
      "CO2 (g/mi)": "268.9",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "268.96",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "276.81",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "275.89",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman All4",
      "CO2 (g/mi)": "206.8516239",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini John Cooper Works Convertible",
      "CO2 (g/mi)": "278.66",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Veyron Super Sport",
      "CO2 (g/mi)": "885",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "239.073",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.51335",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300/SRT-8",
      "CO2 (g/mi)": "458.23846",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "ASPEN 4WD",
      "CO2 (g/mi)": "357.6718523",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.56653",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Caliber",
      "CO2 (g/mi)": "289.48641",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.55036",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "396.90016",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Dakota",
      "CO2 (g/mi)": "578.113087",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "DAKOTA PICKUP",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "DAKOTA PICKUP 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "DAKOTA PICKUP 4WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango 4WD",
      "CO2 (g/mi)": "563.49762",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "403.2933",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Nitro",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "NITRO 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM  PICKUP",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram 1500 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 4WD",
      "CO2 (g/mi)": "558.2",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM PICKUP",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 2wd",
      "CO2 (g/mi)": "449.8292935",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4wd",
      "CO2 (g/mi)": "440.33145",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.88845",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4wd",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "458 Italia Spyder",
      "CO2 (g/mi)": "614.09",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "599 GTB FIORANO",
      "CO2 (g/mi)": "686.7",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "599 GTO",
      "CO2 (g/mi)": "680.487",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "599 SA Aperta",
      "CO2 (g/mi)": "680.86",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "612 Scaglietti",
      "CO2 (g/mi)": "753.99",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California",
      "CO2 (g/mi)": "547.829",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "CROWN VIC POL FFV",
      "CO2 (g/mi)": "496.2349854",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "CROWN VIC POLICE FFV",
      "CO2 (g/mi)": "487.748",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "E-150 Van",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "E-350 Extended Wagon",
      "CO2 (g/mi)": "602.684",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E150 VAN",
      "CO2 (g/mi)": "572.692",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E350 EXTENDED WAGON",
      "CO2 (g/mi)": "499.617",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E350 VAN",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE AWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE FWD",
      "CO2 (g/mi)": "379.595",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "ESCAPE 4X2",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape 4x2 FFV",
      "CO2 (g/mi)": "367.89",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape 4X4",
      "CO2 (g/mi)": "349.429",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "ESCAPE AWD",
      "CO2 (g/mi)": "395.813",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "ESCAPE HEV 4x2",
      "CO2 (g/mi)": "195.586",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER 4WD",
      "CO2 (g/mi)": "425.872",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER FWD",
      "CO2 (g/mi)": "263.6996002",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X2",
      "CO2 (g/mi)": "582.951",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X2",
      "CO2 (g/mi)": "404.729",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4 Supercab",
      "CO2 (g/mi)": "320.858",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Harley Pickup AWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup 2WD",
      "CO2 (g/mi)": "563.089",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup 4WD, Max Trailer Tow",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 2WD",
      "CO2 (g/mi)": "446.479",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 4WD",
      "CO2 (g/mi)": "441.819",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 RAPTOR",
      "CO2 (g/mi)": "645.1580987",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Raptor Pickup 4WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Crew 2WD, Max Trailer Tow",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Crew 4WD, Max Trailer Tow",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Crew Max Tow 4X4",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4",
      "CO2 (g/mi)": "486.527",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 SUPER CAB",
      "CO2 (g/mi)": "374.942",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "231.92",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "455.698",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FLEX FWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FUSION",
      "CO2 (g/mi)": "305.776",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "381.398",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MUSTANG",
      "CO2 (g/mi)": "374.62",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger 2WD",
      "CO2 (g/mi)": "387.832",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER 4X2",
      "CO2 (g/mi)": "360.553009",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER 4X4",
      "CO2 (g/mi)": "482.103",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER 4X4 RKS",
      "CO2 (g/mi)": "485.164",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger Pickup 2WD",
      "CO2 (g/mi)": "482.655",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER PICKUP 4WD",
      "CO2 (g/mi)": "519.7813159",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "RANGER SUPERCAB 4DR 4X2",
      "CO2 (g/mi)": "442.986",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TRANSIT CONNECT",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "EXPEDITION 4X2",
      "CO2 (g/mi)": "518.335",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "EXPEDITION 4X4",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT AWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4",
      "CO2 (g/mi)": "379.327",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT",
      "CO2 (g/mi)": "626.8959961",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT.",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "Fusion",
      "CO2 (g/mi)": "433.007",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "GRAND MARQUIS",
      "CO2 (g/mi)": "444.6759949",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "LINCOLN MKS",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Lincoln-Mercury",
      "Represented Test Veh Model": "MILAN",
      "CO2 (g/mi)": "408.504",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "508.281",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "TOWN CAR",
      "CO2 (g/mi)": "286.167",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MERCURY",
      "Represented Test Veh Model": "MARINER HEV 4X4",
      "CO2 (g/mi)": "223.717",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "AVEO",
      "CO2 (g/mi)": "278.108",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4GB69",
      "CO2 (g/mi)": "369.7355363",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCLAVE AWD",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "369.7355363",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "412.583",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LUCERNE",
      "CO2 (g/mi)": "390.192",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "404.338",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DN69",
      "CO2 (g/mi)": "641.44",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6KJ69",
      "CO2 (g/mi)": "633.855",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6NL26",
      "CO2 (g/mi)": "451.408",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS",
      "CO2 (g/mi)": "231.041",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS AWD",
      "CO2 (g/mi)": "231.041",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS WAGON",
      "CO2 (g/mi)": "399.586",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "DTS",
      "CO2 (g/mi)": "467.289",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "325.94",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD HYBRID",
      "CO2 (g/mi)": "350.466",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE AWD",
      "CO2 (g/mi)": "325.94",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "FUNERAL COACH/HEARSE",
      "CO2 (g/mi)": "391.543",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "LIMOUSINE",
      "CO2 (g/mi)": "588.0708",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX 2WD",
      "CO2 (g/mi)": "392.24",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX AWD",
      "CO2 (g/mi)": "467.1485",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ZK69",
      "CO2 (g/mi)": "444.527",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "486.34",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD XFE",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD",
      "CO2 (g/mi)": "280.961",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD HYBRID",
      "CO2 (g/mi)": "395.916",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C2500 SUBURBAN 2WD",
      "CO2 (g/mi)": "695.174",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "379.669",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "491.027",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10903",
      "CO2 (g/mi)": "551.472",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CG33406",
      "CO2 (g/mi)": "689.864",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "383.932",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "383.932",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CAB CHASSIS INC 2WD",
      "CO2 (g/mi)": "456.314",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CREW CAB 2WD",
      "CO2 (g/mi)": "426.795",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CREW CAB 4WD",
      "CO2 (g/mi)": "456.314",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "439.324",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "289.6938374",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE ECO",
      "CO2 (g/mi)": "147.787216",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "348.28",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "316.042",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD CARGO",
      "CO2 (g/mi)": "555.153",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD PASS",
      "CO2 (g/mi)": "357.907",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "645.137",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "667.168",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "H1500 EXPRESS AWD CARGO",
      "CO2 (g/mi)": "357.907",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "H1500 EXPRESS AWD PASS",
      "CO2 (g/mi)": "388.161",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "HHR FWD",
      "CO2 (g/mi)": "324.28",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "HHR PANEL FWD",
      "CO2 (g/mi)": "332.359",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "368.8",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "511.255",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "467.011",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD HYBRID",
      "CO2 (g/mi)": "395.916",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "322.67",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE AWD",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE FWD",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "C15 SIERRA 2WD XFE",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K15 SIERRA 4WD",
      "CO2 (g/mi)": "280.961",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL AWD",
      "CO2 (g/mi)": "564.367",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K2500 YUKON XL 4WD",
      "CO2 (g/mi)": "702.279",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "FCH69+F46",
      "CO2 (g/mi)": "418.036",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "448.9",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX BASE/TECH",
      "CO2 (g/mi)": "279.46",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 2WD",
      "CO2 (g/mi)": "393.14",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 4WD",
      "CO2 (g/mi)": "420.75",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TSX",
      "CO2 (g/mi)": "322.49",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ZDX 4WD",
      "CO2 (g/mi)": "431.3152958",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD CROSSTOUR 2WD EX-L",
      "CO2 (g/mi)": "391.11",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD CROSSTOUR 4WD EX-L",
      "CO2 (g/mi)": "401.58",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX-L COUPE",
      "CO2 (g/mi)": "360.79",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX/EX-L COUPE",
      "CO2 (g/mi)": "308.44",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX/EX-L SEDAN",
      "CO2 (g/mi)": "304.53",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX COUPE",
      "CO2 (g/mi)": "306.14",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX/EX/EX-L COUPE",
      "CO2 (g/mi)": "311.41",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX/LX+/SE SEDAN",
      "CO2 (g/mi)": "299.85",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC EX",
      "CO2 (g/mi)": "276.3597732",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC GX",
      "CO2 (g/mi)": "215.43",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HYBRID",
      "CO2 (g/mi)": "210.24",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC LX/DX",
      "CO2 (g/mi)": "170.01",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC SI",
      "CO2 (g/mi)": "218.4",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD LX/VP/EX/EXL",
      "CO2 (g/mi)": "331.15",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EX/EXL",
      "CO2 (g/mi)": "344.2",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD LX/VP/EX/EXL",
      "CO2 (g/mi)": "337.02",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-Z EX",
      "CO2 (g/mi)": "193.2648345",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ELEMENT 2WD",
      "CO2 (g/mi)": "257.91",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ELEMENT 4WD",
      "CO2 (g/mi)": "263.97",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FCX Clarity",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "238.2",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT SPORT",
      "CO2 (g/mi)": "247.68",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT DX/LX",
      "CO2 (g/mi)": "163.14",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT EX",
      "CO2 (g/mi)": "164.49",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY LX/EX/EXL",
      "CO2 (g/mi)": "401.29",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.69",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT EX",
      "CO2 (g/mi)": "422.07",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT LX/EX-L/TOURING",
      "CO2 (g/mi)": "278.6",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT LX/EX/EX-L/TOURING",
      "CO2 (g/mi)": "443.12",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE RT/RTS/LX/EX/RTL/EX-L",
      "CO2 (g/mi)": "475.61",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RL",
      "CO2 (g/mi)": "415.23",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ACCENT",
      "CO2 (g/mi)": "258.07",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ACCENT BLUE",
      "CO2 (g/mi)": "268.8824794",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "AZERA",
      "CO2 (g/mi)": "362.03",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA",
      "CO2 (g/mi)": "233.33",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA TOURING",
      "CO2 (g/mi)": "303.86",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "EQUUS",
      "CO2 (g/mi)": "455.4184356",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS",
      "CO2 (g/mi)": "427.34",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS COUPE",
      "CO2 (g/mi)": "429.15",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis Prestige",
      "CO2 (g/mi)": "463.2601",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SANTA FE",
      "CO2 (g/mi)": "360.56",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA",
      "CO2 (g/mi)": "295.9736",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "207.85",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "TUCSON",
      "CO2 (g/mi)": "346.31",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "VERACRUZ",
      "CO2 (g/mi)": "457.1",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XF V8 5.0",
      "CO2 (g/mi)": "443.46",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XF-R",
      "CO2 (g/mi)": "475.95",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "446.87",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Convertible",
      "CO2 (g/mi)": "454.5",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Coupe",
      "CO2 (g/mi)": "446.73",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK-R",
      "CO2 (g/mi)": "477.44",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "BORREGO",
      "CO2 (g/mi)": "301.51",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE",
      "CO2 (g/mi)": "277.14",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE ECO",
      "CO2 (g/mi)": "178.802051",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE KOUP",
      "CO2 (g/mi)": "272.82",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA",
      "CO2 (g/mi)": "190.1937076",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RIO",
      "CO2 (g/mi)": "256.32",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RONDO",
      "CO2 (g/mi)": "359.31",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SEDONA",
      "CO2 (g/mi)": "391.634",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SORENTO",
      "CO2 (g/mi)": "361.55",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SOUL",
      "CO2 (g/mi)": "206.55",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "321.1",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR2",
      "CO2 (g/mi)": "293.8",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR3",
      "CO2 (g/mi)": "576.48",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "583.16",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "569.97",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport Supercharged",
      "CO2 (g/mi)": "612.43",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Supercharged",
      "CO2 (g/mi)": "621.48",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "Elise/Exige",
      "CO2 (g/mi)": "334.036",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "EVORA",
      "CO2 (g/mi)": "412.077258",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mahindra",
      "Represented Test Veh Model": "TR40",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO",
      "CO2 (g/mi)": "551.154",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "590.92",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO S AUTOMATIC",
      "CO2 (g/mi)": "565.285",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE",
      "CO2 (g/mi)": "594.027",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "607.608",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "6",
      "CO2 (g/mi)": "257.291",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-7",
      "CO2 (g/mi)": "412",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 AWD",
      "CO2 (g/mi)": "436.446",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 FWD",
      "CO2 (g/mi)": "406.68",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "179.51",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "344",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "331.19",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazdaspeed3",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "RX-8",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "399.15",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "400.54",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350",
      "CO2 (g/mi)": "416.13",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 63 AMG",
      "CO2 (g/mi)": "570.19",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C300",
      "CO2 (g/mi)": "382.12",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 550 4MATIC",
      "CO2 (g/mi)": "464.67",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 600",
      "CO2 (g/mi)": "602.12",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 63 AMG",
      "CO2 (g/mi)": "483.9",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 65 AMG",
      "CO2 (g/mi)": "597.45",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "509.6",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG",
      "CO2 (g/mi)": "610.44",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "435.33",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (Convertible)",
      "CO2 (g/mi)": "417.85",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "432.2",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 BLUETEC",
      "CO2 (g/mi)": "367.01",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 Coupe",
      "CO2 (g/mi)": "401.38",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550",
      "CO2 (g/mi)": "475.74",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (convertible)",
      "CO2 (g/mi)": "484.124",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (coupe)",
      "CO2 (g/mi)": "468.85",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 4MATIC",
      "CO2 (g/mi)": "480.92",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG",
      "CO2 (g/mi)": "564.18",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "F-Cell",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 55 AMG",
      "CO2 (g/mi)": "669.9",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "632.88",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "511.19",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "566.12",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "579.22",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350",
      "CO2 (g/mi)": "444.05",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350 4MATIC",
      "CO2 (g/mi)": "455.86",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 57 Zeppelin",
      "CO2 (g/mi)": "408.17",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 62",
      "CO2 (g/mi)": "717.95",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "457.55",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "474.64",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 BLUETEC",
      "CO2 (g/mi)": "437.93",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 550 4MATIC",
      "CO2 (g/mi)": "350.26",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "695.91",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML450 HYBRID 4MATIC",
      "CO2 (g/mi)": "440.51",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 4MATIC",
      "CO2 (g/mi)": "482.66",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 BLUETEC",
      "CO2 (g/mi)": "452.32",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 400 HYBRID",
      "CO2 (g/mi)": "248.8401166",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "470.92",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "505.53",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "605.76",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG",
      "CO2 (g/mi)": "473.97",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG",
      "CO2 (g/mi)": "599.95",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "310.36",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "610.03",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 65 AMG",
      "CO2 (g/mi)": "623.17",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 300",
      "CO2 (g/mi)": "379.87",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "401.02",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLS AMG",
      "CO2 (g/mi)": "529.55",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart ForTwo (convertible)",
      "CO2 (g/mi)": "201.26",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo electric drive",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
      "CO2 (g/mi)": "282.8353",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER EVOLUTION",
      "CO2 (g/mi)": "422.12296",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER SPORTBACK",
      "CO2 (g/mi)": "289.13856",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "306.39028",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "320.3937",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "291.69085",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "290.68708",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE",
      "CO2 (g/mi)": "225.74037",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE SPYDER",
      "CO2 (g/mi)": "430.02114",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ENDEAVOR 2WD",
      "CO2 (g/mi)": "453.55163",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ENDEAVOR AWD",
      "CO2 (g/mi)": "472.6996",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "GALANT",
      "CO2 (g/mi)": "332.14356",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX35 AWD Journey",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX35 AWD",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX35 RWD",
      "CO2 (g/mi)": "435",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX50 AWD",
      "CO2 (g/mi)": "514",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G25 Journey",
      "CO2 (g/mi)": "350",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G25x",
      "CO2 (g/mi)": "362",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Journey",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Sport 6MT",
      "CO2 (g/mi)": "437",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Journey",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Sport 6MT",
      "CO2 (g/mi)": "410",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37X COUPE AWD",
      "CO2 (g/mi)": "410",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M37 Base",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M37X Base",
      "CO2 (g/mi)": "407",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56X Base",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 2WD",
      "CO2 (g/mi)": "531",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 4WD",
      "CO2 (g/mi)": "535",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA SE 5.6L 4X4",
      "CO2 (g/mi)": "577",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING CAB XE",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING CAB XE 4X2",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING PRO4X4",
      "CO2 (g/mi)": "497",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z ROADSTER Touring",
      "CO2 (g/mi)": "397",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5 S",
      "CO2 (g/mi)": "297",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5S",
      "CO2 (g/mi)": "301",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 3.5 SR",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA COUPE 2.5 S",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA HYBRID",
      "CO2 (g/mi)": "264",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA HYBRID 4-DOOR SEDAN",
      "CO2 (g/mi)": "294",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Nissan Armada SE 5.6l 4x4",
      "CO2 (g/mi)": "580",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 S",
      "CO2 (g/mi)": "201",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 SL",
      "CO2 (g/mi)": "260.079961",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD XE",
      "CO2 (g/mi)": "420",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB PRO-4X 4X4",
      "CO2 (g/mi)": "466",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE",
      "CO2 (g/mi)": "450",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE 4X2",
      "CO2 (g/mi)": "474",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE 4X4",
      "CO2 (g/mi)": "461",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "286",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF UPR",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 3.5SV",
      "CO2 (g/mi)": "375",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 4-DOOR SEDAN 3.5S",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD LE",
      "CO2 (g/mi)": "402",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD SL",
      "CO2 (g/mi)": "391",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO CrossCabriolet Base",
      "CO2 (g/mi)": "424",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 4WD LE",
      "CO2 (g/mi)": "509",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER SE 4X2",
      "CO2 (g/mi)": "486",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER SE 4X4",
      "CO2 (g/mi)": "325",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "381",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD S",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SV",
      "CO2 (g/mi)": "252",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE FWD S",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE FWD SV",
      "CO2 (g/mi)": "312.6594257",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0",
      "CO2 (g/mi)": "289",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0SL",
      "CO2 (g/mi)": "257",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0SR",
      "CO2 (g/mi)": "259",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SE-R",
      "CO2 (g/mi)": "295",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.6 4AT",
      "CO2 (g/mi)": "271.4911793",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.6 Sedan",
      "CO2 (g/mi)": "188",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.8S",
      "CO2 (g/mi)": "288",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.8SL",
      "CO2 (g/mi)": "185",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN XTERRA 2WD S",
      "CO2 (g/mi)": "445",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER SE 4X4",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA SE-R  Spec V",
      "CO2 (g/mi)": "333",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SUZUKI EQUATOR 2WD",
      "CO2 (g/mi)": "425",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD Crew Cab LE SWB",
      "CO2 (g/mi)": "609",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE LWB",
      "CO2 (g/mi)": "607",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE SWB",
      "CO2 (g/mi)": "596",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 3.6L",
      "CO2 (g/mi)": "377.42156",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S 3.8L",
      "CO2 (g/mi)": "374.54376",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT2RS",
      "CO2 (g/mi)": "442.113",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "523.31615",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3 RS",
      "CO2 (g/mi)": "527.8473",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3RS 4.0",
      "CO2 (g/mi)": "542.81",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo",
      "CO2 (g/mi)": "442.64438",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S",
      "CO2 (g/mi)": "260.00128",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster Spyder",
      "CO2 (g/mi)": "351.3",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "440.8926738",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "456.4596",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "486.11613",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman",
      "CO2 (g/mi)": "347.3957",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman S",
      "CO2 (g/mi)": "366.09",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "400.01134",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "437.9727",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "478.3673",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "324.89",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "618.13",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "E350 Cutaway",
      "CO2 (g/mi)": "620.8707361",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "665.8",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-3 CONVERTIBLE",
      "CO2 (g/mi)": "374.992",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-3 SEDAN AWD",
      "CO2 (g/mi)": "422.049",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-3 SPORT SEDAN",
      "CO2 (g/mi)": "394.042",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-3 SPORTCOMBI",
      "CO2 (g/mi)": "374.992",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-5 SEDAN",
      "CO2 (g/mi)": "404.338",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-5 SEDAN AWD",
      "CO2 (g/mi)": "417.538",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Spyker",
      "Represented Test Veh Model": "C8",
      "CO2 (g/mi)": "517.7",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER AWD",
      "CO2 (g/mi)": "373.0975",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA AWD",
      "CO2 (g/mi)": "432.5364561",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WGN/OUTBACK SPT AWD",
      "CO2 (g/mi)": "356.4178",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN 4WD",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN AWD",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "326",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "TRIBECA AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA",
      "CO2 (g/mi)": "365.6643",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA 4WD",
      "CO2 (g/mi)": "424.3441",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI AWD",
      "CO2 (g/mi)": "314.8266",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI FWD",
      "CO2 (g/mi)": "301.6482",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 2WD",
      "CO2 (g/mi)": "296.8269",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 4WD",
      "CO2 (g/mi)": "312.7982",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "CT 200h",
      "CO2 (g/mi)": "153.69495",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "366.3549782",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "242.267912",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "251.7888799",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "248.3311144",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 460",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "469.5413422",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "HS 250h",
      "CO2 (g/mi)": "189.2263987",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250 AWD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250/IS 250C",
      "CO2 (g/mi)": "334.2514956",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350/IS 350C",
      "CO2 (g/mi)": "356.1255349",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS F",
      "CO2 (g/mi)": "276.6657778",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.3656149",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "256.1145167",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "397.9446499",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "571.3069442",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "386.0582324",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "390.3777118",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "215.3292345",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "217.1822011",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iQ",
      "CO2 (g/mi)": "253.348812",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "tC",
      "CO2 (g/mi)": "299.1152855",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "407.5022803",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "421.6376489",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID",
      "CO2 (g/mi)": "194.9142506",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "211.154089",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA MATRIX",
      "CO2 (g/mi)": "345.9091036",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 2WD",
      "CO2 (g/mi)": "292.952708",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 4WD",
      "CO2 (g/mi)": "303.8880426",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 2WD",
      "CO2 (g/mi)": "415.8852753",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 4WD",
      "CO2 (g/mi)": "281.2777708",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID 4WD",
      "CO2 (g/mi)": "233.1757027",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "130.8100637",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 2WD",
      "CO2 (g/mi)": "365.067935",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 4WD",
      "CO2 (g/mi)": "372.314168",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xB",
      "CO2 (g/mi)": "318.8867968",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xD",
      "CO2 (g/mi)": "250.892098",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "523.547681",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "554.9918017",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "399.0053779",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "291.8004291",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "289.5728875",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TACOMA 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TACOMA 4WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TUNDRA 2WD",
      "CO2 (g/mi)": "520.1730684",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TUNDRA 4WD",
      "CO2 (g/mi)": "523.7861032",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA",
      "CO2 (g/mi)": "334.773498",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "342.3781331",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "184.8605225",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "310",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "JETTA SPORTWAGEN",
      "CO2 (g/mi)": "280",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "304",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "495",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "207",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "414",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C30 T5 FWD",
      "CO2 (g/mi)": "308",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C70 T5 FWD",
      "CO2 (g/mi)": "326",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD",
      "CO2 (g/mi)": "232.0825578",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD PZEV",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD PZEV",
      "CO2 (g/mi)": "268",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 FWD",
      "CO2 (g/mi)": "384",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 FWD PZEV",
      "CO2 (g/mi)": "384",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 AWD 3.2",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "280.427969",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD",
      "CO2 (g/mi)": "385",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD PZEV",
      "CO2 (g/mi)": "397",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 FWD",
      "CO2 (g/mi)": "377",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 FWD PZEV",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 T6 AWD",
      "CO2 (g/mi)": "399",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 3.2 AWD",
      "CO2 (g/mi)": "451",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 FWD 3.2",
      "CO2 (g/mi)": "440",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 V8 AWD",
      "CO2 (g/mi)": "521",
    },
    {
      "Model Year": "2011",
      "Represented Test Veh Make": "VPG",
      "Represented Test Veh Model": "MV-1",
      "CO2 (g/mi)": "464.6",
    },
  ],
  2012: [
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "649.27",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBS",
      "CO2 (g/mi)": "612.598",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide",
      "CO2 (g/mi)": "564.225",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE",
      "CO2 (g/mi)": "551.4037",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE S",
      "CO2 (g/mi)": "529.36",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Virage",
      "CO2 (g/mi)": "569.26",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 QUATTRO",
      "CO2 (g/mi)": "239",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "327",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 QUATTRO",
      "CO2 (g/mi)": "390",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "309",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "435",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "349",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "PASSAT WAGON",
      "CO2 (g/mi)": "342",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Audi",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "287",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "475",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "605",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4",
      "CO2 (g/mi)": "373",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "435",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT Coupe",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT COUPE QUATTRO",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTRS",
      "CO2 (g/mi)": "484",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "348.8",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "300",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf R",
      "CO2 (g/mi)": "372",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "333",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "339",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Azure Dynamics",
      "Represented Test Veh Model": "Transit Connect Electric",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental Supersports",
      "CO2 (g/mi)": "693",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Mulsanne",
      "CO2 (g/mi)": "697",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i",
      "CO2 (g/mi)": "355.17",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i Convertible",
      "CO2 (g/mi)": "230.3951358",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i",
      "CO2 (g/mi)": "222.83",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i Convertible",
      "CO2 (g/mi)": "375.08",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci",
      "CO2 (g/mi)": "230.94",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci Convertible",
      "CO2 (g/mi)": "439.3",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328CiA Convertible",
      "CO2 (g/mi)": "241.98",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "409.13",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xi",
      "CO2 (g/mi)": "441.29",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xiA",
      "CO2 (g/mi)": "245.65",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci",
      "CO2 (g/mi)": "351.51",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci Convertible",
      "CO2 (g/mi)": "234.7353013",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci xDrive",
      "CO2 (g/mi)": "236.01",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335CiA",
      "CO2 (g/mi)": "363.43",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i",
      "CO2 (g/mi)": "385.43",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335is Convertible",
      "CO2 (g/mi)": "398.12",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335is Coupe",
      "CO2 (g/mi)": "389.37",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "294.19",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i xDrive",
      "CO2 (g/mi)": "308.89",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "368.27",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "371.6",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive",
      "CO2 (g/mi)": "333.96",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "230.1",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "423.15",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i GT",
      "CO2 (g/mi)": "440.94",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive",
      "CO2 (g/mi)": "454.82",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "563.23",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive GranTurismo",
      "CO2 (g/mi)": "466.94",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "335.15",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Coupe",
      "CO2 (g/mi)": "341.49",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "465.7",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible xDrive",
      "CO2 (g/mi)": "470.3",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Coupe",
      "CO2 (g/mi)": "457.79",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li",
      "CO2 (g/mi)": "434.49",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750 Li xDrive",
      "CO2 (g/mi)": "518.59",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "304.5860911",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "760Li",
      "CO2 (g/mi)": "341.2947673",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 5",
      "CO2 (g/mi)": "351.06",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7",
      "CO2 (g/mi)": "408.61",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7 L",
      "CO2 (g/mi)": "266.3503316",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB",
      "CO2 (g/mi)": "490.23",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB xDrive",
      "CO2 (g/mi)": "530.89",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "308.29",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3 Convertible",
      "CO2 (g/mi)": "497.13",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "446.79",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "364.55",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "252.63",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "250.2012308",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "453.8707307",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "274.576399",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "521.68",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDriveM",
      "CO2 (g/mi)": "600.3461826",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "262.19",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "499.95",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDriveM",
      "CO2 (g/mi)": "553.27",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive28i",
      "CO2 (g/mi)": "317.6040369",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35i",
      "CO2 (g/mi)": "378.69",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35is",
      "CO2 (g/mi)": "235.78",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Clubman",
      "CO2 (g/mi)": "248.85",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper",
      "CO2 (g/mi)": "244.47",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "256.62",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "194.0098079",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "210.72",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper JCW",
      "CO2 (g/mi)": "275.06",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper JCW Clubman",
      "CO2 (g/mi)": "282.92",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S",
      "CO2 (g/mi)": "268.9",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "268.96",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "276.81",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "195.52",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman All4",
      "CO2 (g/mi)": "206.8516239",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini John Cooper Works Convertible",
      "CO2 (g/mi)": "278.66",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Veyron Super Sport",
      "CO2 (g/mi)": "885",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CODA",
      "Represented Test Veh Model": "CODA",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Fisker",
      "Represented Test Veh Model": "Karma",
      "CO2 (g/mi)": "403",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
      "CO2 (g/mi)": "358.46755",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "508.17198",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.51335",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300/SRT-8",
      "CO2 (g/mi)": "458.23846",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.56653",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Caliber",
      "CO2 (g/mi)": "289.48641",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.55036",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.399",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Grand Cherokee",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "403.2933",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "NITRO 2WD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram 1500 2WD",
      "CO2 (g/mi)": "510.37403",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram 1500 4WD",
      "CO2 (g/mi)": "364.65",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
      "CO2 (g/mi)": "501.87039",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM PICKUP",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500",
      "CO2 (g/mi)": "259.9862594",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "183.346",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4WD",
      "CO2 (g/mi)": "577.53429",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.88845",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.34155",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "458 Italia Spyder",
      "CO2 (g/mi)": "615.347",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California",
      "CO2 (g/mi)": "547.829",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "FF",
      "CO2 (g/mi)": "670.1842336",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "E-350 Extended Wagon",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E150 VAN",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E350 VAN",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE AWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE FWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "ESCAPE 4X2",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape 4x2 FFV",
      "CO2 (g/mi)": "367.89",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape 4X4",
      "CO2 (g/mi)": "349.429",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "ESCAPE AWD",
      "CO2 (g/mi)": "395.813",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "ESCAPE HEV 4x2",
      "CO2 (g/mi)": "195.586",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPEDITION 4X2",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPEDITION 4X4",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER 4WD",
      "CO2 (g/mi)": "425.872",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER FWD",
      "CO2 (g/mi)": "398.458",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X2",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X4 SuperCrew SVT",
      "CO2 (g/mi)": "630.4262021",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X2",
      "CO2 (g/mi)": "404.729",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4 Supercab",
      "CO2 (g/mi)": "320.858",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 2WD",
      "CO2 (g/mi)": "446.479",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 4WD",
      "CO2 (g/mi)": "441.819",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 4WD non-SST",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 4WD SST",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Crew 2WD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
      "CO2 (g/mi)": "473.486",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4",
      "CO2 (g/mi)": "463.898",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 SUPER CAB",
      "CO2 (g/mi)": "374.942",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 SuperCrew 4x2",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 SuperCrew 4x2 SST",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 SuperCrew 4x4",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 SuperCrew 4x4 SST",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "226.464",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "452.22",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FLEX  FWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "FLEX FWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS FFV",
      "CO2 (g/mi)": "249.137",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS SFE",
      "CO2 (g/mi)": "244.742",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FUSION",
      "CO2 (g/mi)": "305.776",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MKS AWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "450.128",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKX AWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MUSTANG",
      "CO2 (g/mi)": "374.62",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
      "CO2 (g/mi)": "418.769",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TRANSIT CONNECT",
      "CO2 (g/mi)": "238.137",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "EXPEDITION 4X2",
      "CO2 (g/mi)": "518.335",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKS",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT FWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4",
      "CO2 (g/mi)": "379.327",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT",
      "CO2 (g/mi)": "656.0930176",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT.",
      "CO2 (g/mi)": "594.9089966",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "Fusion",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "LINCOLN MKS",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Lincoln-Mercury",
      "Represented Test Veh Model": "MILAN",
      "CO2 (g/mi)": "408.504",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LINCOLN-MERCURY",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "508.281",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MERCURY",
      "Represented Test Veh Model": "MARINER HEV 4X4",
      "CO2 (g/mi)": "223.717",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "283.856",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "396.391",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "376.847",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "VERANO",
      "CO2 (g/mi)": "336.451",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6NL26",
      "CO2 (g/mi)": "451.408",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS",
      "CO2 (g/mi)": "231.041",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS AWD",
      "CO2 (g/mi)": "231.041",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS WAGON",
      "CO2 (g/mi)": "435.128",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "325.94",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD HYBRID",
      "CO2 (g/mi)": "350.466",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE AWD",
      "CO2 (g/mi)": "325.94",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX 2WD",
      "CO2 (g/mi)": "417.204",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX AWD",
      "CO2 (g/mi)": "457.828",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ZK69",
      "CO2 (g/mi)": "444.527",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "486.34",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD XFE",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD",
      "CO2 (g/mi)": "280.961",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD HYBRID",
      "CO2 (g/mi)": "395.916",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C2500 SUBURBAN 2WD",
      "CO2 (g/mi)": "695.174",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "379.669",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "393.576",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPTIVA AWD",
      "CO2 (g/mi)": "448.484",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPTIVA FWD",
      "CO2 (g/mi)": "426.606",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "383.932",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "383.932",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CAB CHASSIS INC 2WD",
      "CO2 (g/mi)": "426.795",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CREW CAB 2WD",
      "CO2 (g/mi)": "426.795",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CREW CAB 4WD",
      "CO2 (g/mi)": "456.314",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "439.324",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "243.361",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE ECO",
      "CO2 (g/mi)": "266.493",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "338.502",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "309.317",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD CARGO",
      "CO2 (g/mi)": "555.153",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD PASS",
      "CO2 (g/mi)": "357.907",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD CARGO MDPV",
      "CO2 (g/mi)": "667.168",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD CARGO MDPV",
      "CO2 (g/mi)": "741.688",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "645.137",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "H1500 EXPRESS AWD CARGO",
      "CO2 (g/mi)": "388.161",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "H1500 EXPRESS AWD PASS",
      "CO2 (g/mi)": "388.161",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "396.86",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "511.255",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "467.011",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD HYBRID",
      "CO2 (g/mi)": "395.916",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "339.866",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "RN15306",
      "CO2 (g/mi)": "531",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "251.618",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE AWD",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE FWD",
      "CO2 (g/mi)": "454.425",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "233.936",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "C15 SIERRA 2WD XFE",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL AWD",
      "CO2 (g/mi)": "574.223",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K2500 YUKON XL 4WD",
      "CO2 (g/mi)": "702.279",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN FWD",
      "CO2 (g/mi)": "437.373",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TK20906",
      "CO2 (g/mi)": "753.139",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HUMMER",
      "Represented Test Veh Model": "RN15306",
      "CO2 (g/mi)": "596.699",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-4X FWD",
      "CO2 (g/mi)": "392.24",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "448.9",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX BASE/TECH",
      "CO2 (g/mi)": "279.46",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 2WD",
      "CO2 (g/mi)": "353.07",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 4WD",
      "CO2 (g/mi)": "258.18",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TSX",
      "CO2 (g/mi)": "322.49",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ZDX 4WD",
      "CO2 (g/mi)": "431.3152958",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD CROSSTOUR 2WD EX-L",
      "CO2 (g/mi)": "391.11",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD CROSSTOUR 4WD EX-L",
      "CO2 (g/mi)": "401.58",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX-L COUPE",
      "CO2 (g/mi)": "360.79",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX/EX-L COUPE",
      "CO2 (g/mi)": "308.44",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD EX/EX-L SEDAN",
      "CO2 (g/mi)": "304.53",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX COUPE",
      "CO2 (g/mi)": "306.14",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX/EX/EX-L COUPE",
      "CO2 (g/mi)": "311.41",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD LX/LX+/SE SEDAN",
      "CO2 (g/mi)": "299.85",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC EX",
      "CO2 (g/mi)": "251.9776245",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC GX",
      "CO2 (g/mi)": "192.17",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HF",
      "CO2 (g/mi)": "232.98",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HYBRID",
      "CO2 (g/mi)": "157.0759035",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC LX",
      "CO2 (g/mi)": "158.86",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC SI",
      "CO2 (g/mi)": "410.13",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD EX",
      "CO2 (g/mi)": "303.8",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD EXL",
      "CO2 (g/mi)": "313.4694553",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD LX",
      "CO2 (g/mi)": "208.8561587",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EX",
      "CO2 (g/mi)": "310.76",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EXL",
      "CO2 (g/mi)": "216.14",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD LX",
      "CO2 (g/mi)": "308.76",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-Z EX",
      "CO2 (g/mi)": "193.2648345",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR L4",
      "CO2 (g/mi)": "330.45",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "238.2",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT SPORT",
      "CO2 (g/mi)": "247.68",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT DX/LX",
      "CO2 (g/mi)": "159.6",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT EX",
      "CO2 (g/mi)": "159.39",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY LX/EX/EXL",
      "CO2 (g/mi)": "401.29",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.69",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD EX",
      "CO2 (g/mi)": "250",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD TOURING",
      "CO2 (g/mi)": "401.08",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD EXL",
      "CO2 (g/mi)": "408.1",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD TOURING",
      "CO2 (g/mi)": "420.17",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE",
      "CO2 (g/mi)": "459.96",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RL",
      "CO2 (g/mi)": "415.23",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "240.0891527",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "AZERA",
      "CO2 (g/mi)": "349.1491646",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA",
      "CO2 (g/mi)": "233.33",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA TOURING",
      "CO2 (g/mi)": "303.86",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "EQUUS",
      "CO2 (g/mi)": "455.2976",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS",
      "CO2 (g/mi)": "221.6",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS COUPE",
      "CO2 (g/mi)": "429.15",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS R SPEC",
      "CO2 (g/mi)": "523.8",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SANTA FE",
      "CO2 (g/mi)": "360.56",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA",
      "CO2 (g/mi)": "295.9736",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "207.85",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "TUCSON",
      "CO2 (g/mi)": "346.31",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Veloster",
      "CO2 (g/mi)": "251.9249918",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "VERACRUZ",
      "CO2 (g/mi)": "457.1",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XF V8 5.0",
      "CO2 (g/mi)": "443.46",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XF-R",
      "CO2 (g/mi)": "475.95",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "446.87",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Convertible",
      "CO2 (g/mi)": "454.5",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Coupe",
      "CO2 (g/mi)": "446.73",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK-R",
      "CO2 (g/mi)": "477.44",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE",
      "CO2 (g/mi)": "277.14",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE ECO",
      "CO2 (g/mi)": "178.802051",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE KOUP",
      "CO2 (g/mi)": "272.82",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA",
      "CO2 (g/mi)": "190.1937076",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RIO",
      "CO2 (g/mi)": "231.1048",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RONDO",
      "CO2 (g/mi)": "359.31",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SEDONA",
      "CO2 (g/mi)": "391.634",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SORENTO",
      "CO2 (g/mi)": "361.55",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SOUL",
      "CO2 (g/mi)": "269.9",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SOUL ECO",
      "CO2 (g/mi)": "179.7428281",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "341.67",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "834",
      "CO2 (g/mi)": "727",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR2",
      "CO2 (g/mi)": "293.8",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR3",
      "CO2 (g/mi)": "576.48",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "583.16",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque",
      "CO2 (g/mi)": "384.868525",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "569.97",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport Supercharged",
      "CO2 (g/mi)": "612.43",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Supercharged",
      "CO2 (g/mi)": "621.48",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "EVORA",
      "CO2 (g/mi)": "254.6",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora S-IPS",
      "CO2 (g/mi)": "446.145",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO",
      "CO2 (g/mi)": "560.136",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.258",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "575.221",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "6",
      "CO2 (g/mi)": "257.291",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-7",
      "CO2 (g/mi)": "412",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 AWD",
      "CO2 (g/mi)": "436.446",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 FWD",
      "CO2 (g/mi)": "406.68",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "Mazda 3 DI 4-Door",
      "CO2 (g/mi)": "163",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "Mazda 3 DI 5-Door",
      "CO2 (g/mi)": "247.0663809",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "179.51",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "344",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA5",
      "CO2 (g/mi)": "329",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "331.19",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazdaspeed3",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "MP4-12C Coupe",
      "CO2 (g/mi)": "590.7",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250",
      "CO2 (g/mi)": "202.542449",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250 (Coupe)",
      "CO2 (g/mi)": "328.26",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "400.54",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350",
      "CO2 (g/mi)": "354.76",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 (Coupe)",
      "CO2 (g/mi)": "372.76",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 4MATIC (Coupe)",
      "CO2 (g/mi)": "369.1",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 63 AMG Black Series (coupe)",
      "CO2 (g/mi)": "543.56",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 550 4MATIC",
      "CO2 (g/mi)": "470.4",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 600",
      "CO2 (g/mi)": "616.2928055",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 63 AMG",
      "CO2 (g/mi)": "299.45",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 65 AMG",
      "CO2 (g/mi)": "588.7",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "535.49",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "432.75",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG",
      "CO2 (g/mi)": "488.77",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "358.37",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (Convertible)",
      "CO2 (g/mi)": "371.39",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (Coupe)",
      "CO2 (g/mi)": "375.28",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4 MATIC",
      "CO2 (g/mi)": "372.64",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4 MATIC (Coupe)",
      "CO2 (g/mi)": "380.47",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "368.43",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Coupe)",
      "CO2 (g/mi)": "373.5",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Station Wagon)",
      "CO2 (g/mi)": "383.17",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 BLUETEC",
      "CO2 (g/mi)": "372.61",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (Convertible)",
      "CO2 (g/mi)": "413.12",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (Coupe)",
      "CO2 (g/mi)": "409.02",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 4MATIC",
      "CO2 (g/mi)": "437.37",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG",
      "CO2 (g/mi)": "462.37",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG (Station Wagon)",
      "CO2 (g/mi)": "467.77",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "F-Cell",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "628.88",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "481.98",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "566.12",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "579.22",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350",
      "CO2 (g/mi)": "505.32",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350 4MATIC",
      "CO2 (g/mi)": "455.86",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 57 Zeppelin",
      "CO2 (g/mi)": "408.17",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach 62",
      "CO2 (g/mi)": "717.95",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "419.9222211",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "408.59",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 550 4MATIC",
      "CO2 (g/mi)": "490.95",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "520.54",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 4MATIC",
      "CO2 (g/mi)": "444.86",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "297.5553561",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "383.94",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 400 HYBRID",
      "CO2 (g/mi)": "248.8401166",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "454.01",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "600.14",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "605.76",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG",
      "CO2 (g/mi)": "467.16",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG",
      "CO2 (g/mi)": "592.3",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "310.36",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "608.98",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 250",
      "CO2 (g/mi)": "308.38",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "218.6221575",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 55 AMG",
      "CO2 (g/mi)": "372.98",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLS AMG",
      "CO2 (g/mi)": "529.55",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo (Coupe)",
      "CO2 (g/mi)": "289.23",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "W204E63-Z1011",
      "Represented Test Veh Model": "C 63 AMG",
      "CO2 (g/mi)": "546.41",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "i-MiEV",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
      "CO2 (g/mi)": "279.44774",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER EVOLUTION",
      "CO2 (g/mi)": "422.12296",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER SPORTBACK",
      "CO2 (g/mi)": "402.69605",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "306.39028",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "320.3937",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "291.69085",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "226.3841806",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE",
      "CO2 (g/mi)": "225.74037",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE SPYDER",
      "CO2 (g/mi)": "430.02114",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "GALANT",
      "CO2 (g/mi)": "332.14356",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX35 AWD Journey",
      "CO2 (g/mi)": "422",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX35 AWD",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX35 RWD",
      "CO2 (g/mi)": "435",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX50 AWD",
      "CO2 (g/mi)": "514",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G25 Journey",
      "CO2 (g/mi)": "350",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G25x",
      "CO2 (g/mi)": "364",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Journey",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Sport 6MT",
      "CO2 (g/mi)": "437",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Journey",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Sport 6MT",
      "CO2 (g/mi)": "434.7349456",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37X COUPE AWD",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M35h",
      "CO2 (g/mi)": "258",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M37 Base",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M37X Base",
      "CO2 (g/mi)": "267",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56 Base",
      "CO2 (g/mi)": "472",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56X Base",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 2WD",
      "CO2 (g/mi)": "536",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 4WD",
      "CO2 (g/mi)": "535",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA SE 5.6L 4X4",
      "CO2 (g/mi)": "577",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING CAB XE",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING CAB XE 4X2",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER KING PRO4X4",
      "CO2 (g/mi)": "497",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z ROADSTER Touring",
      "CO2 (g/mi)": "397",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5 S",
      "CO2 (g/mi)": "297",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5S",
      "CO2 (g/mi)": "301",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 3.5 SR",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA COUPE 2.5 S",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Nissan Armada SE 5.6l 4x4",
      "CO2 (g/mi)": "580",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 S",
      "CO2 (g/mi)": "201",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 SL",
      "CO2 (g/mi)": "202",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD XE",
      "CO2 (g/mi)": "420",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB PRO-4X 4X4",
      "CO2 (g/mi)": "466",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE",
      "CO2 (g/mi)": "461",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE 4X2",
      "CO2 (g/mi)": "474",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER KING CAB SE 4X4",
      "CO2 (g/mi)": "461",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "447",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "196",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF UPR",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 4-DOOR SEDAN 3.5S",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA SV",
      "CO2 (g/mi)": "372",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD LE",
      "CO2 (g/mi)": "402",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD SL",
      "CO2 (g/mi)": "391",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO CrossCabriolet Base",
      "CO2 (g/mi)": "424",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 4WD LE",
      "CO2 (g/mi)": "518",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER SE 4X2",
      "CO2 (g/mi)": "486",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER SE 4X4",
      "CO2 (g/mi)": "325",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "381",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SV",
      "CO2 (g/mi)": "246",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0",
      "CO2 (g/mi)": "289",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0SL",
      "CO2 (g/mi)": "257",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA 2.0SR",
      "CO2 (g/mi)": "259",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SE-R",
      "CO2 (g/mi)": "295",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.8S",
      "CO2 (g/mi)": "288",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA 1.8SL",
      "CO2 (g/mi)": "185",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA S",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA SL",
      "CO2 (g/mi)": "223",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN XTERRA 2WD S",
      "CO2 (g/mi)": "445",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER SE 4X4",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA SE-R  Spec V",
      "CO2 (g/mi)": "333",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SUZUKI EQUATOR 2WD",
      "CO2 (g/mi)": "425",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD Crew Cab LE SWB",
      "CO2 (g/mi)": "609",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE LWB",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE SWB",
      "CO2 (g/mi)": "596",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE-SWB",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "233.146011",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 3.6L",
      "CO2 (g/mi)": "377.42156",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "372.03",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "378.45",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S 3.8L",
      "CO2 (g/mi)": "374.54376",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "379.07",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo",
      "CO2 (g/mi)": "442.64438",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S",
      "CO2 (g/mi)": "260.00128",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster Spyder",
      "CO2 (g/mi)": "351.3",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "437.1585",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "456.4596",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "486.11613",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman",
      "CO2 (g/mi)": "347.3957",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman S",
      "CO2 (g/mi)": "366.09",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "400.01134",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "437.9727",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera S Hybrid",
      "CO2 (g/mi)": "292.07",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "478.3673",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "324.89",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "618.13",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "E350 Cutaway",
      "CO2 (g/mi)": "620.8707361",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "665.8",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-3 SEDAN AWD",
      "CO2 (g/mi)": "392.239",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-3 SPORT SEDAN",
      "CO2 (g/mi)": "340.147",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-5 SEDAN",
      "CO2 (g/mi)": "392.239",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SAAB",
      "Represented Test Veh Model": "9-5 SEDAN AWD",
      "CO2 (g/mi)": "417.538",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER AWD",
      "CO2 (g/mi)": "373.0975",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA AWD",
      "CO2 (g/mi)": "261",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON/OUTBACK SPORT AWD",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WGN/OUTBACK SPT AWD",
      "CO2 (g/mi)": "415.3185",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN 4WD",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN AWD",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "326",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "TRIBECA AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA",
      "CO2 (g/mi)": "365.6643",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA 4WD",
      "CO2 (g/mi)": "424.3441",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI AWD",
      "CO2 (g/mi)": "314.8266",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI FWD",
      "CO2 (g/mi)": "301.6482",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 2WD",
      "CO2 (g/mi)": "296.8269",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 4WD",
      "CO2 (g/mi)": "312.7982",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "S3",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "CT 200h",
      "CO2 (g/mi)": "153.69495",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "224.896731",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "469.5413422",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "HS 250h",
      "CO2 (g/mi)": "189.2263987",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250 AWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250/IS 250C",
      "CO2 (g/mi)": "334.2514956",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350 AWD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350/IS 350C",
      "CO2 (g/mi)": "356.1255349",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS F",
      "CO2 (g/mi)": "276.6657778",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LFA",
      "CO2 (g/mi)": "604.6376223",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.3656149",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "256.1145167",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "397.9446499",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "388.3262057",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "262.5109038",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "215.3292345",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "217.1822011",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iQ",
      "CO2 (g/mi)": "229.2161468",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "tC",
      "CO2 (g/mi)": "299.1152855",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "407.5022803",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "421.6376489",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Avalon",
      "CO2 (g/mi)": "362.2439694",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "186.9175648",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid LE",
      "CO2 (g/mi)": "156.5325481",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid XLE",
      "CO2 (g/mi)": "157.2902683",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "177.5084434",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA MATRIX",
      "CO2 (g/mi)": "345.9091036",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 2WD",
      "CO2 (g/mi)": "292.952708",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 4WD",
      "CO2 (g/mi)": "303.8880426",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 2WD",
      "CO2 (g/mi)": "415.8852753",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 4WD",
      "CO2 (g/mi)": "281.2777708",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID 4WD",
      "CO2 (g/mi)": "233.1757027",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "130.8100637",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "180.1866934",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Plug-in Hybrid",
      "CO2 (g/mi)": "180.7904938",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS v",
      "CO2 (g/mi)": "148.3199728",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 2WD",
      "CO2 (g/mi)": "365.067935",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 4WD",
      "CO2 (g/mi)": "369.5892453",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Toyota",
      "Represented Test Veh Model": "RAV4 EV",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xB",
      "CO2 (g/mi)": "318.8867968",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xD",
      "CO2 (g/mi)": "250.892098",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "499.3866316",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "358.0137298",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "560.5876212",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "399.0053779",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "273.4205755",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "388.9768036",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "289.5728875",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TUNDRA 2WD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "315.5671034",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "364.1309207",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA",
      "CO2 (g/mi)": "334.773498",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "342.3781331",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "JETTA SPORTWAGEN",
      "CO2 (g/mi)": "269.5674712",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "NMS",
      "CO2 (g/mi)": "364",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "495",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "207",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "266.6770044",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C30 T5 FWD",
      "CO2 (g/mi)": "308",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C70 T5 FWD",
      "CO2 (g/mi)": "409",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "352",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD",
      "CO2 (g/mi)": "346",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 FWD",
      "CO2 (g/mi)": "374",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD PZEV",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 3.2 AWD",
      "CO2 (g/mi)": "440",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 FWD 3.2",
      "CO2 (g/mi)": "431",
    },
    {
      "Model Year": "2012",
      "Represented Test Veh Make": "VPG",
      "Represented Test Veh Model": "MV-1",
      "CO2 (g/mi)": "464.6",
    },
  ],
  2013: [
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "550.27",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE",
      "CO2 (g/mi)": "551.4037",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE S",
      "CO2 (g/mi)": "529.36",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 QUATTRO",
      "CO2 (g/mi)": "239",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "325",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "352",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A5",
      "CO2 (g/mi)": "324",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "309",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 quattro",
      "CO2 (g/mi)": "422",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "483",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5 Hybrid",
      "CO2 (g/mi)": "323",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "468",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "552",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS5",
      "CO2 (g/mi)": "541",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "396",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S7",
      "CO2 (g/mi)": "484",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8",
      "CO2 (g/mi)": "569",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT Coupe",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT COUPE QUATTRO",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTRS",
      "CO2 (g/mi)": "484",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT",
      "CO2 (g/mi)": "632",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "348.8",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "300",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf R",
      "CO2 (g/mi)": "372",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "333",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "TIGUAN",
      "CO2 (g/mi)": "421",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Azure Dynamics",
      "Represented Test Veh Model": "Transit Connect Electric",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental Supersports",
      "CO2 (g/mi)": "693",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Mulsanne",
      "CO2 (g/mi)": "690.22275",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i",
      "CO2 (g/mi)": "355.17",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "128i Convertible",
      "CO2 (g/mi)": "230.3951358",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i",
      "CO2 (g/mi)": "222.83",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "135i Convertible",
      "CO2 (g/mi)": "375.08",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i",
      "CO2 (g/mi)": "301.19",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i xDrive",
      "CO2 (g/mi)": "324.3",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci",
      "CO2 (g/mi)": "230.94",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328Ci Convertible",
      "CO2 (g/mi)": "439.3",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328CiA Convertible",
      "CO2 (g/mi)": "241.98",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "175.1535785",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive",
      "CO2 (g/mi)": "306.26",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xi",
      "CO2 (g/mi)": "441.29",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328xiA",
      "CO2 (g/mi)": "421.19",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci",
      "CO2 (g/mi)": "351.51",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci Convertible",
      "CO2 (g/mi)": "234.7353013",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335Ci xDrive",
      "CO2 (g/mi)": "236.01",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335CiA",
      "CO2 (g/mi)": "363.43",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i",
      "CO2 (g/mi)": "385.43",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive",
      "CO2 (g/mi)": "352.79",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335is Convertible",
      "CO2 (g/mi)": "398.12",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335is Coupe",
      "CO2 (g/mi)": "389.37",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "291.97",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i xDrive",
      "CO2 (g/mi)": "302.1",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "368.27",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive",
      "CO2 (g/mi)": "353.9",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "385.56",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "423.15",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i Gran Turismo",
      "CO2 (g/mi)": "435.73",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive",
      "CO2 (g/mi)": "454.82",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "432.48",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.56",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Coupe",
      "CO2 (g/mi)": "343.14",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.25",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Coupe",
      "CO2 (g/mi)": "402.1",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Coupe",
      "CO2 (g/mi)": "424.2",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li",
      "CO2 (g/mi)": "219.65",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li xDrive",
      "CO2 (g/mi)": "362.85",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "428.57",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750Li",
      "CO2 (g/mi)": "259.7",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750Li xDrive",
      "CO2 (g/mi)": "430.34",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "760Li",
      "CO2 (g/mi)": "574.75",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 3",
      "CO2 (g/mi)": "283.96",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 5",
      "CO2 (g/mi)": "351.06",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7",
      "CO2 (g/mi)": "327.44",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "308.29",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3 Convertible",
      "CO2 (g/mi)": "497.13",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "485.57",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.39",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "307.64",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "340.63",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive35i",
      "CO2 (g/mi)": "395.82",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "328.21",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "250.2012308",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "453.8707307",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "274.576399",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "521.68",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDriveM",
      "CO2 (g/mi)": "600.3461826",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "262.19",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "499.95",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDriveM",
      "CO2 (g/mi)": "553.27",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive28i",
      "CO2 (g/mi)": "317.6040369",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35i",
      "CO2 (g/mi)": "378.69",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35is",
      "CO2 (g/mi)": "235.78",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works",
      "CO2 (g/mi)": "284.56",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works All4 Countryman",
      "CO2 (g/mi)": "306.52",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works Clubman",
      "CO2 (g/mi)": "284.47",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works Convertible",
      "CO2 (g/mi)": "288.67",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Clubman",
      "CO2 (g/mi)": "248.85",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper",
      "CO2 (g/mi)": "244.47",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "256.62",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "194.0098079",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "210.72",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S",
      "CO2 (g/mi)": "268.9",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "268.96",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "276.81",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "195.52",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman All4",
      "CO2 (g/mi)": "206.8516239",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Veyron Super Sport",
      "CO2 (g/mi)": "885",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CODA",
      "Represented Test Veh Model": "CODA",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
      "CO2 (g/mi)": "360",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "239.073",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.51335",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300/SRT-8",
      "CO2 (g/mi)": "458.23846",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.56653",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
      "CO2 (g/mi)": "211.704",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Caliber",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.55036",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.399",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Dart",
      "CO2 (g/mi)": "252.42547",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Grand Cherokee",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram 1500 2WD",
      "CO2 (g/mi)": "510.37403",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram 1500 4WD",
      "CO2 (g/mi)": "364.65",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM PICKUP",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "183.346",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 2WD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 4WD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4WD",
      "CO2 (g/mi)": "577.53429",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.88845",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.34155",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
      "CO2 (g/mi)": "416.70508",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SRT",
      "Represented Test Veh Model": "Viper",
      "CO2 (g/mi)": "614.21549",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "458 Italia Spyder",
      "CO2 (g/mi)": "514.92",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California",
      "CO2 (g/mi)": "500.95",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Berlinetta",
      "CO2 (g/mi)": "596.476",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "FF",
      "CO2 (g/mi)": "628.71",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max (PHEV)",
      "CO2 (g/mi)": "172.8648383",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "E-350 Extended Wagon",
      "CO2 (g/mi)": "543",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E150 VAN",
      "CO2 (g/mi)": "549",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E350 EXTENDED WAGON",
      "CO2 (g/mi)": "723",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE AWD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE FWD",
      "CO2 (g/mi)": "377",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "311.603",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "312.191",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER 4WD",
      "CO2 (g/mi)": "279.511",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FFV FWD Police",
      "CO2 (g/mi)": "413.258",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER FWD FFV",
      "CO2 (g/mi)": "397.136",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "452.945",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X4 SuperCrew SVT",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4 Supercab",
      "CO2 (g/mi)": "320.858",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup 2WD",
      "CO2 (g/mi)": "563.089",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 2WD",
      "CO2 (g/mi)": "446.479",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 4WD",
      "CO2 (g/mi)": "441.819",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
      "CO2 (g/mi)": "473.486",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4",
      "CO2 (g/mi)": "458",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 SUPER CAB",
      "CO2 (g/mi)": "374.375",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X2",
      "CO2 (g/mi)": "407.892",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "226.464",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "451",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS FFV",
      "CO2 (g/mi)": "249.137",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS SFE",
      "CO2 (g/mi)": "244.742",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS ST",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "152.0873189",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion AWD",
      "CO2 (g/mi)": "322.75",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion FWD",
      "CO2 (g/mi)": "296.159",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MKS AWD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "553.77",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKX AWD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKX FWD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ (HEV)",
      "CO2 (g/mi)": "175.157",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MUSTANG",
      "CO2 (g/mi)": "374.62",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
      "CO2 (g/mi)": "365.753",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police",
      "CO2 (g/mi)": "396.917",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "449.629",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
      "CO2 (g/mi)": "256.32",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "389.431",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TRANSIT CONNECT",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "EXPEDITION 4X2",
      "CO2 (g/mi)": "518.335",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKS",
      "CO2 (g/mi)": "243.5828256",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKS FWD",
      "CO2 (g/mi)": "370.595",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKTLivery",
      "CO2 (g/mi)": "343.419",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKZ AWD",
      "CO2 (g/mi)": "391.561",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4",
      "CO2 (g/mi)": "379.327",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT",
      "CO2 (g/mi)": "656.0930176",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT.",
      "CO2 (g/mi)": "594.9089966",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCLAVE AWD",
      "CO2 (g/mi)": "442.1",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "214.5406179",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "283.856",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "386.4",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "VERANO",
      "CO2 (g/mi)": "203.4610451",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DM69",
      "CO2 (g/mi)": "231.041",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DP35",
      "CO2 (g/mi)": "399.586",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS",
      "CO2 (g/mi)": "202.309",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS",
      "CO2 (g/mi)": "621.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS WAGON",
      "CO2 (g/mi)": "614.987",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "317.9",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD HYBRID",
      "CO2 (g/mi)": "350.466",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE AWD",
      "CO2 (g/mi)": "327.9",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX 2WD",
      "CO2 (g/mi)": "417.204",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX AWD",
      "CO2 (g/mi)": "457.828",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS",
      "CO2 (g/mi)": "411.4",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "251",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "489.612",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1EF37",
      "CO2 (g/mi)": "379.669",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LH26",
      "CO2 (g/mi)": "316.042",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LK26",
      "CO2 (g/mi)": "348.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "480.4",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 SILVERADO CLASSIC 2WD",
      "CO2 (g/mi)": "486.34",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD HYBRID",
      "CO2 (g/mi)": "395.916",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C2500 SUBURBAN 2WD",
      "CO2 (g/mi)": "695.174",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "400.3",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "393.576",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPTIVA FWD",
      "CO2 (g/mi)": "267.714",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10703",
      "CO2 (g/mi)": "467.011",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10706",
      "CO2 (g/mi)": "449.772",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10903",
      "CO2 (g/mi)": "551.472",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CG13406",
      "CO2 (g/mi)": "388.161",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "439.324",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "263.7",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE ECO",
      "CO2 (g/mi)": "223.739",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "330.734",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "309.317",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD CARGO",
      "CO2 (g/mi)": "552",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD PASS",
      "CO2 (g/mi)": "357.907",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "645.137",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS CONV 2WD CARGO",
      "CO2 (g/mi)": "691.8",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "409.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "220.7400051",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "511.255",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD HYBRID",
      "CO2 (g/mi)": "398.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "340.772",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "251.618",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC 5",
      "CO2 (g/mi)": "279.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC RS",
      "CO2 (g/mi)": "184.776",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "213.298",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "233.936",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "C15 SIERRA 2WD",
      "CO2 (g/mi)": "577.1",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL AWD",
      "CO2 (g/mi)": "574.223",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K2500 YUKON XL 4WD",
      "CO2 (g/mi)": "702.279",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TK20906",
      "CO2 (g/mi)": "753.139",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "290.51",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX HYBRID",
      "CO2 (g/mi)": "231.66",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "448.9",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 2WD",
      "CO2 (g/mi)": "350.84",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 4WD",
      "CO2 (g/mi)": "362.05",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 2WD",
      "CO2 (g/mi)": "353.07",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 4WD",
      "CO2 (g/mi)": "258.18",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TSX",
      "CO2 (g/mi)": "322.49",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ZDX 4WD",
      "CO2 (g/mi)": "431.3152958",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "258.97",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC",
      "CO2 (g/mi)": "243.62",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC GX",
      "CO2 (g/mi)": "192.82",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HF",
      "CO2 (g/mi)": "232.03",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HYBRID",
      "CO2 (g/mi)": "157.0759035",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC SI",
      "CO2 (g/mi)": "410.13",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD EX",
      "CO2 (g/mi)": "303.8",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD EXL",
      "CO2 (g/mi)": "313.4694553",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD LX",
      "CO2 (g/mi)": "208.8561587",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EX",
      "CO2 (g/mi)": "310.76",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EXL",
      "CO2 (g/mi)": "216.14",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD LX",
      "CO2 (g/mi)": "308.76",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-Z",
      "CO2 (g/mi)": "185.08",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR L4",
      "CO2 (g/mi)": "320.94",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR V6 2WD",
      "CO2 (g/mi)": "355.99",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR V6 4WD",
      "CO2 (g/mi)": "228.53",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "238.2",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EV",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT SPORT",
      "CO2 (g/mi)": "247.68",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT DX/LX",
      "CO2 (g/mi)": "159.6",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT EX",
      "CO2 (g/mi)": "159.39",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY LX/EX/EXL",
      "CO2 (g/mi)": "401.29",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.69",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD EX",
      "CO2 (g/mi)": "250",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD TOURING",
      "CO2 (g/mi)": "401.08",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD EXL",
      "CO2 (g/mi)": "408.1",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD TOURING",
      "CO2 (g/mi)": "420.17",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE",
      "CO2 (g/mi)": "459.96",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "240.0891527",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "AZERA",
      "CO2 (g/mi)": "215.4175",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA",
      "CO2 (g/mi)": "233.33",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA BLUE",
      "CO2 (g/mi)": "233.1976797",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA COUPE",
      "CO2 (g/mi)": "247.1663343",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ELANTRA GT",
      "CO2 (g/mi)": "249.7636",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "EQUUS",
      "CO2 (g/mi)": "455.2976",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS",
      "CO2 (g/mi)": "221.6",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS COUPE",
      "CO2 (g/mi)": "355.1541",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "GENESIS R SPEC",
      "CO2 (g/mi)": "523.8",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "265.2879347",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport",
      "CO2 (g/mi)": "354.7265997",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA",
      "CO2 (g/mi)": "295.9736",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "184.7263",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID LIMITED",
      "CO2 (g/mi)": "157.7761198",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "TUCSON",
      "CO2 (g/mi)": "346.31",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Veloster",
      "CO2 (g/mi)": "247.48",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID",
      "CO2 (g/mi)": "184.6212",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID EX",
      "CO2 (g/mi)": "189.4587",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "459.7",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF 3.0",
      "CO2 (g/mi)": "407.6",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF 3.0 AWD",
      "CO2 (g/mi)": "445.78",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF Supercharged",
      "CO2 (g/mi)": "477.17",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ 3.0",
      "CO2 (g/mi)": "428.89",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "278.38",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL",
      "CO2 (g/mi)": "457.11",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Convertible",
      "CO2 (g/mi)": "454.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Coupe",
      "CO2 (g/mi)": "446.73",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XK-R",
      "CO2 (g/mi)": "484.2",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE",
      "CO2 (g/mi)": "277.14",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE ECO",
      "CO2 (g/mi)": "178.802051",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "FORTE KOUP",
      "CO2 (g/mi)": "272.82",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA",
      "CO2 (g/mi)": "294.6865",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RIO",
      "CO2 (g/mi)": "231.1048",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "RIO ECO",
      "CO2 (g/mi)": "156.1878589",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SORENTO",
      "CO2 (g/mi)": "361.55",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SOUL",
      "CO2 (g/mi)": "269.9",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SOUL ECO",
      "CO2 (g/mi)": "179.7428281",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "341.67",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Koenigsegg",
      "Represented Test Veh Model": "CC-X Agera",
      "CO2 (g/mi)": "669.96",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR",
      "CO2 (g/mi)": "784",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "LR2",
      "CO2 (g/mi)": "406.99",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "LR3",
      "CO2 (g/mi)": "576.48",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "531.45",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque",
      "CO2 (g/mi)": "362.42",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "364.23",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Range Rover Sport Supercharged",
      "CO2 (g/mi)": "612.43",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Supercharged",
      "CO2 (g/mi)": "565.05",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "EVORA",
      "CO2 (g/mi)": "254.6",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora S-IPS",
      "CO2 (g/mi)": "446.145",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.258",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO S AUTOMATIC",
      "CO2 (g/mi)": "560.136",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "609.864",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "6",
      "CO2 (g/mi)": "257.291",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "263",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 AWD",
      "CO2 (g/mi)": "436.446",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 FWD",
      "CO2 (g/mi)": "406.68",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "Mazda 3 DI 4-Door",
      "CO2 (g/mi)": "163",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "Mazda 3 DI 5-Door",
      "CO2 (g/mi)": "247.0663809",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "179.51",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "339",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA5",
      "CO2 (g/mi)": "329",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "331.19",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazdaspeed3",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "MP4-12C Coupe",
      "CO2 (g/mi)": "590.7",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250",
      "CO2 (g/mi)": "322.51",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250 (Coupe)",
      "CO2 (g/mi)": "323.82",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "352.21",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350",
      "CO2 (g/mi)": "350.85",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 (Coupe)",
      "CO2 (g/mi)": "350.95",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 4Matic (Coupe)",
      "CO2 (g/mi)": "362.91",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 63 AMG Black Series (coupe)",
      "CO2 (g/mi)": "543.56",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 550 4MATIC",
      "CO2 (g/mi)": "470.4",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 600",
      "CO2 (g/mi)": "616.2928055",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 63 AMG",
      "CO2 (g/mi)": "299.45",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 65 AMG",
      "CO2 (g/mi)": "588.7",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "535.49",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "432.75",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG",
      "CO2 (g/mi)": "488.77",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "358.37",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (Convertible)",
      "CO2 (g/mi)": "371.39",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (Coupe)",
      "CO2 (g/mi)": "367.72",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4 MATIC",
      "CO2 (g/mi)": "372.64",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "368.43",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Coupe)",
      "CO2 (g/mi)": "373.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Station Wagon)",
      "CO2 (g/mi)": "383.17",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 BLUETEC",
      "CO2 (g/mi)": "372.61",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 HYBRID",
      "CO2 (g/mi)": "208.44",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (Convertible)",
      "CO2 (g/mi)": "413.12",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (Coupe)",
      "CO2 (g/mi)": "409.02",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 4MATIC",
      "CO2 (g/mi)": "437.37",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG",
      "CO2 (g/mi)": "462.37",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG (Station Wagon)",
      "CO2 (g/mi)": "467.77",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "615.61",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "280.47",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "513.88",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "604.77",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 63 AMG",
      "CO2 (g/mi)": "736.6",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 250 BLUETEC 4MATIC",
      "CO2 (g/mi)": "217.49",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350",
      "CO2 (g/mi)": "363.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350 4MATIC",
      "CO2 (g/mi)": "368.85",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "397.11",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "398.5",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "402.8",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 550 4MATIC",
      "CO2 (g/mi)": "490.95",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "520.54",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "R 350 4MATIC",
      "CO2 (g/mi)": "444.86",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "383.94",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 400 HYBRID",
      "CO2 (g/mi)": "248.8401166",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "454.01",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "600.14",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "605.76",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG",
      "CO2 (g/mi)": "467.16",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG",
      "CO2 (g/mi)": "592.3",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "259.41",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "448.57",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 65 AMG",
      "CO2 (g/mi)": "511.74",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 250",
      "CO2 (g/mi)": "308.38",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "218.81",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 55 AMG",
      "CO2 (g/mi)": "372.98",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLS AMG",
      "CO2 (g/mi)": "344.37",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo (Coupe)",
      "CO2 (g/mi)": "289.23",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo electric drive (convertible)",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "W204E63-Z1011",
      "Represented Test Veh Model": "C 63 AMG",
      "CO2 (g/mi)": "546.41",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "i-MiEV",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
      "CO2 (g/mi)": "279.44774",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER EVOLUTION",
      "CO2 (g/mi)": "422.12296",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER SPORTBACK",
      "CO2 (g/mi)": "402.69605",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "306.39028",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "320.3937",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "294.05506",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "292.44073",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX37 AWD Journey",
      "CO2 (g/mi)": "410",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX37 Journey",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX37 AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX37 RWD",
      "CO2 (g/mi)": "425",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX50 AWD",
      "CO2 (g/mi)": "508",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Journey",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 CONVERTIBLE Sport 6MT",
      "CO2 (g/mi)": "437",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Journey",
      "CO2 (g/mi)": "369",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 sedan Sport 6MT",
      "CO2 (g/mi)": "434.7349456",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37X COUPE AWD",
      "CO2 (g/mi)": "398",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI JX35 AWD",
      "CO2 (g/mi)": "396",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M35h",
      "CO2 (g/mi)": "258",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M37 Base",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M37X Base",
      "CO2 (g/mi)": "267",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56 Base",
      "CO2 (g/mi)": "472",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56x",
      "CO2 (g/mi)": "458",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56X Base",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 2WD",
      "CO2 (g/mi)": "531",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 4WD",
      "CO2 (g/mi)": "532",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA SE 5.6L 4X4",
      "CO2 (g/mi)": "577",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z ROADSTER Touring",
      "CO2 (g/mi)": "397",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z Touring",
      "CO2 (g/mi)": "405",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5S",
      "CO2 (g/mi)": "301",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5SL",
      "CO2 (g/mi)": "163",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 3.5SL",
      "CO2 (g/mi)": "205",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Nissan Armada SE 5.6l 4x4",
      "CO2 (g/mi)": "580",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 S",
      "CO2 (g/mi)": "201",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 SL",
      "CO2 (g/mi)": "260.079961",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD K/C SV",
      "CO2 (g/mi)": "452",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5AT",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5MT",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5AT",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5MT",
      "CO2 (g/mi)": "268",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD C/C PRO-4X",
      "CO2 (g/mi)": "494",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C PRO-4X",
      "CO2 (g/mi)": "465",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C SV",
      "CO2 (g/mi)": "489",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "427",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "196",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF S",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF SL",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 4-DOOR SEDAN 3.5S",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA SV",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD LE",
      "CO2 (g/mi)": "406.1835502",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO CrossCabriolet BASE",
      "CO2 (g/mi)": "285",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 Cargo Van S",
      "CO2 (g/mi)": "229",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 2WD Platinum",
      "CO2 (g/mi)": "356",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 4WD Platinum",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "376",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SV",
      "CO2 (g/mi)": "246",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA FE+SV",
      "CO2 (g/mi)": "221",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA S",
      "CO2 (g/mi)": "254",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SL",
      "CO2 (g/mi)": "228",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SV",
      "CO2 (g/mi)": "224",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN TITAN 4WD Crew Cab XE LWB",
      "CO2 (g/mi)": "608",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA S",
      "CO2 (g/mi)": "256",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA SV",
      "CO2 (g/mi)": "150",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE LWB",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE SWB",
      "CO2 (g/mi)": "596",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE-SWB",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "233.146011",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "371.89",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "379.4",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "383.59",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "388.17",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "372.03",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "378.45",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "379.07",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo",
      "CO2 (g/mi)": "442.64438",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S",
      "CO2 (g/mi)": "260.00128",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "359.2",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "431.3213694",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "482.29",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "456.4596",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "486.11613",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "400.01134",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "437.9727",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS",
      "CO2 (g/mi)": "450.8",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera S Hybrid",
      "CO2 (g/mi)": "292.07",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "478.3673",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "469.58",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom EWB",
      "CO2 (g/mi)": "538.77",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "E350 Cutaway",
      "CO2 (g/mi)": "620.8707361",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "294.4",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER AWD",
      "CO2 (g/mi)": "373.0975",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA AWD",
      "CO2 (g/mi)": "261",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON/OUTBACK SPORT AWD",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WGN/OUTBACK SPT AWD",
      "CO2 (g/mi)": "415.3185",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY AWD",
      "CO2 (g/mi)": "289.8171623",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN 4WD",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK WAGON AWD",
      "CO2 (g/mi)": "292",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "TRIBECA AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "XV CROSSTREK AWD",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA",
      "CO2 (g/mi)": "365.6643",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "GRAND VITARA 4WD",
      "CO2 (g/mi)": "424.3441",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI AWD",
      "CO2 (g/mi)": "314.8266",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "KIZASHI FWD",
      "CO2 (g/mi)": "301.6482",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 2WD",
      "CO2 (g/mi)": "296.8269",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SUZUKI",
      "Represented Test Veh Model": "SX4 4WD",
      "CO2 (g/mi)": "312.7982",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Model S",
      "Represented Test Veh Model": "S1",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Model S",
      "Represented Test Veh Model": "S2",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "S3",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "222.8797967",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "337.2546768",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "419.5398048",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "252.7376817",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "287.556771",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "469.5413422",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250 AWD",
      "CO2 (g/mi)": "232.264289",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250/IS 250C",
      "CO2 (g/mi)": "327.5932197",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350 AWD",
      "CO2 (g/mi)": "244.8879836",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350/IS 350C",
      "CO2 (g/mi)": "235.1906137",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS F",
      "CO2 (g/mi)": "276.6657778",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.7875086",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L AWD",
      "CO2 (g/mi)": "458.914436",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "397.9446499",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "365.419759",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "388.3262057",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "262.5109038",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "215.3292345",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "217.1822011",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iQ",
      "CO2 (g/mi)": "229.2161468",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iQ EV",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "tC",
      "CO2 (g/mi)": "299.1152855",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "419.5139867",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "298.4722884",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "186.9175648",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid LE",
      "CO2 (g/mi)": "156.5325481",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid XLE",
      "CO2 (g/mi)": "157.2902683",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "177.5084434",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA MATRIX",
      "CO2 (g/mi)": "345.9091036",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 2WD",
      "CO2 (g/mi)": "304.3",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 4WD",
      "CO2 (g/mi)": "427.2257772",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 2WD",
      "CO2 (g/mi)": "415.8852753",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER 4WD",
      "CO2 (g/mi)": "281.2777708",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID 4WD",
      "CO2 (g/mi)": "233.1757027",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "362.4384054",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "130.8100637",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "180.1866934",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Plug-in Hybrid",
      "CO2 (g/mi)": "180.7904938",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS v",
      "CO2 (g/mi)": "148.3199728",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "293.4932214",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "218.0924634",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Toyota",
      "Represented Test Veh Model": "RAV4 EV",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 Limited AWD",
      "CO2 (g/mi)": "214.4620557",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xB",
      "CO2 (g/mi)": "318.8867968",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xD",
      "CO2 (g/mi)": "250.892098",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "550.6731501",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "566.5345276",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "399.0053779",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "273.4205755",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "418.1035893",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "309.4667811",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TOYOTA TUNDRA 2WD",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "524.5673731",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "560.4281712",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "364.1309207",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA",
      "CO2 (g/mi)": "374.2102674",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "252.2302394",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A8 W12",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta Hybrid",
      "CO2 (g/mi)": "155",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "JETTA SPORTWAGEN",
      "CO2 (g/mi)": "269.5674712",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "NMS",
      "CO2 (g/mi)": "364",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat wagon",
      "CO2 (g/mi)": "348",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "207",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "266.6770044",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C30 T5 FWD",
      "CO2 (g/mi)": "308",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "C70 T5 FWD",
      "CO2 (g/mi)": "224.3959778",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "311",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "473",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD",
      "CO2 (g/mi)": "352",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD PZEV",
      "CO2 (g/mi)": "364",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD PZEV",
      "CO2 (g/mi)": "402",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 FWD",
      "CO2 (g/mi)": "374",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 AWD 3.2",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "267",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD PZEV",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 3.2 AWD",
      "CO2 (g/mi)": "455",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 FWD 3.2",
      "CO2 (g/mi)": "271",
    },
    {
      "Model Year": "2013",
      "Represented Test Veh Make": "VPG",
      "Represented Test Veh Model": "MV-1",
      "CO2 (g/mi)": "538.4",
    },
  ],
  2014: [
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "550.27",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE",
      "CO2 (g/mi)": "551.4037",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE S",
      "CO2 (g/mi)": "529.36",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "303",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "292",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "352",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A5",
      "CO2 (g/mi)": "343",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "309",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 quattro",
      "CO2 (g/mi)": "422",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "297",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "483",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5 Hybrid",
      "CO2 (g/mi)": "323",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "458",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "552",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS5",
      "CO2 (g/mi)": "541",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS7",
      "CO2 (g/mi)": "467",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "396",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S7",
      "CO2 (g/mi)": "484",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8",
      "CO2 (g/mi)": "569",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT Coupe",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT COUPE QUATTRO",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT",
      "CO2 (g/mi)": "632",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "TIGUAN",
      "CO2 (g/mi)": "421",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Mulsanne",
      "CO2 (g/mi)": "690.22275",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i",
      "CO2 (g/mi)": "290.8360369",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i",
      "CO2 (g/mi)": "301.19",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i xDrive",
      "CO2 (g/mi)": "299.04",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d",
      "CO2 (g/mi)": "241.11",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d Sports Wagon xDrive",
      "CO2 (g/mi)": "165.86",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive",
      "CO2 (g/mi)": "166.81",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "175.1535785",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive",
      "CO2 (g/mi)": "306.26",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive Gran Turismo",
      "CO2 (g/mi)": "312.82",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive Sports Wagon",
      "CO2 (g/mi)": "325.93",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i",
      "CO2 (g/mi)": "338.72",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive",
      "CO2 (g/mi)": "352.79",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive Gran Turismo",
      "CO2 (g/mi)": "350.09",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Convertible xDrive",
      "CO2 (g/mi)": "323.42",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Coupe",
      "CO2 (g/mi)": "318.73",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Convertible",
      "CO2 (g/mi)": "342.41",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Coupe",
      "CO2 (g/mi)": "357.41",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i xDrive Coupe",
      "CO2 (g/mi)": "368.85",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "291.97",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i xDrive",
      "CO2 (g/mi)": "302.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535d",
      "CO2 (g/mi)": "304.08",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535d xDrive",
      "CO2 (g/mi)": "307.45",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "368.27",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "236.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive",
      "CO2 (g/mi)": "353.9",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "385.56",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "403.64",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i Gran Turismo",
      "CO2 (g/mi)": "435.73",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive",
      "CO2 (g/mi)": "257.61",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "472.5361654",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.56",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Coupe",
      "CO2 (g/mi)": "343.14",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Convertible",
      "CO2 (g/mi)": "350.43",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Coupe",
      "CO2 (g/mi)": "351.66",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.25",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Coupe",
      "CO2 (g/mi)": "257.3810855",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Convertible",
      "CO2 (g/mi)": "458.96",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Coupe",
      "CO2 (g/mi)": "424.2",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li",
      "CO2 (g/mi)": "219.65",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li xDrive",
      "CO2 (g/mi)": "362.85",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "428.57",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750Li",
      "CO2 (g/mi)": "259.7",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750Li xDrive",
      "CO2 (g/mi)": "430.34",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "760Li",
      "CO2 (g/mi)": "574.75",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 3",
      "CO2 (g/mi)": "200.3050615",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 5",
      "CO2 (g/mi)": "351.06",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7",
      "CO2 (g/mi)": "327.44",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB",
      "CO2 (g/mi)": "442.29",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB xDrive",
      "CO2 (g/mi)": "492.9",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 BEV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 REX",
      "CO2 (g/mi)": "169.44",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I8",
      "CO2 (g/mi)": "398.92",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i",
      "CO2 (g/mi)": "338.64",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "485.57",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.39",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "307.64",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "340.63",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive35i",
      "CO2 (g/mi)": "395.82",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "328.21",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "250.2012308",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive35i",
      "CO2 (g/mi)": "365.02",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "328.54",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "373.51",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "493.47",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "262.19",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "499.95",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDriveM",
      "CO2 (g/mi)": "553.27",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive28i",
      "CO2 (g/mi)": "317.6040369",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35i",
      "CO2 (g/mi)": "378.69",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35is",
      "CO2 (g/mi)": "235.78",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works",
      "CO2 (g/mi)": "198.4124197",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works All4 Countryman",
      "CO2 (g/mi)": "324.84",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works Clubman",
      "CO2 (g/mi)": "284.47",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works Convertible",
      "CO2 (g/mi)": "288.67",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Clubman",
      "CO2 (g/mi)": "248.85",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper",
      "CO2 (g/mi)": "244.47",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper (3-doors)",
      "CO2 (g/mi)": "233.41",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "256.62",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "194.0098079",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "210.72",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S",
      "CO2 (g/mi)": "268.9",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (3-doors)",
      "CO2 (g/mi)": "248.06",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "268.96",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "276.81",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "195.52",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman All4",
      "CO2 (g/mi)": "206.8516239",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Veyron Super Sport",
      "CO2 (g/mi)": "885",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.32014",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
      "CO2 (g/mi)": "358.46755",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "239.073",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.51335",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.56653",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Caliber",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.55036",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "396.90016",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.399",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Dart",
      "CO2 (g/mi)": "252.42547",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "381.31731",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "411",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM PICKUP",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "247",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "294",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee",
      "CO2 (g/mi)": "339.48839",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "252.869",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "206.9866687",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 2WD",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 4WD",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "340.22632",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass FWD",
      "CO2 (g/mi)": "332.6879415",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "290.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "377.9",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.07996",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.88845",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.34155",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "415.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "5500 4X2",
      "CO2 (g/mi)": "387.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "6000#  4X2",
      "CO2 (g/mi)": "261.3457495",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ram",
      "Represented Test Veh Model": "Ram",
      "CO2 (g/mi)": "418.1225622",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SRT",
      "Represented Test Veh Model": "Viper",
      "CO2 (g/mi)": "614.21549",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "458 Italia Spyder",
      "CO2 (g/mi)": "514.92",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California",
      "CO2 (g/mi)": "500.95",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Berlinetta",
      "CO2 (g/mi)": "596.476",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "FF",
      "CO2 (g/mi)": "628.71",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "LaFerrari",
      "CO2 (g/mi)": "615.395",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max (PHEV)",
      "CO2 (g/mi)": "172.8648383",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max HEV FWD",
      "CO2 (g/mi)": "169.7150958",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "E-350 Extended Wagon",
      "CO2 (g/mi)": "543",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E150 VAN",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E250 VAN",
      "CO2 (g/mi)": "539.863",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "E350 EXTENDED WAGON",
      "CO2 (g/mi)": "700",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EDGE FWD",
      "CO2 (g/mi)": "377",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "311.603",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "309",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER 4WD",
      "CO2 (g/mi)": "279.511",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
      "CO2 (g/mi)": "353",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER FWD FFV",
      "CO2 (g/mi)": "397.136",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "452.945",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X2",
      "CO2 (g/mi)": "600",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X4 SuperCrew SVT",
      "CO2 (g/mi)": "630.4262021",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4 Supercab",
      "CO2 (g/mi)": "320.858",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup 2WD",
      "CO2 (g/mi)": "563.089",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 2WD",
      "CO2 (g/mi)": "446.479",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Pickup FFV 4WD",
      "CO2 (g/mi)": "441.819",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
      "CO2 (g/mi)": "473.486",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4",
      "CO2 (g/mi)": "463.898",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 SUPER CAB",
      "CO2 (g/mi)": "374.375",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X2",
      "CO2 (g/mi)": "407.892",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "174.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA SFE",
      "CO2 (g/mi)": "211.616",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fiesta ST",
      "CO2 (g/mi)": "261",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "282",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS FFV",
      "CO2 (g/mi)": "249.137",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS PZEV",
      "CO2 (g/mi)": "259.456",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS SFE",
      "CO2 (g/mi)": "244.742",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS ST",
      "CO2 (g/mi)": "198",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "152.0873189",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion AWD",
      "CO2 (g/mi)": "322.75",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion FWD",
      "CO2 (g/mi)": "314",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "553.77",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ (HEV)",
      "CO2 (g/mi)": "175.157",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MUSTANG",
      "CO2 (g/mi)": "374.62",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Special Service Police",
      "CO2 (g/mi)": "344.826",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
      "CO2 (g/mi)": "415",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "449.629",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
      "CO2 (g/mi)": "256.32",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "389.431",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Transit Connect",
      "CO2 (g/mi)": "330.408",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN",
      "CO2 (g/mi)": "335.514",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON",
      "CO2 (g/mi)": "223.088",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT FWD",
      "CO2 (g/mi)": "228.281",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "EXPEDITION 4X2",
      "CO2 (g/mi)": "518.335",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKS FWD",
      "CO2 (g/mi)": "370.595",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "425",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKTLivery",
      "CO2 (g/mi)": "343.419",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKZ AWD",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4",
      "CO2 (g/mi)": "379.327",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT",
      "CO2 (g/mi)": "656.0930176",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LINCOLN",
      "Represented Test Veh Model": "NAVIGATOR 4X4 EXT.",
      "CO2 (g/mi)": "594.9089966",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4GT69",
      "CO2 (g/mi)": "411.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCLAVE AWD",
      "CO2 (g/mi)": "442.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "214.5406179",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "422.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "361.136",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL AWD",
      "CO2 (g/mi)": "371.8",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "VERANO",
      "CO2 (g/mi)": "203.4610451",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DN69",
      "CO2 (g/mi)": "602.197",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DP35",
      "CO2 (g/mi)": "399.586",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6K10706",
      "CO2 (g/mi)": "317.9",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6NG26",
      "CO2 (g/mi)": "381.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS",
      "CO2 (g/mi)": "336.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN",
      "CO2 (g/mi)": "268.523",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN AWD",
      "CO2 (g/mi)": "395.45",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS WAGON",
      "CO2 (g/mi)": "614.987",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "496.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX 2WD",
      "CO2 (g/mi)": "448.284",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX AWD",
      "CO2 (g/mi)": "457.828",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS",
      "CO2 (g/mi)": "319.301",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "247.3825622",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "465.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1EF37",
      "CO2 (g/mi)": "396.7",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ES37",
      "CO2 (g/mi)": "451.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LH26",
      "CO2 (g/mi)": "316.042",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LK26",
      "CO2 (g/mi)": "348.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C10 TAHOE 2WD",
      "CO2 (g/mi)": "280.961",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "493.3884152",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 SUBURBAN 2WD",
      "CO2 (g/mi)": "429.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "379.669",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "393.576",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10703",
      "CO2 (g/mi)": "280.961",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CC10903",
      "CO2 (g/mi)": "551.472",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CG13406",
      "CO2 (g/mi)": "361.8",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CHEV SS",
      "CO2 (g/mi)": "511.959",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "454.3823885",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "243.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE ECO",
      "CO2 (g/mi)": "263.7",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "330.734",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "313.887",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G1500 EXPRESS 2WD CARGO",
      "CO2 (g/mi)": "346.081",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "645.137",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "691.8",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "338.0672213",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K10 TAHOE 4WD",
      "CO2 (g/mi)": "280.961",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "430.344",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "294.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "340.772",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "255.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC 5",
      "CO2 (g/mi)": "276.9",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC RS",
      "CO2 (g/mi)": "184.776",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "161.5033025",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK EV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "233.936",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 YUKON XL AWD",
      "CO2 (g/mi)": "574.223",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL 4WD",
      "CO2 (g/mi)": "499.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN AWD",
      "CO2 (g/mi)": "443.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "290.51",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX HYBRID",
      "CO2 (g/mi)": "170.81",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 2WD",
      "CO2 (g/mi)": "355.23",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "386.6089208",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 2WD",
      "CO2 (g/mi)": "350.84",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 4WD",
      "CO2 (g/mi)": "362.05",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX HYBRID",
      "CO2 (g/mi)": "229.56",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 2WD",
      "CO2 (g/mi)": "353.07",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TL 4WD",
      "CO2 (g/mi)": "258.18",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TSX",
      "CO2 (g/mi)": "322.49",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "258.97",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "205.76",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD PHEV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC",
      "CO2 (g/mi)": "244.54",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC GX",
      "CO2 (g/mi)": "192.82",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HF",
      "CO2 (g/mi)": "154.2994228",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HYBRID",
      "CO2 (g/mi)": "144.35",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC SI",
      "CO2 (g/mi)": "335.46",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD EX",
      "CO2 (g/mi)": "303.8",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD EXL",
      "CO2 (g/mi)": "313.4694553",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD LX",
      "CO2 (g/mi)": "208.8561587",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EX",
      "CO2 (g/mi)": "310.76",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD EXL",
      "CO2 (g/mi)": "216.14",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD LX",
      "CO2 (g/mi)": "308.76",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-Z",
      "CO2 (g/mi)": "185.08",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR L4",
      "CO2 (g/mi)": "320.94",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR V6 2WD",
      "CO2 (g/mi)": "355.99",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR V6 4WD",
      "CO2 (g/mi)": "228.53",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FCX Clarity",
      "CO2 (g/mi)": "0",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT DX/LX",
      "CO2 (g/mi)": "159.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT EX",
      "CO2 (g/mi)": "159.39",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.69",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD EX",
      "CO2 (g/mi)": "250",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD TOURING",
      "CO2 (g/mi)": "401.08",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD EXL",
      "CO2 (g/mi)": "408.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD TOURING",
      "CO2 (g/mi)": "420.17",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE",
      "CO2 (g/mi)": "459.96",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "358.15",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera",
      "CO2 (g/mi)": "365.4361",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "280.8065",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra Coupe",
      "CO2 (g/mi)": "285.6865",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "287.7302",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Equus",
      "CO2 (g/mi)": "481.0397",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis",
      "CO2 (g/mi)": "384.2814",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis Coupe",
      "CO2 (g/mi)": "392.769",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis R Spec",
      "CO2 (g/mi)": "474.2824",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "265.2879347",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport",
      "CO2 (g/mi)": "365.397",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Ultimate",
      "CO2 (g/mi)": "422.8205",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "336.1468",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "184.7263",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID LIMITED",
      "CO2 (g/mi)": "157.7761198",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "364.5972",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Veloster",
      "CO2 (g/mi)": "288.0498",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "290.2238",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte Koup",
      "CO2 (g/mi)": "185.1281",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte5",
      "CO2 (g/mi)": "288.1211947",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID",
      "CO2 (g/mi)": "184.6212",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID EX",
      "CO2 (g/mi)": "189.4587",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type",
      "CO2 (g/mi)": "457.95",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type S",
      "CO2 (g/mi)": "368.27",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "369.06",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF 3.0 AWD",
      "CO2 (g/mi)": "445.78",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF 3.0 FFV",
      "CO2 (g/mi)": "407.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF Supercharged",
      "CO2 (g/mi)": "463.28",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF-R",
      "CO2 (g/mi)": "477.17",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ 3.0 AWD",
      "CO2 (g/mi)": "444.29",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ 3.0 FFV",
      "CO2 (g/mi)": "396.28",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "483.11",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL 3.0 AWD",
      "CO2 (g/mi)": "448.01",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL 3.0 FFV",
      "CO2 (g/mi)": "428.89",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Convertible",
      "CO2 (g/mi)": "286.27",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Coupe",
      "CO2 (g/mi)": "446.73",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XK-R",
      "CO2 (g/mi)": "484.2",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "LR2",
      "CO2 (g/mi)": "406.99",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "LR4",
      "CO2 (g/mi)": "500.29",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque",
      "CO2 (g/mi)": "337.2",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "529.85",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "255.1639",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra Limited",
      "CO2 (g/mi)": "251.2605",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "490.0606",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte 5",
      "CO2 (g/mi)": "300.8668",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte ECO",
      "CO2 (g/mi)": "176.2712325",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "346.3287",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "245.908",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio ECO",
      "CO2 (g/mi)": "247.2876",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona",
      "CO2 (g/mi)": "415.6292304",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "272.6405445",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "298.4447909",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul ECO dynamics",
      "CO2 (g/mi)": "208.4274996",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "243.1385721",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "834",
      "CO2 (g/mi)": "784",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR",
      "CO2 (g/mi)": "784",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LOTUS",
      "Represented Test Veh Model": "EVORA",
      "CO2 (g/mi)": "254.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora S-IPS",
      "CO2 (g/mi)": "446.145",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6",
      "CO2 (g/mi)": "477.1",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "466.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.258",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO SPORT",
      "CO2 (g/mi)": "560.136",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "300.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "277.5907688",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "263",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 AWD",
      "CO2 (g/mi)": "436.446",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 FWD",
      "CO2 (g/mi)": "406.68",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "179.51",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "232",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA5",
      "CO2 (g/mi)": "329",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "272",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "MP4-12C Coupe",
      "CO2 (g/mi)": "590.7",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "P1",
      "CO2 (g/mi)": "550.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "B-class electric drive",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250",
      "CO2 (g/mi)": "322.51",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250 (Coupe)",
      "CO2 (g/mi)": "323.82",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "352.21",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350",
      "CO2 (g/mi)": "350.85",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 (Coupe)",
      "CO2 (g/mi)": "350.95",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 4Matic (Coupe)",
      "CO2 (g/mi)": "362.91",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 550 4MATIC",
      "CO2 (g/mi)": "470.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 600",
      "CO2 (g/mi)": "616.2928055",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 63 AMG",
      "CO2 (g/mi)": "299.45",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CL 65 AMG",
      "CO2 (g/mi)": "588.7",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "265.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "293.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "304.65",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "412.49",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "268.63",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG",
      "CO2 (g/mi)": "488.77",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG 4MATIC",
      "CO2 (g/mi)": "457.97",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 250 BLUETEC",
      "CO2 (g/mi)": "276.53",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 250 BLUETEC 4MATIC",
      "CO2 (g/mi)": "288.85",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "206.79",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (convertible)",
      "CO2 (g/mi)": "432.09",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (coupe)",
      "CO2 (g/mi)": "221.57",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "215.18",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (coupe)",
      "CO2 (g/mi)": "357.52",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Station Wagon)",
      "CO2 (g/mi)": "351.34",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 HYBRID",
      "CO2 (g/mi)": "208.44",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (convertible)",
      "CO2 (g/mi)": "414.86",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (coupe)",
      "CO2 (g/mi)": "404.38",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 4MATIC",
      "CO2 (g/mi)": "262.65",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG",
      "CO2 (g/mi)": "462.37",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG 4MATIC",
      "CO2 (g/mi)": "441.43",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG S 4MATIC",
      "CO2 (g/mi)": "465.22",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG S 4MATIC (station wagon)",
      "CO2 (g/mi)": "472.03",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "615.61",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "280.47",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "513.88",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "604.77",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 63 AMG",
      "CO2 (g/mi)": "736.6",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 250 BLUETEC 4MATIC",
      "CO2 (g/mi)": "217.49",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350",
      "CO2 (g/mi)": "371.92",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350 4MATIC",
      "CO2 (g/mi)": "381.67",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "390.7",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "403.82",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "402.8",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 550 4MATIC",
      "CO2 (g/mi)": "507.62",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "520.54",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "410.66",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "436",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC",
      "CO2 (g/mi)": "565.46",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "259.41",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "448.57",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 65 AMG",
      "CO2 (g/mi)": "511.74",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 250",
      "CO2 (g/mi)": "308.38",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "218.81",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 55 AMG",
      "CO2 (g/mi)": "372.98",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLS AMG",
      "CO2 (g/mi)": "344.37",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLS AMG Black Series Coupe",
      "CO2 (g/mi)": "382.65",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo (Coupe)",
      "CO2 (g/mi)": "289.23",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo electric drive (convertible)",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "W204E63-Z1011",
      "Represented Test Veh Model": "C 63 AMG",
      "CO2 (g/mi)": "546.41",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "i-MiEV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
      "CO2 (g/mi)": "279.44774",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER EVOLUTION",
      "CO2 (g/mi)": "422.12296",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER SPORTBACK",
      "CO2 (g/mi)": "402.69605",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "197.57017",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "277.71965",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "290.48768",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "291.30131",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "286.2748",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "MBV",
      "Represented Test Veh Model": "MV-1",
      "CO2 (g/mi)": "439.1854024",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI  Q50 HYBRID PREMIUM",
      "CO2 (g/mi)": "243",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX37 AWD Journey",
      "CO2 (g/mi)": "410",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI EX37 Journey",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX37 AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX37 RWD",
      "CO2 (g/mi)": "425",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI FX50 AWD",
      "CO2 (g/mi)": "508",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Convertible Journey",
      "CO2 (g/mi)": "417",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Convertible Sport 6MT",
      "CO2 (g/mi)": "434",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Coupe Journey",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Coupe Sport 6MT",
      "CO2 (g/mi)": "410",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37x Coupe AWD",
      "CO2 (g/mi)": "402",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI JX35 AWD",
      "CO2 (g/mi)": "371",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56 Base",
      "CO2 (g/mi)": "472",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56x",
      "CO2 (g/mi)": "458",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI M56X Base",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 HYBRID PREMIUM",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM",
      "CO2 (g/mi)": "360",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM AWD",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S Q50 HYBRID SPORT 4WD",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S Q50 HYBRID SPORT AWD",
      "CO2 (g/mi)": "248",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7",
      "CO2 (g/mi)": "385.1874427",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7 AWD",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 HYBRID",
      "CO2 (g/mi)": "231",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 2WD",
      "CO2 (g/mi)": "531",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX56 4WD",
      "CO2 (g/mi)": "532",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 AWD",
      "CO2 (g/mi)": "224",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 FWD",
      "CO2 (g/mi)": "254",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA SE 5.6L 4X4",
      "CO2 (g/mi)": "577",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z Touring",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5SL",
      "CO2 (g/mi)": "254",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 3.5SV",
      "CO2 (g/mi)": "322",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Nissan Armada SE 5.6l 4x4",
      "CO2 (g/mi)": "580",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 S",
      "CO2 (g/mi)": "276",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN CUBE 1.8 SL",
      "CO2 (g/mi)": "260.079961",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD K/C SV",
      "CO2 (g/mi)": "452",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5AT",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5MT",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5AT",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5MT",
      "CO2 (g/mi)": "268",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD C/C PRO-4X",
      "CO2 (g/mi)": "494",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C PRO-4X",
      "CO2 (g/mi)": "465",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C SV",
      "CO2 (g/mi)": "489",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "427",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "196",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF S",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF SL",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA 4-DOOR SEDAN 3.5S",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA SV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD LE",
      "CO2 (g/mi)": "406.1835502",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO CrossCabriolet BASE",
      "CO2 (g/mi)": "285",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 Cargo Van S",
      "CO2 (g/mi)": "229",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 4WD Platinum",
      "CO2 (g/mi)": "370",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER Hybrid 2WD Platinum",
      "CO2 (g/mi)": "253",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER Hybrid 4WD Platinum",
      "CO2 (g/mi)": "264",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "376",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SL",
      "CO2 (g/mi)": "279",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SV",
      "CO2 (g/mi)": "235",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA S",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SL",
      "CO2 (g/mi)": "226",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN TITAN 4WD Crew Cab XE LWB",
      "CO2 (g/mi)": "608",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA S",
      "CO2 (g/mi)": "250",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA SV",
      "CO2 (g/mi)": "209",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE LWB",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE SWB",
      "CO2 (g/mi)": "596",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE-SWB",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Pagani Automobili",
      "Represented Test Veh Model": "PT4",
      "CO2 (g/mi)": "689.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "233.146011",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "371.89",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "379.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "383.59",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "388.17",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "372.03",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "378.45",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "379.07",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "488.42",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4",
      "CO2 (g/mi)": "386.36",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4S",
      "CO2 (g/mi)": "395.98",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "429.45",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "359.2",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "269.56",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "482.29",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "456.4596",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "486.11613",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo S",
      "CO2 (g/mi)": "545.5",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "396.34",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4",
      "CO2 (g/mi)": "405.76",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "416.79",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "426.68",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS",
      "CO2 (g/mi)": "472.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera S E-Hybrid",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "483.26",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "487.13",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "469.58",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "348.29",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom EWB",
      "CO2 (g/mi)": "538.77",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "577.03",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "E350 Cutaway",
      "CO2 (g/mi)": "620.8707361",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "611.2",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "294.4",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "RUF",
      "Represented Test Veh Model": "TURBO 12/CTR 3",
      "CO2 (g/mi)": "513.47",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "231.34772",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA AWD",
      "CO2 (g/mi)": "261",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON/OUTBACK SPORT AWD",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WGN/OUTBACK SPT AWD",
      "CO2 (g/mi)": "415.3185",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY AWD",
      "CO2 (g/mi)": "289.8171623",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY SDN 4WD",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK WAGON AWD",
      "CO2 (g/mi)": "292",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "TRIBECA AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "XV Crosstrek",
      "CO2 (g/mi)": "233.517111",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "XV CROSSTREK AWD",
      "CO2 (g/mi)": "275",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Model S",
      "Represented Test Veh Model": "S2",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P85D",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "S3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "222.8797967",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "337.2546768",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "450.3556386",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "244.155431",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "300.30772",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "315.1462204",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250",
      "CO2 (g/mi)": "209.2162214",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250 AWD",
      "CO2 (g/mi)": "232.141214",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250/IS 250C",
      "CO2 (g/mi)": "327.5932197",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350",
      "CO2 (g/mi)": "436.019967",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350 AWD",
      "CO2 (g/mi)": "457.4575183",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350/IS 350C",
      "CO2 (g/mi)": "235.1906137",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS F",
      "CO2 (g/mi)": "276.6657778",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "432.5436445",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L AWD",
      "CO2 (g/mi)": "458.914436",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "397.9446499",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "365.419759",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "388.3262057",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "262.5109038",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "215.3292345",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "217.1822011",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iQ",
      "CO2 (g/mi)": "229.2161468",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "tC",
      "CO2 (g/mi)": "199.7433482",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "419.5139867",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "298.4722884",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "276.8714861",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid LE",
      "CO2 (g/mi)": "156.5325481",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid XLE",
      "CO2 (g/mi)": "157.2902683",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "250.3427994",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA LE ECO",
      "CO2 (g/mi)": "219.3207439",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 2WD",
      "CO2 (g/mi)": "304.3",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "FJ CRUISER 4WD",
      "CO2 (g/mi)": "427.2257772",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "388.8461536",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "391.9383457",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "341.6673586",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LE Plus",
      "CO2 (g/mi)": "290.0017833",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "362.4384054",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "130.8100637",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "180.1866934",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Plug-in Hybrid",
      "CO2 (g/mi)": "180.7904938",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS v",
      "CO2 (g/mi)": "148.3199728",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "293.4932214",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "218.0924634",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Toyota",
      "Represented Test Veh Model": "RAV4 EV",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 Limited AWD",
      "CO2 (g/mi)": "214.4620557",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xB",
      "CO2 (g/mi)": "318.8867968",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xD",
      "CO2 (g/mi)": "250.892098",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "550.6731501",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "374.2080431",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "566.5345276",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "255.0882384",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "273.4205755",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "418.1035893",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "309.4667811",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "524.5673731",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "560.4281712",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "364.1309207",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA",
      "CO2 (g/mi)": "374.2102674",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "252.2302394",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A8 W12",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "272",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "314",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta Hybrid",
      "CO2 (g/mi)": "155",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "JETTA SPORTWAGEN",
      "CO2 (g/mi)": "269.5674712",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "NMS",
      "CO2 (g/mi)": "364",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat wagon",
      "CO2 (g/mi)": "348",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "207",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "266.6770044",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "311",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "473",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S80 3.2 FWD",
      "CO2 (g/mi)": "352",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD PZEV",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 FWD",
      "CO2 (g/mi)": "236.3969137",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "405",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD PZEV",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 T6 AWD",
      "CO2 (g/mi)": "371",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 3.2 AWD",
      "CO2 (g/mi)": "442",
    },
    {
      "Model Year": "2014",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 3.2 FWD",
      "CO2 (g/mi)": "430",
    },
  ],
  2015: [
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "550.27",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide S",
      "CO2 (g/mi)": "511.93",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V12 Vantage S",
      "CO2 (g/mi)": "603.49",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE",
      "CO2 (g/mi)": "551.4037",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE S",
      "CO2 (g/mi)": "529.36",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vanquish",
      "CO2 (g/mi)": "536.18",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "292",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "309",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 quattro",
      "CO2 (g/mi)": "422",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "297",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5 Hybrid",
      "CO2 (g/mi)": "323",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "458",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "647",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS5",
      "CO2 (g/mi)": "541",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS7",
      "CO2 (g/mi)": "467",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "396",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S7",
      "CO2 (g/mi)": "484",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT Coupe",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT COUPE QUATTRO",
      "CO2 (g/mi)": "378",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT",
      "CO2 (g/mi)": "555",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Bentley",
      "Represented Test Veh Model": "Mulsanne",
      "CO2 (g/mi)": "690.22275",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i",
      "CO2 (g/mi)": "290.8360369",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i Convertible",
      "CO2 (g/mi)": "292.05",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i xDrive Convertible",
      "CO2 (g/mi)": "308.62",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i",
      "CO2 (g/mi)": "301.19",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i xDrive",
      "CO2 (g/mi)": "299.04",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d",
      "CO2 (g/mi)": "241.11",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d Sports Wagon xDrive",
      "CO2 (g/mi)": "165.86",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive",
      "CO2 (g/mi)": "166.81",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "175.1535785",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive",
      "CO2 (g/mi)": "306.26",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive Gran Turismo",
      "CO2 (g/mi)": "314.06",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive Sports Wagon",
      "CO2 (g/mi)": "329.73",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i",
      "CO2 (g/mi)": "338.72",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive",
      "CO2 (g/mi)": "352.79",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive Gran Turismo",
      "CO2 (g/mi)": "350.09",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Convertible",
      "CO2 (g/mi)": "309.37",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Convertible xDrive",
      "CO2 (g/mi)": "323.42",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Coupe",
      "CO2 (g/mi)": "318.73",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Gran Coupe",
      "CO2 (g/mi)": "300.53",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i xDrive",
      "CO2 (g/mi)": "302.74",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i xDrive Gran Coupe",
      "CO2 (g/mi)": "308.63",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Convertible",
      "CO2 (g/mi)": "342.41",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Coupe",
      "CO2 (g/mi)": "357.41",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Gran Coupe",
      "CO2 (g/mi)": "328.13",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i xDrive Coupe",
      "CO2 (g/mi)": "368.85",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "291.97",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i xDrive",
      "CO2 (g/mi)": "302.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535d",
      "CO2 (g/mi)": "304.08",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535d xDrive",
      "CO2 (g/mi)": "307.45",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "336.4",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "236.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive",
      "CO2 (g/mi)": "353.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "385.56",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "408.39",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i Gran Turismo",
      "CO2 (g/mi)": "435.73",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive",
      "CO2 (g/mi)": "254.21",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "472.5361654",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.56",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Coupe",
      "CO2 (g/mi)": "343.14",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Convertible",
      "CO2 (g/mi)": "361.19",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Coupe",
      "CO2 (g/mi)": "355",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.25",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Coupe",
      "CO2 (g/mi)": "257.3810855",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Convertible",
      "CO2 (g/mi)": "458.96",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Coupe",
      "CO2 (g/mi)": "424.2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Ld xDrive",
      "CO2 (g/mi)": "334.88",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li",
      "CO2 (g/mi)": "219.65",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740Li xDrive",
      "CO2 (g/mi)": "362.85",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "428.57",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750Li",
      "CO2 (g/mi)": "259.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750Li xDrive",
      "CO2 (g/mi)": "430.34",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "760Li",
      "CO2 (g/mi)": "574.75",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 3",
      "CO2 (g/mi)": "200.3050615",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 5",
      "CO2 (g/mi)": "351.06",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 7",
      "CO2 (g/mi)": "327.44",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB",
      "CO2 (g/mi)": "442.29",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB xDrive",
      "CO2 (g/mi)": "492.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 BEV",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 REX",
      "CO2 (g/mi)": "169.44",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I8",
      "CO2 (g/mi)": "398.92",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i",
      "CO2 (g/mi)": "338.64",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i Convertible",
      "CO2 (g/mi)": "342.58",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i xDrive",
      "CO2 (g/mi)": "341.97",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "482.93",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Convertible",
      "CO2 (g/mi)": "364.59",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Coupe",
      "CO2 (g/mi)": "236.366618",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "485.57",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.39",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "307.64",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "340.63",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive35i",
      "CO2 (g/mi)": "395.82",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive 28d",
      "CO2 (g/mi)": "282.5",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "322.65",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "382.5934697",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive 28i",
      "CO2 (g/mi)": "345.56",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive35i",
      "CO2 (g/mi)": "372.08",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M",
      "CO2 (g/mi)": "491.62",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive35i",
      "CO2 (g/mi)": "365.02",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive 35d",
      "CO2 (g/mi)": "326.34",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive 50i",
      "CO2 (g/mi)": "474.6",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "373.51",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive 35i",
      "CO2 (g/mi)": "403.85",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive 50i",
      "CO2 (g/mi)": "470.2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive28i",
      "CO2 (g/mi)": "317.6040369",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35is",
      "CO2 (g/mi)": "235.78",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works",
      "CO2 (g/mi)": "198.4124197",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works All4 Countryman",
      "CO2 (g/mi)": "324.84",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works Convertible",
      "CO2 (g/mi)": "288.67",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper",
      "CO2 (g/mi)": "244.47",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper (3-doors)",
      "CO2 (g/mi)": "232.51",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper (5-doors)",
      "CO2 (g/mi)": "244.0599905",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "194.0098079",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "210.72",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S",
      "CO2 (g/mi)": "268.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (3-doors)",
      "CO2 (g/mi)": "190.98",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (5-doors)",
      "CO2 (g/mi)": "265.242842",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "276.81",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "195.52",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman All4",
      "CO2 (g/mi)": "206.8516239",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI John Cooper Works Hardtop",
      "CO2 (g/mi)": "271.9708968",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Veyron Super Sport",
      "CO2 (g/mi)": "885",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.32014",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
      "CO2 (g/mi)": "300.71133",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200 AWD",
      "CO2 (g/mi)": "385.4714",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.51335",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.56653",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
      "CO2 (g/mi)": "431",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.55036",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.39543",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "413",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.399",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Dart",
      "CO2 (g/mi)": "276.59398",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "381.31731",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "411",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram",
      "CO2 (g/mi)": "353",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM PICKUP",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "247",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "192.2496321",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee",
      "CO2 (g/mi)": "339.48839",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "252.869",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "387.8945463",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "206.9866687",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "366.93647",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 2WD",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 4WD",
      "CO2 (g/mi)": "302",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "340.22632",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass FWD",
      "CO2 (g/mi)": "335",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "290.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "377.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.07996",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 2WD",
      "CO2 (g/mi)": "204.215",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.88845",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "201.8611563",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "276.08782",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.34155",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "415.3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 EcoDiesel29 4x2",
      "CO2 (g/mi)": "247.7275022",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "5500 4X2",
      "CO2 (g/mi)": "387.3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "6000#  4X2",
      "CO2 (g/mi)": "261.3457495",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SRT",
      "Represented Test Veh Model": "Viper",
      "CO2 (g/mi)": "614.21549",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "458 Italia Spyder",
      "CO2 (g/mi)": "514.92",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California T",
      "CO2 (g/mi)": "448.891",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Berlinetta",
      "CO2 (g/mi)": "596.476",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "FF",
      "CO2 (g/mi)": "628.71",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max (PHEV)",
      "CO2 (g/mi)": "172.8648383",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max HEV FWD",
      "CO2 (g/mi)": "169.7150958",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge",
      "CO2 (g/mi)": "383.191",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "316",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "199",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "497.043",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition 4x2",
      "CO2 (g/mi)": "453.336",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition 4x4",
      "CO2 (g/mi)": "486.871",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition EL 4x2",
      "CO2 (g/mi)": "488.438",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition EL 4x4",
      "CO2 (g/mi)": "497.25",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER 4WD",
      "CO2 (g/mi)": "279.511",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
      "CO2 (g/mi)": "353",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EXPLORER FWD FFV",
      "CO2 (g/mi)": "397.136",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "452.945",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X2",
      "CO2 (g/mi)": "368.207",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X2",
      "CO2 (g/mi)": "399",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4",
      "CO2 (g/mi)": "422.43",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Cab Max",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
      "CO2 (g/mi)": "260.717",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2 Super Cab",
      "CO2 (g/mi)": "359.453",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4",
      "CO2 (g/mi)": "428.204",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 Super Crew",
      "CO2 (g/mi)": "274.355",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X2",
      "CO2 (g/mi)": "449.71",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X4",
      "CO2 (g/mi)": "509.07",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "174.5",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA SFE",
      "CO2 (g/mi)": "211.616",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fiesta ST",
      "CO2 (g/mi)": "261",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "451",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS FFV",
      "CO2 (g/mi)": "254",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS ST",
      "CO2 (g/mi)": "301",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "152.0873189",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion AWD",
      "CO2 (g/mi)": "322.75",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion FWD",
      "CO2 (g/mi)": "324",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "404",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ (HEV)",
      "CO2 (g/mi)": "175.157",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
      "CO2 (g/mi)": "379.535697",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Special Service Police",
      "CO2 (g/mi)": "344.826",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T150 FFV Wagon",
      "CO2 (g/mi)": "517",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T150 Transit Van",
      "CO2 (g/mi)": "348.759",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
      "CO2 (g/mi)": "418.769",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
      "CO2 (g/mi)": "364",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "449.629",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
      "CO2 (g/mi)": "256.32",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "389.431",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Transit Connect",
      "CO2 (g/mi)": "213.315",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN",
      "CO2 (g/mi)": "335.514",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON",
      "CO2 (g/mi)": "223.088",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT FWD",
      "CO2 (g/mi)": "228.281",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKC",
      "CO2 (g/mi)": "390",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKS FWD",
      "CO2 (g/mi)": "370.595",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "425",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKTLivery",
      "CO2 (g/mi)": "343.419",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "400.863",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKZ AWD",
      "CO2 (g/mi)": "393",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator L 4x2",
      "CO2 (g/mi)": "485.098",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator L 4x4",
      "CO2 (g/mi)": "493.4242136",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "4GT69",
      "CO2 (g/mi)": "411.4",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCLAVE AWD",
      "CO2 (g/mi)": "431.4",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "173.6",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "414.936",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "361.136",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL AWD",
      "CO2 (g/mi)": "371.8",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "VERANO",
      "CO2 (g/mi)": "203.4610451",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "6DN69",
      "CO2 (g/mi)": "513.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS",
      "CO2 (g/mi)": "364.085",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN",
      "CO2 (g/mi)": "344.171",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN AWD",
      "CO2 (g/mi)": "384.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS WAGON",
      "CO2 (g/mi)": "614.987",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "479.977",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX 2WD",
      "CO2 (g/mi)": "417.204",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX AWD",
      "CO2 (g/mi)": "457.828",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS",
      "CO2 (g/mi)": "422.811",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "448.201",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "489.612",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1EF37",
      "CO2 (g/mi)": "396.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1ES37",
      "CO2 (g/mi)": "451.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LH26",
      "CO2 (g/mi)": "316.042",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LK26",
      "CO2 (g/mi)": "348.5",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "490.367",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 SUBURBAN 2WD",
      "CO2 (g/mi)": "442.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "379.669",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "393.576",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CHEV SS",
      "CO2 (g/mi)": "511.959",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "366.131",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "252.885387",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO CAB CHASSIS 2WD",
      "CO2 (g/mi)": "481.675",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "421.225",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "243.361",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE ECO",
      "CO2 (g/mi)": "266.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "429.3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "313.887",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "645.137",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "691.8",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "396.86",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "430.344",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 SUBURBAN 4WD",
      "CO2 (g/mi)": "476.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "285.423",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "340.772",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "255.4",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC 5",
      "CO2 (g/mi)": "276.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC RS",
      "CO2 (g/mi)": "184.776",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "161.5033025",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK EV",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX",
      "CO2 (g/mi)": "202.119",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "233.936",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL 4WD",
      "CO2 (g/mi)": "497.074",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K2500 YUKON XL 4WD",
      "CO2 (g/mi)": "711",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "331.2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 2WD",
      "CO2 (g/mi)": "355.23",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "386.6089208",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 2WD",
      "CO2 (g/mi)": "350.84",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 4WD",
      "CO2 (g/mi)": "362.05",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX",
      "CO2 (g/mi)": "281.1647093",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "288.57",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "205.76",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC",
      "CO2 (g/mi)": "244.54",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC GX",
      "CO2 (g/mi)": "192.82",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HF",
      "CO2 (g/mi)": "154.2994228",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC HYBRID",
      "CO2 (g/mi)": "144.35",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC SI",
      "CO2 (g/mi)": "335.46",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD",
      "CO2 (g/mi)": "265.4914783",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD",
      "CO2 (g/mi)": "272.073919",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-Z",
      "CO2 (g/mi)": "185.08",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR L4",
      "CO2 (g/mi)": "320.94",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR V6 2WD",
      "CO2 (g/mi)": "355.99",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CROSSTOUR V6 4WD",
      "CO2 (g/mi)": "228.53",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EX",
      "CO2 (g/mi)": "208.26",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT LX",
      "CO2 (g/mi)": "232.04",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.69",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD EX",
      "CO2 (g/mi)": "250",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD TOURING",
      "CO2 (g/mi)": "401.08",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD EXL",
      "CO2 (g/mi)": "408.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD TOURING",
      "CO2 (g/mi)": "420.17",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "358.15",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera",
      "CO2 (g/mi)": "359.5251996",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera Limited",
      "CO2 (g/mi)": "375.7709",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "280.8065",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra Coupe",
      "CO2 (g/mi)": "285.6865",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "287.7302",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra Limited",
      "CO2 (g/mi)": "253.8639",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Equus",
      "CO2 (g/mi)": "481.0397",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis",
      "CO2 (g/mi)": "255.0800646",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis Coupe",
      "CO2 (g/mi)": "452.2789",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "265.2879347",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport",
      "CO2 (g/mi)": "365.397",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport ULTIMATE",
      "CO2 (g/mi)": "368.2011",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Ultimate",
      "CO2 (g/mi)": "422.8205",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "199.7241153",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "184.7263",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID LIMITED",
      "CO2 (g/mi)": "157.7761198",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "364.5972",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson Fuel Cell",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Veloster",
      "CO2 (g/mi)": "288.0498",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID",
      "CO2 (g/mi)": "184.6212",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID EX",
      "CO2 (g/mi)": "189.4587",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type",
      "CO2 (g/mi)": "457.95",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type S",
      "CO2 (g/mi)": "368.27",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "369.06",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF 3.0 2WD",
      "CO2 (g/mi)": "389.36",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "419.5",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF Supercharged",
      "CO2 (g/mi)": "463.28",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF-R",
      "CO2 (g/mi)": "477.17",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ 3.0 AWD",
      "CO2 (g/mi)": "444.29",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ 3.0 FFV",
      "CO2 (g/mi)": "396.28",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "483.11",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL 3.0 AWD",
      "CO2 (g/mi)": "448.01",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL 3.0 FFV",
      "CO2 (g/mi)": "428.89",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Convertible",
      "CO2 (g/mi)": "286.27",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "JAGUAR",
      "Represented Test Veh Model": "XK Coupe",
      "CO2 (g/mi)": "446.73",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XK-R",
      "CO2 (g/mi)": "484.2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport",
      "CO2 (g/mi)": "355",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "LR2",
      "CO2 (g/mi)": "406.99",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "LR4",
      "CO2 (g/mi)": "492.06",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover 3.0 PZEV",
      "CO2 (g/mi)": "420.89",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque",
      "CO2 (g/mi)": "337.2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "529.85",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "255.1639",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "490.0606",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "283.6807",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte 5",
      "CO2 (g/mi)": "278.7531",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte Koup",
      "CO2 (g/mi)": "316.2032",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte5",
      "CO2 (g/mi)": "324.8977",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900",
      "CO2 (g/mi)": "470.3812",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "346.3287",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Quoris",
      "CO2 (g/mi)": "239.5655333",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "245.908",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio ECO",
      "CO2 (g/mi)": "247.2876",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona",
      "CO2 (g/mi)": "402.4325",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SX",
      "CO2 (g/mi)": "391.9028",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SXL",
      "CO2 (g/mi)": "433.0131",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "272.6405445",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "298.4447909",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul ECO dynamics",
      "CO2 (g/mi)": "208.4274996",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul electric",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "243.1385721",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "834",
      "CO2 (g/mi)": "784",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR",
      "CO2 (g/mi)": "784",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6",
      "CO2 (g/mi)": "477.1",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "466.6",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.258",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO SPORT",
      "CO2 (g/mi)": "560.136",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "541.3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "277.5907688",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "263",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 AWD",
      "CO2 (g/mi)": "436.446",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-9 FWD",
      "CO2 (g/mi)": "406.68",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "232",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA5",
      "CO2 (g/mi)": "317",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "274",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "306",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "MP4-12C Coupe",
      "CO2 (g/mi)": "451.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "P1",
      "CO2 (g/mi)": "550.3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63",
      "CO2 (g/mi)": "403.61",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "B-class electric drive",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 250 (Coupe)",
      "CO2 (g/mi)": "323.82",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "186.36",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "287.05",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 (Coupe)",
      "CO2 (g/mi)": "350.95",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350 4Matic (Coupe)",
      "CO2 (g/mi)": "362.91",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 400 4MATIC",
      "CO2 (g/mi)": "331.61",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "265.6",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "285.44",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "304.65",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 400",
      "CO2 (g/mi)": "346.74",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 400 4MATIC",
      "CO2 (g/mi)": "242.0995605",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "404.89",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "268.63",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG 4MATIC",
      "CO2 (g/mi)": "457.97",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 250 BLUETEC",
      "CO2 (g/mi)": "276.53",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 250 BLUETEC 4MATIC",
      "CO2 (g/mi)": "288.85",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "218.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (convertible)",
      "CO2 (g/mi)": "223.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 (coupe)",
      "CO2 (g/mi)": "223.5570741",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "215.18",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Station Wagon)",
      "CO2 (g/mi)": "351.34",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400",
      "CO2 (g/mi)": "344.95",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (convertible)",
      "CO2 (g/mi)": "342.17",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (coupe)",
      "CO2 (g/mi)": "345.11",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC",
      "CO2 (g/mi)": "357.58",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (coupe)",
      "CO2 (g/mi)": "349.99",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (station wagon)",
      "CO2 (g/mi)": "371.53",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 HYBRID",
      "CO2 (g/mi)": "293.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (convertible)",
      "CO2 (g/mi)": "414.86",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (coupe)",
      "CO2 (g/mi)": "404.38",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG 4MATIC",
      "CO2 (g/mi)": "441.43",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG S 4MATIC",
      "CO2 (g/mi)": "465.22",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG S 4MATIC (station wagon)",
      "CO2 (g/mi)": "461.51",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "615.61",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "280.47",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "421.19",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "604.77",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 63 AMG",
      "CO2 (g/mi)": "736.6",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "275.05",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "287.39",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "302.57",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 250 BLUETEC 4MATIC",
      "CO2 (g/mi)": "217.49",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350",
      "CO2 (g/mi)": "371.92",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLK 350 4MATIC",
      "CO2 (g/mi)": "392.2488893",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 250 BlueTEC 4MATIC",
      "CO2 (g/mi)": "233.16",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "390.7",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "403.82",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 400 4MATIC",
      "CO2 (g/mi)": "395.68",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "520.54",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "410.66",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "436",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC (coupe)",
      "CO2 (g/mi)": "435.39",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 e",
      "CO2 (g/mi)": "294.63",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "565.9387899",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC",
      "CO2 (g/mi)": "565.46",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC (coupe)",
      "CO2 (g/mi)": "465.13",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG",
      "CO2 (g/mi)": "562.9",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG (coupe)",
      "CO2 (g/mi)": "316.0550386",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 400",
      "CO2 (g/mi)": "352.39",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "404.49",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "448.57",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 65 AMG",
      "CO2 (g/mi)": "511.74",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 250",
      "CO2 (g/mi)": "308.38",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "218.81",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 55 AMG",
      "CO2 (g/mi)": "372.98",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLS AMG",
      "CO2 (g/mi)": "344.37",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo (Coupe)",
      "CO2 (g/mi)": "289.23",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo electric drive (convertible)",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "W204E63-Z1011",
      "Represented Test Veh Model": "C 63 AMG",
      "CO2 (g/mi)": "546.41",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
      "CO2 (g/mi)": "279.44774",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER EVOLUTION",
      "CO2 (g/mi)": "422.12296",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER SPORTBACK",
      "CO2 (g/mi)": "402.69605",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "197.57017",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "277.71965",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "290.48768",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "291.30131",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "279.74055",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI  Q50 HYBRID PREMIUM",
      "CO2 (g/mi)": "243",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Convertible Journey",
      "CO2 (g/mi)": "417",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Convertible Sport 6MT",
      "CO2 (g/mi)": "434",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Coupe Journey",
      "CO2 (g/mi)": "395",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37 Coupe Sport 6MT",
      "CO2 (g/mi)": "410",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI G37x Coupe AWD",
      "CO2 (g/mi)": "402",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 HYBRID PREMIUM",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM",
      "CO2 (g/mi)": "360",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM AWD",
      "CO2 (g/mi)": "382",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S Q50 HYBRID SPORT 4WD",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S Q50 HYBRID SPORT AWD",
      "CO2 (g/mi)": "248",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7",
      "CO2 (g/mi)": "385.1874427",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7 AWD",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 AWD 5.6",
      "CO2 (g/mi)": "460",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 HYBRID",
      "CO2 (g/mi)": "231",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX50 AWD Journey",
      "CO2 (g/mi)": "409",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX50 Journey",
      "CO2 (g/mi)": "403",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 AWD",
      "CO2 (g/mi)": "246",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 FWD",
      "CO2 (g/mi)": "256",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX70 AWD",
      "CO2 (g/mi)": "444",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX70 RWD",
      "CO2 (g/mi)": "420",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 4WD",
      "CO2 (g/mi)": "518",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 4WD LIMITED",
      "CO2 (g/mi)": "548",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA SE 5.6L 4X4",
      "CO2 (g/mi)": "577",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z Touring",
      "CO2 (g/mi)": "393",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA 2.5SL",
      "CO2 (g/mi)": "254",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA SL",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Nissan Armada SE 5.6l 4x4",
      "CO2 (g/mi)": "580",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD K/C SV",
      "CO2 (g/mi)": "438",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5AT",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5MT",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5AT",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5MT",
      "CO2 (g/mi)": "268",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD C/C PRO-4X",
      "CO2 (g/mi)": "490",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C PRO-4X",
      "CO2 (g/mi)": "465",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C SV",
      "CO2 (g/mi)": "440",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "427",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE AWD SL",
      "CO2 (g/mi)": "202",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE NISMO RS",
      "CO2 (g/mi)": "201",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SL",
      "CO2 (g/mi)": "249.6500897",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "277",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF S",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF SL",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD  SL",
      "CO2 (g/mi)": "336",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD SL",
      "CO2 (g/mi)": "216.3253593",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 Cargo Van S",
      "CO2 (g/mi)": "358",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 NYC Taxi STD",
      "CO2 (g/mi)": "341",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 4WD S",
      "CO2 (g/mi)": "243",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER Hybrid 2WD Platinum",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER Hybrid 4WD Platinum",
      "CO2 (g/mi)": "266",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "365",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SL",
      "CO2 (g/mi)": "279",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SV",
      "CO2 (g/mi)": "246",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA S",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SL",
      "CO2 (g/mi)": "222",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SR",
      "CO2 (g/mi)": "234",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN TITAN 4WD Crew Cab XE LWB",
      "CO2 (g/mi)": "608",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA NOTE S",
      "CO2 (g/mi)": "247",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA NOTE SV",
      "CO2 (g/mi)": "215",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA S",
      "CO2 (g/mi)": "264",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA SV",
      "CO2 (g/mi)": "214",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE LWB",
      "CO2 (g/mi)": "570",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE SWB",
      "CO2 (g/mi)": "596",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN KING-5.6LE-SWB",
      "CO2 (g/mi)": "559",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "233.146011",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "371.89",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "379.4",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "383.59",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "388.17",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Kit",
      "CO2 (g/mi)": "386.18",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Kit Cabriolet",
      "CO2 (g/mi)": "254.32",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "372.03",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "378.45",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "379.07",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Kit",
      "CO2 (g/mi)": "392.47",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Kit Cabriolet",
      "CO2 (g/mi)": "396.27",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "488.42",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4",
      "CO2 (g/mi)": "386.36",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4S",
      "CO2 (g/mi)": "395.98",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "429.45",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "918 Spyder",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "359.2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "419.99",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S e-Hybrid",
      "CO2 (g/mi)": "335.77",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "306.41142",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman GTS",
      "CO2 (g/mi)": "366.48",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "418.49",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo",
      "CO2 (g/mi)": "275.7519138",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "396.34",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4",
      "CO2 (g/mi)": "405.76",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "416.79",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "426.68",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS",
      "CO2 (g/mi)": "472.3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera S E-Hybrid",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "483.26",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "487.13",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Quantum Impala",
      "Represented Test Veh Model": "Impala dual fuel",
      "CO2 (g/mi)": "472.84",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "469.58",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "348.29",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom EWB",
      "CO2 (g/mi)": "538.77",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "577.03",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "532.7471",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "231.34772",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA",
      "CO2 (g/mi)": "242.682069",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA SPORT",
      "CO2 (g/mi)": "252.489991",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON",
      "CO2 (g/mi)": "249.530565",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "264.269239",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK",
      "CO2 (g/mi)": "275.680845",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "438.489198",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX STI",
      "CO2 (g/mi)": "416.377238",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "XV Crosstrek",
      "CO2 (g/mi)": "264.927722",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Model S",
      "Represented Test Veh Model": "S2",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "70D",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "85D",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P85D",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "S3",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "222.8797967",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "337.2546768",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "450.3556386",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "244.155431",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "300.30772",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "315.1462204",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250",
      "CO2 (g/mi)": "209.2162214",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250 AWD",
      "CO2 (g/mi)": "232.141214",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 250/IS 250C",
      "CO2 (g/mi)": "327.5932197",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350 AWD",
      "CO2 (g/mi)": "457.4575183",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350/IS 350C",
      "CO2 (g/mi)": "235.1906137",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.7875086",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "432.5436445",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L AWD",
      "CO2 (g/mi)": "458.914436",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "397.9446499",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "365.419759",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.203026",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h",
      "CO2 (g/mi)": "208.7136152",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "209.5908616",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "425.9731312",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "388.3262057",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "262.5109038",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "215.3292345",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "217.1822011",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iQ",
      "CO2 (g/mi)": "229.2161468",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "tC",
      "CO2 (g/mi)": "199.7433482",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "419.5139867",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "298.4722884",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "276.8714861",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid LE",
      "CO2 (g/mi)": "156.5325481",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid XLE",
      "CO2 (g/mi)": "157.2902683",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "250.3427994",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA LE ECO",
      "CO2 (g/mi)": "219.3207439",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "388.8461536",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "391.9383457",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "301.1286992",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LE Plus",
      "CO2 (g/mi)": "290.0017833",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "362.4384054",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "130.8100637",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "180.1866934",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Plug-in Hybrid",
      "CO2 (g/mi)": "180.7904938",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS v",
      "CO2 (g/mi)": "148.3199728",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "293.4932214",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "218.0924634",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 Limited AWD",
      "CO2 (g/mi)": "214.4620557",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SCION xB",
      "CO2 (g/mi)": "318.8867968",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "550.6731501",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "374.2080431",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "566.5345276",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "255.0882384",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "273.4205755",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "428.3006323",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "309.4667811",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "524.5673731",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "560.4281712",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "364.1309207",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA",
      "CO2 (g/mi)": "374.2102674",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "252.2302394",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "314",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "359",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta Hybrid",
      "CO2 (g/mi)": "155",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat wagon",
      "CO2 (g/mi)": "348",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "356",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "266.6770044",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "336",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "331",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "446",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "448",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S3",
      "CO2 (g/mi)": "349",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8",
      "CO2 (g/mi)": "462",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "415",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT3-R",
      "CO2 (g/mi)": "542",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan",
      "CO2 (g/mi)": "346",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "e-Golf",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "174.5461889",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "290",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "VW",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "251",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD",
      "CO2 (g/mi)": "218",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "166",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "373",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 FWD",
      "CO2 (g/mi)": "295",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 CC T5 AWD",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 Polestar T6 AWD",
      "CO2 (g/mi)": "379",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 3.2 AWD PZEV",
      "CO2 (g/mi)": "401",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "440",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 FWD",
      "CO2 (g/mi)": "290",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "405",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 FWD",
      "CO2 (g/mi)": "321",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 3.2 AWD PZEV",
      "CO2 (g/mi)": "389",
    },
    {
      "Model Year": "2015",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 T6 AWD",
      "CO2 (g/mi)": "371",
    },
  ],
  2016: [
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB9",
      "CO2 (g/mi)": "550.27",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide S",
      "CO2 (g/mi)": "511.93",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V12 Vantage S",
      "CO2 (g/mi)": "603.49",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE",
      "CO2 (g/mi)": "551.4037",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V8 VANTAGE S",
      "CO2 (g/mi)": "529.36",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vanquish",
      "CO2 (g/mi)": "536.18",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "325",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5 Hybrid",
      "CO2 (g/mi)": "323",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS7",
      "CO2 (g/mi)": "467",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "396",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT",
      "CO2 (g/mi)": "555",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Bluecar",
      "Represented Test Veh Model": "Bluecar",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i",
      "CO2 (g/mi)": "320.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i xDrive",
      "CO2 (g/mi)": "308.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i xDrive Convertible",
      "CO2 (g/mi)": "308.62",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i",
      "CO2 (g/mi)": "291.87",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i xDrive",
      "CO2 (g/mi)": "299.04",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d",
      "CO2 (g/mi)": "241.11",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive",
      "CO2 (g/mi)": "246.94",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive Sports Wagon",
      "CO2 (g/mi)": "261.48",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i",
      "CO2 (g/mi)": "175.1535785",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive",
      "CO2 (g/mi)": "306.26",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive Gran Turismo",
      "CO2 (g/mi)": "314.06",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328i xDrive Sports Wagon",
      "CO2 (g/mi)": "329.73",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330e",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "335i xDrive Gran Turismo",
      "CO2 (g/mi)": "350.09",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i",
      "CO2 (g/mi)": "304.56",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive",
      "CO2 (g/mi)": "302.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Convertible",
      "CO2 (g/mi)": "309.37",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Convertible xDrive",
      "CO2 (g/mi)": "323.42",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Coupe",
      "CO2 (g/mi)": "318.73",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i Gran Coupe",
      "CO2 (g/mi)": "300.53",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "428i xDrive Gran Coupe",
      "CO2 (g/mi)": "308.63",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Convertible",
      "CO2 (g/mi)": "342.41",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Coupe",
      "CO2 (g/mi)": "357.41",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i Gran Coupe",
      "CO2 (g/mi)": "328.13",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i xDrive Convertible",
      "CO2 (g/mi)": "364.21",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i xDrive Coupe",
      "CO2 (g/mi)": "368.85",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "435i xDrive Gran Coupe",
      "CO2 (g/mi)": "348",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i",
      "CO2 (g/mi)": "291.97",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "528i xDrive",
      "CO2 (g/mi)": "302.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535d",
      "CO2 (g/mi)": "304.08",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535d xDrive",
      "CO2 (g/mi)": "307.45",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i",
      "CO2 (g/mi)": "336.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "236.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive",
      "CO2 (g/mi)": "353.9",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "385.56",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i",
      "CO2 (g/mi)": "408.39",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive",
      "CO2 (g/mi)": "254.21",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "472.5361654",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.56",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Coupe",
      "CO2 (g/mi)": "343.14",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Coupe",
      "CO2 (g/mi)": "355",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.25",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Coupe",
      "CO2 (g/mi)": "257.3810855",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Convertible",
      "CO2 (g/mi)": "458.96",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Coupe",
      "CO2 (g/mi)": "424.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i",
      "CO2 (g/mi)": "316.18",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "401.2950194",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i xDrive",
      "CO2 (g/mi)": "410.24",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ActiveHybrid 5",
      "CO2 (g/mi)": "351.06",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 BEV",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 REX",
      "CO2 (g/mi)": "169.44",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I8",
      "CO2 (g/mi)": "398.92",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2",
      "CO2 (g/mi)": "341.34",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i",
      "CO2 (g/mi)": "338.64",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i Convertible",
      "CO2 (g/mi)": "342.58",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i xDrive",
      "CO2 (g/mi)": "341.97",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "482.93",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Convertible",
      "CO2 (g/mi)": "364.59",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Coupe",
      "CO2 (g/mi)": "236.366618",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 GTS",
      "CO2 (g/mi)": "244.5102966",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "485.57",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.39",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "305.52",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive 28d",
      "CO2 (g/mi)": "282.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "322.65",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "382.5934697",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 M40i",
      "CO2 (g/mi)": "369.99",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive 28i",
      "CO2 (g/mi)": "344.07",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive35i",
      "CO2 (g/mi)": "372.08",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M",
      "CO2 (g/mi)": "491.62",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive35i",
      "CO2 (g/mi)": "372.22",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "243.0306358",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "376.688",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive40e",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "485.76",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 sDrive35i",
      "CO2 (g/mi)": "374.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive 50i",
      "CO2 (g/mi)": "484.87",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "376.29",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "450.28",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive28i",
      "CO2 (g/mi)": "317.6040369",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive35is",
      "CO2 (g/mi)": "235.78",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works All4 Countryman",
      "CO2 (g/mi)": "324.84",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "272.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "252.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "210.72",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 2 DOOR",
      "CO2 (g/mi)": "241.42",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 4 DOOR",
      "CO2 (g/mi)": "239.77",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (3-doors)",
      "CO2 (g/mi)": "190.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (5-doors)",
      "CO2 (g/mi)": "265.242842",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "187.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "266.2218692",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "195.52",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman All4",
      "CO2 (g/mi)": "206.8516239",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI John Cooper Works Hardtop",
      "CO2 (g/mi)": "271.9708968",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.32014",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
      "CO2 (g/mi)": "300.71133",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200 AWD",
      "CO2 (g/mi)": "385.4714",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.51335",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.56653",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
      "CO2 (g/mi)": "431",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.55036",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.39543",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "413",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.399",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Dart",
      "CO2 (g/mi)": "276.59398",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango AWD",
      "CO2 (g/mi)": "505.86742",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "239.8645341",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "411",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Ram",
      "CO2 (g/mi)": "353",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM 1500 PICKUP 2WD",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "RAM PICKUP",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "247",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "269.57371",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X",
      "CO2 (g/mi)": "276.12647",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X AWD",
      "CO2 (g/mi)": "329.26366",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee",
      "CO2 (g/mi)": "339.48839",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "252.869",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "387.8945463",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "206.9866687",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "366.93647",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 2WD",
      "CO2 (g/mi)": "321",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 4WD",
      "CO2 (g/mi)": "315",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "349",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass FWD",
      "CO2 (g/mi)": "335",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "359.7397",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "384.45149",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.07996",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 2WD",
      "CO2 (g/mi)": "204.215",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.88845",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "201.8611563",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "276.08782",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.34155",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "415.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 EcoDiesel29 4x2",
      "CO2 (g/mi)": "247.7275022",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "5500 4X2",
      "CO2 (g/mi)": "387.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "6000#  4X2",
      "CO2 (g/mi)": "261.3457495",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SRT",
      "Represented Test Veh Model": "Viper",
      "CO2 (g/mi)": "489.457",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 GTB",
      "CO2 (g/mi)": "448.4425486",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California T",
      "CO2 (g/mi)": "448.891",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Berlinetta",
      "CO2 (g/mi)": "596.476",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 FNA",
      "CO2 (g/mi)": "639.325",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Special Series",
      "CO2 (g/mi)": "640.058",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "FF",
      "CO2 (g/mi)": "628.71",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max (PHEV)",
      "CO2 (g/mi)": "172.8648383",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max HEV FWD",
      "CO2 (g/mi)": "169.7150958",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge",
      "CO2 (g/mi)": "210",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "311.603",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "322.856",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "497.043",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition 4x2",
      "CO2 (g/mi)": "453.336",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition 4x4",
      "CO2 (g/mi)": "488",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition EL 4x2",
      "CO2 (g/mi)": "488.438",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition EL 4x4",
      "CO2 (g/mi)": "497.25",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "Explorer",
      "CO2 (g/mi)": "485.879",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer AWD",
      "CO2 (g/mi)": "247.218",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
      "CO2 (g/mi)": "379.5378552",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "267.8652",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, FWD",
      "CO2 (g/mi)": "395.13",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X2",
      "CO2 (g/mi)": "368.207",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X2",
      "CO2 (g/mi)": "384",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4",
      "CO2 (g/mi)": "286",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Cab Max",
      "CO2 (g/mi)": "436",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2",
      "CO2 (g/mi)": "260.717",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2 Super Cab",
      "CO2 (g/mi)": "249.6901615",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4",
      "CO2 (g/mi)": "438",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 Super Crew",
      "CO2 (g/mi)": "274.355",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X2",
      "CO2 (g/mi)": "449.71",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X4",
      "CO2 (g/mi)": "492",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "174.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA SFE",
      "CO2 (g/mi)": "211.616",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fiesta ST",
      "CO2 (g/mi)": "190",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "452.22",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS FFV",
      "CO2 (g/mi)": "253",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Focus RS",
      "CO2 (g/mi)": "353",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS ST",
      "CO2 (g/mi)": "206",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "152.0873189",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion AWD",
      "CO2 (g/mi)": "322.75",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion FWD",
      "CO2 (g/mi)": "312",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "553.77",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ (HEV)",
      "CO2 (g/mi)": "175.157",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
      "CO2 (g/mi)": "379.535697",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility",
      "CO2 (g/mi)": "467.69",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Special Service Police",
      "CO2 (g/mi)": "216",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T150 Transit Wagon MDPV",
      "CO2 (g/mi)": "344",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T250 Transit Van MDPV",
      "CO2 (g/mi)": "359.8990235",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TAURUS",
      "CO2 (g/mi)": "411",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
      "CO2 (g/mi)": "259",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
      "CO2 (g/mi)": "375",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "291",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
      "CO2 (g/mi)": "269",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "252",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Transit Connect",
      "CO2 (g/mi)": "315.219",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FFV",
      "CO2 (g/mi)": "231.443",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON LWB FFV",
      "CO2 (g/mi)": "225.956",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT T150 WAGON FFV",
      "CO2 (g/mi)": "355",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKC",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKS AWD",
      "CO2 (g/mi)": "429",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "427",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKTLivery",
      "CO2 (g/mi)": "226",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX AWD",
      "CO2 (g/mi)": "423.197",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKZ AWD",
      "CO2 (g/mi)": "385",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator L 4x2",
      "CO2 (g/mi)": "485.098",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator L 4x4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "CASCADA",
      "CO2 (g/mi)": "351.385127",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCLAVE AWD",
      "CO2 (g/mi)": "480.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE",
      "CO2 (g/mi)": "243.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "260.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION AWD",
      "CO2 (g/mi)": "372.6",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "282.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "417.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "361.136",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL AWD",
      "CO2 (g/mi)": "371.8",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "VERANO",
      "CO2 (g/mi)": "345.8",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS",
      "CO2 (g/mi)": "309.348",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS AWD",
      "CO2 (g/mi)": "318.869",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS-V",
      "CO2 (g/mi)": "425.503",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6",
      "CO2 (g/mi)": "316.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 AWD",
      "CO2 (g/mi)": "243.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN",
      "CO2 (g/mi)": "326.052",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN AWD",
      "CO2 (g/mi)": "229.005",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS-V",
      "CO2 (g/mi)": "321.755",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ELR",
      "CO2 (g/mi)": "206.661",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "479.977",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX 2WD",
      "CO2 (g/mi)": "448.284",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "SRX AWD",
      "CO2 (g/mi)": "457.828",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "276.6212495",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "489.612",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LH26",
      "CO2 (g/mi)": "316.042",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LK26",
      "CO2 (g/mi)": "348.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "267.0153485",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 SUBURBAN 2WD",
      "CO2 (g/mi)": "456",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "393.576",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "365.653",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "381.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "421.225",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "239.011",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE ECO",
      "CO2 (g/mi)": "266.9",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "334.8",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "313.887",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "409.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "705.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "396.86",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "434.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 SUBURBAN 4WD",
      "CO2 (g/mi)": "470.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "293.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "255.3947054",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU LIMITED",
      "CO2 (g/mi)": "293.484",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "255.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC 5",
      "CO2 (g/mi)": "279.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC RS",
      "CO2 (g/mi)": "187.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "216.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK EV",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SS",
      "CO2 (g/mi)": "499.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX",
      "CO2 (g/mi)": "202.119",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "145.302",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON 2WD",
      "CO2 (g/mi)": "366.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON 4WD",
      "CO2 (g/mi)": "405.0864696",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON CAB CHASSIS 2WD",
      "CO2 (g/mi)": "522.868",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL 4WD",
      "CO2 (g/mi)": "497.074",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "273.09",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 2WD",
      "CO2 (g/mi)": "339.99",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX 4WD",
      "CO2 (g/mi)": "359.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 2WD",
      "CO2 (g/mi)": "354.16",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 4WD",
      "CO2 (g/mi)": "369.97",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX HYBRID",
      "CO2 (g/mi)": "229.56",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX",
      "CO2 (g/mi)": "281.1647093",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "288.57",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD L4",
      "CO2 (g/mi)": "258.49",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 1.5L",
      "CO2 (g/mi)": "147.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 2.0L",
      "CO2 (g/mi)": "259.76",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 1.5L",
      "CO2 (g/mi)": "147.5226252",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 2.0L",
      "CO2 (g/mi)": "230.4359582",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2WD",
      "CO2 (g/mi)": "262.14",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 4WD",
      "CO2 (g/mi)": "290.17",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-Z",
      "CO2 (g/mi)": "185.08",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EX",
      "CO2 (g/mi)": "208.26",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT LX",
      "CO2 (g/mi)": "232.04",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "HR-V 2WD",
      "CO2 (g/mi)": "271.76",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "HR-V 4WD",
      "CO2 (g/mi)": "194.5819198",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.69",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 6AT",
      "CO2 (g/mi)": "358.78",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 9AT",
      "CO2 (g/mi)": "349.83",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 6AT",
      "CO2 (g/mi)": "379.67",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 9AT",
      "CO2 (g/mi)": "251.37",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "205.82",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera",
      "CO2 (g/mi)": "359.5251996",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera Limited",
      "CO2 (g/mi)": "375.7709",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "280.8065",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra Limited",
      "CO2 (g/mi)": "253.8639",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Equus",
      "CO2 (g/mi)": "481.0397",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis",
      "CO2 (g/mi)": "255.0800646",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis Coupe",
      "CO2 (g/mi)": "439.2253",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "265.2879347",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport",
      "CO2 (g/mi)": "365.397",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport ULTIMATE",
      "CO2 (g/mi)": "368.2011",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Ultimate",
      "CO2 (g/mi)": "422.8205",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "199.7241153",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "218.223",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA PLUG-IN HYBRID",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "247.8189",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson Fuel Cell",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "328.4947",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Fe",
      "CO2 (g/mi)": "272.6336",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID",
      "CO2 (g/mi)": "184.6212",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA HYBRID EX",
      "CO2 (g/mi)": "189.4587",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type",
      "CO2 (g/mi)": "457.95",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type AWD",
      "CO2 (g/mi)": "391.01",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Manual",
      "CO2 (g/mi)": "463.82",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type S",
      "CO2 (g/mi)": "375.37",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "348.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "355.79",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "424.32",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ AWD LWB",
      "CO2 (g/mi)": "424.97",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "483.11",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL",
      "CO2 (g/mi)": "390.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport",
      "CO2 (g/mi)": "355",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "LR4",
      "CO2 (g/mi)": "492.06",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover 3.0 PZEV",
      "CO2 (g/mi)": "429.05",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque",
      "CO2 (g/mi)": "337.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque Cabriolet",
      "CO2 (g/mi)": "225.14",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "528.66",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "255.1639",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "290.9759",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Veloster",
      "CO2 (g/mi)": "244.5902",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "490.0606",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "283.6807",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte 5",
      "CO2 (g/mi)": "278.7910493",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte Koup",
      "CO2 (g/mi)": "316.2032",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte5",
      "CO2 (g/mi)": "324.8977",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900",
      "CO2 (g/mi)": "481.6413",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900 EX",
      "CO2 (g/mi)": "421.5964",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "245.908",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio ECO",
      "CO2 (g/mi)": "247.2876",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona",
      "CO2 (g/mi)": "402.4325",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SX",
      "CO2 (g/mi)": "391.9028",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SXL",
      "CO2 (g/mi)": "433.0131",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "263.5426209",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "284.5921",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul ECO dynamics",
      "CO2 (g/mi)": "208.4274996",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul electric",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "362.3031",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR",
      "CO2 (g/mi)": "784",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6 AWD",
      "CO2 (g/mi)": "446.9",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S RWD",
      "CO2 (g/mi)": "439.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "427.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.258",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO SPORT",
      "CO2 (g/mi)": "560.136",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "490.6",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S V6 RWD",
      "CO2 (g/mi)": "449.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "455.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-3",
      "CO2 (g/mi)": "195",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mazda",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "263",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-9",
      "CO2 (g/mi)": "337.0229104",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "215",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "232",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "272",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "258",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "570S Coupe",
      "CO2 (g/mi)": "419",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "MP4-12C Coupe",
      "CO2 (g/mi)": "451.9",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63",
      "CO2 (g/mi)": "403.61",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G65",
      "CO2 (g/mi)": "758.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63 S (coupe)",
      "CO2 (g/mi)": "630.45",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT S",
      "CO2 (g/mi)": "295.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "B-class electric drive",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "186.36",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "287.05",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350e",
      "CO2 (g/mi)": "237.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 450 AMG",
      "CO2 (g/mi)": "330.52",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "265.6",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "285.44",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "304.65",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 400",
      "CO2 (g/mi)": "346.74",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 400 4MATIC",
      "CO2 (g/mi)": "242.0995605",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "404.89",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "417.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG 4MATIC",
      "CO2 (g/mi)": "457.97",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 250 BLUETEC",
      "CO2 (g/mi)": "276.53",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 250 BLUETEC 4MATIC",
      "CO2 (g/mi)": "288.85",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "218.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "215.18",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC (Station Wagon)",
      "CO2 (g/mi)": "351.34",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400",
      "CO2 (g/mi)": "344.95",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (convertible)",
      "CO2 (g/mi)": "342.17",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (coupe)",
      "CO2 (g/mi)": "345.11",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC",
      "CO2 (g/mi)": "357.58",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (coupe)",
      "CO2 (g/mi)": "349.99",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (convertible)",
      "CO2 (g/mi)": "414.86",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (coupe)",
      "CO2 (g/mi)": "404.38",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 4MATIC",
      "CO2 (g/mi)": "262.65",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG 4MATIC",
      "CO2 (g/mi)": "441.43",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG S 4MATIC",
      "CO2 (g/mi)": "465.22",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 63 AMG S 4MATIC (station wagon)",
      "CO2 (g/mi)": "461.51",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "564.75",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 350 BLUETEC 4MATIC",
      "CO2 (g/mi)": "280.47",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 450 4MATIC",
      "CO2 (g/mi)": "421.19",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 550 4MATIC",
      "CO2 (g/mi)": "604.77",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 63 AMG",
      "CO2 (g/mi)": "736.6",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "275.05",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "287.39",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "315.49",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300",
      "CO2 (g/mi)": "319.22",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC",
      "CO2 (g/mi)": "330.25",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 300 d 4MATIC",
      "CO2 (g/mi)": "231.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 350 D 4MATIC",
      "CO2 (g/mi)": "344.1",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 450 AMG (coupe)",
      "CO2 (g/mi)": "407.72",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 550 e 4MATIC",
      "CO2 (g/mi)": "327.57",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach S 600",
      "CO2 (g/mi)": "559.47",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van)",
      "CO2 (g/mi)": "334.266885",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Passenger Van)",
      "CO2 (g/mi)": "253.84",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "390.7",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "403.82",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 400 4MATIC",
      "CO2 (g/mi)": "395.68",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "520.54",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "410.66",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "436",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC (coupe)",
      "CO2 (g/mi)": "435.39",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 e",
      "CO2 (g/mi)": "294.63",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "300.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC",
      "CO2 (g/mi)": "565.46",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC (coupe)",
      "CO2 (g/mi)": "465.13",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG",
      "CO2 (g/mi)": "562.9",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 65 AMG (coupe)",
      "CO2 (g/mi)": "316.0550386",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 400",
      "CO2 (g/mi)": "352.39",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "440.12",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "448.57",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 65 AMG",
      "CO2 (g/mi)": "511.74",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 300",
      "CO2 (g/mi)": "193.64",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 350",
      "CO2 (g/mi)": "218.81",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 55 AMG",
      "CO2 (g/mi)": "372.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo (Coupe)",
      "CO2 (g/mi)": "213.137",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "smart fortwo electric drive (convertible)",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "i-MiEV",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER AWD",
      "CO2 (g/mi)": "200.89828",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "268.81697",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "278.36773",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "298.72266",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "213.33792",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "MV",
      "Represented Test Veh Model": "MV-1",
      "CO2 (g/mi)": "514.6",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI  Q50 HYBRID PREMIUM",
      "CO2 (g/mi)": "243",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 AWD PREMIUM",
      "CO2 (g/mi)": "355",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 HYBRID PREMIUM",
      "CO2 (g/mi)": "242",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM",
      "CO2 (g/mi)": "330",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S AWD SPORT",
      "CO2 (g/mi)": "245",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S Q50 HYBRID SPORT AWD",
      "CO2 (g/mi)": "257",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S SPORT",
      "CO2 (g/mi)": "239",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7",
      "CO2 (g/mi)": "388",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7 AWD",
      "CO2 (g/mi)": "262",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 AWD 5.6",
      "CO2 (g/mi)": "460",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 HYBRID",
      "CO2 (g/mi)": "231",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX50 AWD Journey",
      "CO2 (g/mi)": "409",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 AWD",
      "CO2 (g/mi)": "246",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 FWD",
      "CO2 (g/mi)": "256",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX70 AWD",
      "CO2 (g/mi)": "444",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX70 RWD",
      "CO2 (g/mi)": "420",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 2WD",
      "CO2 (g/mi)": "516",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 4WD",
      "CO2 (g/mi)": "539",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50",
      "CO2 (g/mi)": "361",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD",
      "CO2 (g/mi)": "365",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50S",
      "CO2 (g/mi)": "370",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50S AWD",
      "CO2 (g/mi)": "387",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z Touring",
      "CO2 (g/mi)": "393",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA SL",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA SR 2.5",
      "CO2 (g/mi)": "168.1910984",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD K/C SV",
      "CO2 (g/mi)": "438",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5AT",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5MT",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5AT",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD SV 4-Cyl 5MT",
      "CO2 (g/mi)": "268",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD C/C PRO-4X",
      "CO2 (g/mi)": "490",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C PRO-4X",
      "CO2 (g/mi)": "465",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 4WD K/C SV",
      "CO2 (g/mi)": "440",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "427",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE AWD SL",
      "CO2 (g/mi)": "202",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE NISMO RS",
      "CO2 (g/mi)": "201",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SL",
      "CO2 (g/mi)": "249.6500897",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "277",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF S",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF SL",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF SV",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MAXIMA SR",
      "CO2 (g/mi)": "325",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD  SL",
      "CO2 (g/mi)": "336",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD Hybrid SL",
      "CO2 (g/mi)": "256",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD SL",
      "CO2 (g/mi)": "216.3253593",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 Cargo Van S",
      "CO2 (g/mi)": "358",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 NYC Taxi STD",
      "CO2 (g/mi)": "341",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN PATHFINDER 4WD S",
      "CO2 (g/mi)": "243",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "365",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD",
      "CO2 (g/mi)": "282",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ROGUE AWD SL",
      "CO2 (g/mi)": "279",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA S",
      "CO2 (g/mi)": "255",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SL",
      "CO2 (g/mi)": "226",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA NOTE S",
      "CO2 (g/mi)": "247",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA NOTE SV",
      "CO2 (g/mi)": "215",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA S",
      "CO2 (g/mi)": "264",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA SV",
      "CO2 (g/mi)": "214",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Pagani Automobili",
      "Represented Test Veh Model": "PT4",
      "CO2 (g/mi)": "689.5",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "233.146011",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "371.89",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "379.4",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "383.59",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "388.17",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Kit",
      "CO2 (g/mi)": "386.18",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Kit Cabriolet",
      "CO2 (g/mi)": "254.32",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "372.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "378.45",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "379.07",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Kit",
      "CO2 (g/mi)": "392.47",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Kit Cabriolet",
      "CO2 (g/mi)": "396.27",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "488.42",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3RS",
      "CO2 (g/mi)": "493.14",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 R",
      "CO2 (g/mi)": "513.31",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4",
      "CO2 (g/mi)": "386.36",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4S",
      "CO2 (g/mi)": "395.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "429.45",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "319",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "359.2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster Spyder",
      "CO2 (g/mi)": "391.55",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "386.9",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "439.36",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "419.99",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S e-Hybrid",
      "CO2 (g/mi)": "335.77",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "306.41142",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman GT4",
      "CO2 (g/mi)": "399.46",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman GTS",
      "CO2 (g/mi)": "366.48",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "408.31",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo",
      "CO2 (g/mi)": "423.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "396.34",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4",
      "CO2 (g/mi)": "405.76",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S",
      "CO2 (g/mi)": "416.79",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "426.68",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS",
      "CO2 (g/mi)": "472.3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera S E-Hybrid",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo",
      "CO2 (g/mi)": "483.26",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "487.13",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Quantum Impala",
      "Represented Test Veh Model": "Impala dual fuel",
      "CO2 (g/mi)": "472.84",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Dawn",
      "CO2 (g/mi)": "592.59",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "469.58",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "348.29",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom EWB",
      "CO2 (g/mi)": "538.77",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "577.03",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "634.98",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "532.7471",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "281",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "231.34772",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA",
      "CO2 (g/mi)": "242.682069",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA SPORT",
      "CO2 (g/mi)": "252.489991",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA WAGON",
      "CO2 (g/mi)": "249.530565",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "264.269239",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK",
      "CO2 (g/mi)": "275.680845",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "438.489198",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX STI",
      "CO2 (g/mi)": "416.377238",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "XV Crosstrek",
      "CO2 (g/mi)": "264.927722",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Model S",
      "Represented Test Veh Model": "S2",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "60D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "60R",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "70D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75R",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "85D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "90D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P85D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P90D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "S3",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "60D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "90D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "CT 200h",
      "CO2 (g/mi)": "153.69495",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "222.8797967",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "337.2546768",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 200t F SPORT",
      "CO2 (g/mi)": "336.1858146",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "354.0594128",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "365.8044844",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 F SPORT",
      "CO2 (g/mi)": "229.9275437",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "300.30772",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS F",
      "CO2 (g/mi)": "272.8677435",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "315.1462204",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 200t",
      "CO2 (g/mi)": "314",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350",
      "CO2 (g/mi)": "436.019967",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350 AWD",
      "CO2 (g/mi)": "457.4575183",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.7875086",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "432.5436445",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L AWD",
      "CO2 (g/mi)": "458.914436",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 600h L",
      "CO2 (g/mi)": "397.9446499",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "554.8840801",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.203026",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h",
      "CO2 (g/mi)": "208.7136152",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "209.5908616",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "425.9731312",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "227.9272582",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "240.078263",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h",
      "CO2 (g/mi)": "284.4801049",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "277.0124438",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iM",
      "CO2 (g/mi)": "249.770364",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "tC",
      "CO2 (g/mi)": "199.7433482",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "419.5139867",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "298.4722884",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "276.8714861",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid LE",
      "CO2 (g/mi)": "156.5325481",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid XLE",
      "CO2 (g/mi)": "157.2902683",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "250.3427994",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA LE ECO",
      "CO2 (g/mi)": "219.3207439",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "388.8461536",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "391.9383457",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "301.1286992",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LE Plus",
      "CO2 (g/mi)": "290.0017833",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "542.543684",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "123.7047548",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "180.1866934",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Eco",
      "CO2 (g/mi)": "153.2872691",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS v",
      "CO2 (g/mi)": "148.3199728",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "293.4932214",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "218.0924634",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 HYBRID AWD",
      "CO2 (g/mi)": "197.1758551",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 Limited AWD",
      "CO2 (g/mi)": "214.4620557",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "550.6731501",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "374.2080431",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "566.5345276",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "255.0882384",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "273.4205755",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "270.391702",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "281.7765016",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD D-CAB V6 MT OFF-ROAD",
      "CO2 (g/mi)": "319.0533243",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "380",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD FFV",
      "CO2 (g/mi)": "352.7597544",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "560.4281712",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "549",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "305",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "Eos",
      "CO2 (g/mi)": "314",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "359",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta Hybrid",
      "CO2 (g/mi)": "220",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "386",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat wagon",
      "CO2 (g/mi)": "348",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "356",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "416",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "336",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 e-tron",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "331",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "345",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "366",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "446",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A6",
      "CO2 (g/mi)": "286",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi TT",
      "CO2 (g/mi)": "361",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "448",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S3",
      "CO2 (g/mi)": "349",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S6",
      "CO2 (g/mi)": "408",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8",
      "CO2 (g/mi)": "462",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8 Plus",
      "CO2 (g/mi)": "422",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "415",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTS",
      "CO2 (g/mi)": "314",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Mulsanne Speed",
      "CO2 (g/mi)": "642",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan",
      "CO2 (g/mi)": "336",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "e-Golf",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "174.5461889",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf R",
      "CO2 (g/mi)": "334",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "290",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD",
      "CO2 (g/mi)": "218",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "263",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 FWD",
      "CO2 (g/mi)": "316",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 CC T5 AWD",
      "CO2 (g/mi)": "406",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 T6 AWD",
      "CO2 (g/mi)": "330",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "372",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 FWD",
      "CO2 (g/mi)": "307.1842762",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "405",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 FWD",
      "CO2 (g/mi)": "341",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 T5 AWD",
      "CO2 (g/mi)": "363",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC70 T5 FWD",
      "CO2 (g/mi)": "297",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 AWD",
      "CO2 (g/mi)": "394",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 FWD",
      "CO2 (g/mi)": "381",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T6 AWD",
      "CO2 (g/mi)": "413",
    },
    {
      "Model Year": "2016",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T8 AWD",
      "CO2 (g/mi)": "240",
    },
  ],
  2017: [
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11",
      "CO2 (g/mi)": "466.8700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide S",
      "CO2 (g/mi)": "511.9300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "V12 Vantage S",
      "CO2 (g/mi)": "603.4900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vanquish",
      "CO2 (g/mi)": "536.1800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "368.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "387.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS7",
      "CO2 (g/mi)": "467.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S5",
      "CO2 (g/mi)": "396.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT",
      "CO2 (g/mi)": "555.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Convertible",
      "CO2 (g/mi)": "195.2600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Coupe",
      "CO2 (g/mi)": "337.1654796",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i xDrive Convertible",
      "CO2 (g/mi)": "301.3100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i xDrive Coupe",
      "CO2 (g/mi)": "292.7719933",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i",
      "CO2 (g/mi)": "291.8700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i xDrive",
      "CO2 (g/mi)": "299.0400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d",
      "CO2 (g/mi)": "241.1100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive",
      "CO2 (g/mi)": "246.9400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive Sports Wagon",
      "CO2 (g/mi)": "177.5800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330e",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i",
      "CO2 (g/mi)": "286.9500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive",
      "CO2 (g/mi)": "297.4300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Gran Turismo",
      "CO2 (g/mi)": "302.3700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Sports Wagon",
      "CO2 (g/mi)": "308.7500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i",
      "CO2 (g/mi)": "304.5600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive",
      "CO2 (g/mi)": "302.9800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive Gran Turismo",
      "CO2 (g/mi)": "323.4998000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Convertible",
      "CO2 (g/mi)": "293.0300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Coupe",
      "CO2 (g/mi)": "286.5300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Gran Coupe",
      "CO2 (g/mi)": "293.8100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Convertible",
      "CO2 (g/mi)": "317.4800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Coupe",
      "CO2 (g/mi)": "298.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Gran Coupe",
      "CO2 (g/mi)": "303.4200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Convertible",
      "CO2 (g/mi)": "321.6900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Coupe",
      "CO2 (g/mi)": "303.7200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Gran Coupe",
      "CO2 (g/mi)": "309.1500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Convertible",
      "CO2 (g/mi)": "334.1400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Coupe",
      "CO2 (g/mi)": "321.7700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Gran Coupe",
      "CO2 (g/mi)": "321.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i",
      "CO2 (g/mi)": "281.4700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i xDrive",
      "CO2 (g/mi)": "299.1900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i Gran Turismo",
      "CO2 (g/mi)": "236.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "535i xDrive Gran Turismo",
      "CO2 (g/mi)": "385.5600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i",
      "CO2 (g/mi)": "342.1100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i xDrive",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "550i xDrive Gran Turismo",
      "CO2 (g/mi)": "472.5361654",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.5600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Coupe",
      "CO2 (g/mi)": "343.1400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Convertible",
      "CO2 (g/mi)": "361.1900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Coupe",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Coupe",
      "CO2 (g/mi)": "257.3810855",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Convertible",
      "CO2 (g/mi)": "458.9600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Coupe",
      "CO2 (g/mi)": "424.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740e xDrive",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i",
      "CO2 (g/mi)": "316.1800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i xDrive",
      "CO2 (g/mi)": "356.2900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "401.2950194",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i xDrive",
      "CO2 (g/mi)": "408.4672002",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 xDrive",
      "CO2 (g/mi)": "460.4939000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 BEV",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 REX",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I8",
      "CO2 (g/mi)": "398.9200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2",
      "CO2 (g/mi)": "341.3400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i",
      "CO2 (g/mi)": "312.2200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i Convertible",
      "CO2 (g/mi)": "322.8400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive",
      "CO2 (g/mi)": "319.7018000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive Convertible",
      "CO2 (g/mi)": "324.6900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "482.9300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Convertible",
      "CO2 (g/mi)": "364.5900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Coupe",
      "CO2 (g/mi)": "236.3666180",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "485.5700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.3900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M760i xDrive",
      "CO2 (g/mi)": "534.2102000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "297.3500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "305.5200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive 28d",
      "CO2 (g/mi)": "282.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive28i",
      "CO2 (g/mi)": "322.6500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive35i",
      "CO2 (g/mi)": "382.5934697",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 M40i",
      "CO2 (g/mi)": "369.9900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive 28i",
      "CO2 (g/mi)": "345.5600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M",
      "CO2 (g/mi)": "491.6200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive35i",
      "CO2 (g/mi)": "372.2200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "243.0306358",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "376.6880000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive40e",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "503.7440585",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 sDrive35i",
      "CO2 (g/mi)": "374.0300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive 50i",
      "CO2 (g/mi)": "327.4629234",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "376.2900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "450.2800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "272.0300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman ALL4",
      "CO2 (g/mi)": "292.7600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "252.9800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "277.0100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman ALL4",
      "CO2 (g/mi)": "308.7500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 2 DOOR",
      "CO2 (g/mi)": "174.7547433",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 4 DOOR",
      "CO2 (g/mi)": "239.7700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (3-doors)",
      "CO2 (g/mi)": "190.9800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (5-doors)",
      "CO2 (g/mi)": "265.2428420",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "187.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman ALL4",
      "CO2 (g/mi)": "336.8100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "266.2218692",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "287.5400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman ALL4",
      "CO2 (g/mi)": "300.2400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI JOHN COOPER WORKS CLUBMAN ALL4",
      "CO2 (g/mi)": "293.6900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI JOHN COOPER WORKS CONVERTIBLE",
      "CO2 (g/mi)": "190.8100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI John Cooper Works Hardtop",
      "CO2 (g/mi)": "271.9708968",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "215.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "414.9000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.3201400",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia",
      "CO2 (g/mi)": "292.9918000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia AWD",
      "CO2 (g/mi)": "308.0348100",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200",
      "CO2 (g/mi)": "300.7113300",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "200 AWD",
      "CO2 (g/mi)": "385.4714000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "406.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.5133500",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica",
      "CO2 (g/mi)": "366.5736700",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica Hybrid",
      "CO2 (g/mi)": "386.6835000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.5665300",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
      "CO2 (g/mi)": "431.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.5503600",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.3954300",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "413.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.3990000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango AWD",
      "CO2 (g/mi)": "505.8674200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "510.2874757",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "411.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Viper SRT",
      "CO2 (g/mi)": "691.2230000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "124 Spider",
      "CO2 (g/mi)": "258.6946290",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "247.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X",
      "CO2 (g/mi)": "276.1264700",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X AWD",
      "CO2 (g/mi)": "329.2636600",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee",
      "CO2 (g/mi)": "339.4883900",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "252.8690000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "382.9957700",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "206.9866687",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "384.1057600",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 2WD",
      "CO2 (g/mi)": "321.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "COMPASS 4WD",
      "CO2 (g/mi)": "315.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X2",
      "CO2 (g/mi)": "306.4890200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "321.3667976",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass FWD",
      "CO2 (g/mi)": "335.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "371.7277400",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "380.9087000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.0799600",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 2WD",
      "CO2 (g/mi)": "204.2150000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Patriot 4wd",
      "CO2 (g/mi)": "348.8884500",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "201.8611563",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "276.0878200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.3415500",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X2",
      "CO2 (g/mi)": "261.2366638",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "423.4857178",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 GTB",
      "CO2 (g/mi)": "448.4425486",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California T",
      "CO2 (g/mi)": "448.8910000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Berlinetta",
      "CO2 (g/mi)": "596.4760000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F12 Special Series",
      "CO2 (g/mi)": "640.0580000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso",
      "CO2 (g/mi)": "641.1826000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "LaFerrari Aperta",
      "CO2 (g/mi)": "427.8320000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max (HEV)",
      "CO2 (g/mi)": "152.7182648",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max Energi (PHEV)",
      "CO2 (g/mi)": "156.0420000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge",
      "CO2 (g/mi)": "344.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape",
      "CO2 (g/mi)": "341.3180000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "318.3360000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "330.6130000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "360.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition 4x2",
      "CO2 (g/mi)": "468.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition 4x4",
      "CO2 (g/mi)": "486.8710000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition EL 4x2",
      "CO2 (g/mi)": "500.1980000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition EL 4x4",
      "CO2 (g/mi)": "497.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer AWD",
      "CO2 (g/mi)": "247.2180000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "267.8652000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, FWD",
      "CO2 (g/mi)": "395.1300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150",
      "CO2 (g/mi)": "360.0240000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X2",
      "CO2 (g/mi)": "367.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X2",
      "CO2 (g/mi)": "377.4905000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 FFV 4X4",
      "CO2 (g/mi)": "406.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Cab Max",
      "CO2 (g/mi)": "437.4591940",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X2 Super Cab",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4X4 Super Crew",
      "CO2 (g/mi)": "274.3550000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X2",
      "CO2 (g/mi)": "449.7100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FFV 4X4",
      "CO2 (g/mi)": "488.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "174.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA SFE",
      "CO2 (g/mi)": "211.6160000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fiesta ST",
      "CO2 (g/mi)": "185.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "451.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
      "CO2 (g/mi)": "153.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Focus RS",
      "CO2 (g/mi)": "364.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS ST",
      "CO2 (g/mi)": "309.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion",
      "CO2 (g/mi)": "292.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "141.5150000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (PHEV)",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion FWD",
      "CO2 (g/mi)": "189.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "GT",
      "CO2 (g/mi)": "589.7090000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ",
      "CO2 (g/mi)": "230.6846730",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility",
      "CO2 (g/mi)": "467.6900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Special Service Police",
      "CO2 (g/mi)": "216.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T150 Transit Wagon MDPV",
      "CO2 (g/mi)": "491.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T250 Transit Van MDPV",
      "CO2 (g/mi)": "359.8990235",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TAURUS",
      "CO2 (g/mi)": "266.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "TAURUS AWD",
      "CO2 (g/mi)": "259.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "291.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
      "CO2 (g/mi)": "397.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "253.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FFV",
      "CO2 (g/mi)": "231.4430000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON LWB FFV",
      "CO2 (g/mi)": "225.9560000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT T150 WAGON FFV",
      "CO2 (g/mi)": "517.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Continental",
      "CO2 (g/mi)": "230.1460000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKC",
      "CO2 (g/mi)": "368.4450000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "426.4880000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX AWD",
      "CO2 (g/mi)": "423.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "247.5320000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator L 4x2",
      "CO2 (g/mi)": "483.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator L 4x4",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "CASCADA",
      "CO2 (g/mi)": "351.3851270",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCLAVE AWD",
      "CO2 (g/mi)": "480.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE",
      "CO2 (g/mi)": "243.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "260.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION AWD",
      "CO2 (g/mi)": "372.6000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION FWD",
      "CO2 (g/mi)": "214.6000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "332.8000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "364.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL AWD",
      "CO2 (g/mi)": "387.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "VERANO",
      "CO2 (g/mi)": "336.4510000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS",
      "CO2 (g/mi)": "309.3480000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS AWD",
      "CO2 (g/mi)": "318.8690000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS-V",
      "CO2 (g/mi)": "420.9000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6",
      "CO2 (g/mi)": "316.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 AWD",
      "CO2 (g/mi)": "243.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 HYBRID",
      "CO2 (g/mi)": "278.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS",
      "CO2 (g/mi)": "456.8000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN",
      "CO2 (g/mi)": "205.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN AWD",
      "CO2 (g/mi)": "229.0050000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS-V",
      "CO2 (g/mi)": "505.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "480.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5",
      "CO2 (g/mi)": "361.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 AWD",
      "CO2 (g/mi)": "405.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS",
      "CO2 (g/mi)": "421.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "489.6120000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LH26",
      "CO2 (g/mi)": "316.0420000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "1LK26",
      "CO2 (g/mi)": "348.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BOLT",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "267.0153485",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 SUBURBAN 2WD",
      "CO2 (g/mi)": "437.8000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAPRICE PPV",
      "CO2 (g/mi)": "393.5760000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "365.6530000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "381.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO ZR2 4WD",
      "CO2 (g/mi)": "495.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "421.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "226.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "429.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "313.8870000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G2500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "409.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "G3500 EXPRESS 2WD PASS MDPV",
      "CO2 (g/mi)": "705.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "333.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "430.3440000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 SUBURBAN 4WD",
      "CO2 (g/mi)": "472.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "293.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "255.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "255.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "222.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SS",
      "CO2 (g/mi)": "499.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX",
      "CO2 (g/mi)": "267.9090000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "145.3020000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA",
      "CO2 (g/mi)": "390.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA AWD",
      "CO2 (g/mi)": "394.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON 2WD",
      "CO2 (g/mi)": "367.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON 4WD",
      "CO2 (g/mi)": "253.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON CAB CHASSIS 2WD",
      "CO2 (g/mi)": "483.7737122",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL 4WD",
      "CO2 (g/mi)": "497.0740000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "273.0900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "NSX",
      "CO2 (g/mi)": "291.8200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 2WD",
      "CO2 (g/mi)": "354.1600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 4WD",
      "CO2 (g/mi)": "369.9700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX HYBRID",
      "CO2 (g/mi)": "229.5600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX",
      "CO2 (g/mi)": "179.1400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "288.5700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "191.7100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD L4",
      "CO2 (g/mi)": "258.4900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2.0L",
      "CO2 (g/mi)": "238.5600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 1.5L",
      "CO2 (g/mi)": "234.3100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 1.5L",
      "CO2 (g/mi)": "225.8500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 2.0L",
      "CO2 (g/mi)": "244.0100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR",
      "CO2 (g/mi)": "248.0200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR Type-R",
      "CO2 (g/mi)": "327.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC Si",
      "CO2 (g/mi)": "242.2900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Fuel Cell",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 1.5L TC",
      "CO2 (g/mi)": "253.0500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2.4L",
      "CO2 (g/mi)": "278.4100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EX",
      "CO2 (g/mi)": "208.2600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT LX",
      "CO2 (g/mi)": "232.0400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "HR-V 2WD",
      "CO2 (g/mi)": "271.7600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "HR-V 4WD",
      "CO2 (g/mi)": "194.5819198",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX AWD",
      "CO2 (g/mi)": "361.9400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX FWD",
      "CO2 (g/mi)": "358.3700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX HYBRID",
      "CO2 (g/mi)": "257.2100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY TOURING/TOURING-TE",
      "CO2 (g/mi)": "371.6900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 6AT",
      "CO2 (g/mi)": "358.7800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 9AT",
      "CO2 (g/mi)": "349.8300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 9AT",
      "CO2 (g/mi)": "251.3700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE AWD",
      "CO2 (g/mi)": "381.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE FWD",
      "CO2 (g/mi)": "374.6500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "205.8200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera",
      "CO2 (g/mi)": "359.5251996",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Azera Limited",
      "CO2 (g/mi)": "375.7709000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "250.3819000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "G90",
      "CO2 (g/mi)": "412.6748814",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Genesis",
      "CO2 (g/mi)": "255.0800646",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "389.6984000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport",
      "CO2 (g/mi)": "352.5065000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Ultimate",
      "CO2 (g/mi)": "422.8205000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "199.7241153",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "164.9215000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA PLUG-IN HYBRID",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "247.8189000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson Fuel Cell",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "328.4947000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Fe",
      "CO2 (g/mi)": "272.6336000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Hybrid",
      "CO2 (g/mi)": "220.8169000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA PLUG-IN HYBRID",
      "CO2 (g/mi)": "230.4345000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-PACE",
      "CO2 (g/mi)": "215.1800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE",
      "CO2 (g/mi)": "354.2846000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type AWD",
      "CO2 (g/mi)": "391.0100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Manual",
      "CO2 (g/mi)": "463.8200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE",
      "CO2 (g/mi)": "339.0044000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE AWD",
      "CO2 (g/mi)": "255.4702000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "348.4000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "355.7900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "424.3200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ AWD LWB",
      "CO2 (g/mi)": "424.9700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "483.1100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL",
      "CO2 (g/mi)": "390.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery",
      "CO2 (g/mi)": "450.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport",
      "CO2 (g/mi)": "358.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover 3.0 PZEV",
      "CO2 (g/mi)": "429.0500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque",
      "CO2 (g/mi)": "337.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Evoque Cabriolet",
      "CO2 (g/mi)": "225.1400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "528.6600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "250.8674000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "290.9759000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Veloster",
      "CO2 (g/mi)": "244.5902000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "347.3516000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "278.1662000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Forte Koup",
      "CO2 (g/mi)": "278.9070000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Forte5",
      "CO2 (g/mi)": "277.4187664",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900",
      "CO2 (g/mi)": "481.6413000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900 EX",
      "CO2 (g/mi)": "421.5964000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "NIRO",
      "CO2 (g/mi)": "205.7378000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "245.9080000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio ECO",
      "CO2 (g/mi)": "247.2876000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona",
      "CO2 (g/mi)": "402.4325000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SX",
      "CO2 (g/mi)": "391.9028000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SXL",
      "CO2 (g/mi)": "433.0131000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "248.8973000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "293.6600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul electric",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "375.9552580",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR",
      "CO2 (g/mi)": "784.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora 400",
      "CO2 (g/mi)": "452.8408000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6 AWD",
      "CO2 (g/mi)": "446.9000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S RWD 405HP",
      "CO2 (g/mi)": "439.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "427.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.2580000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO SPORT",
      "CO2 (g/mi)": "560.1360000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE",
      "CO2 (g/mi)": "487.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE S",
      "CO2 (g/mi)": "495.9000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "490.6000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "449.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "455.2000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-3",
      "CO2 (g/mi)": "195.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "293.7820000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-9",
      "CO2 (g/mi)": "340.5880000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "214.9380000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "244.1310000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA6",
      "CO2 (g/mi)": "279.2380000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "263.4460000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "570S Coupe",
      "CO2 (g/mi)": "419.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC",
      "CO2 (g/mi)": "343.2300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (convertible)",
      "CO2 (g/mi)": "366.6200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (coupe)",
      "CO2 (g/mi)": "353.9900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63",
      "CO2 (g/mi)": "416.9400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 (convertible)",
      "CO2 (g/mi)": "285.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 43 4MATIC",
      "CO2 (g/mi)": "393.3400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G65",
      "CO2 (g/mi)": "758.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC",
      "CO2 (g/mi)": "395.3600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC (coupe)",
      "CO2 (g/mi)": "393.1700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 43 4MATIC",
      "CO2 (g/mi)": "417.5100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63 S (coupe)",
      "CO2 (g/mi)": "630.4500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT S",
      "CO2 (g/mi)": "295.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (convertible)",
      "CO2 (g/mi)": "496.8900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65",
      "CO2 (g/mi)": "646.6300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65 (convertible)",
      "CO2 (g/mi)": "647.0800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65 (coupe)",
      "CO2 (g/mi)": "549.4200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SL 65",
      "CO2 (g/mi)": "655.9000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SLC 43",
      "CO2 (g/mi)": "342.8300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "B-class electric drive",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "284.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (convertible)",
      "CO2 (g/mi)": "302.5860000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (coupe)",
      "CO2 (g/mi)": "306.6670000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "287.0500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (convertible)",
      "CO2 (g/mi)": "318.1360000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (coupe)",
      "CO2 (g/mi)": "308.0750000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350e",
      "CO2 (g/mi)": "237.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "287.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "297.1100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "304.6500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "395.9400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "411.6600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG 4MATIC",
      "CO2 (g/mi)": "457.9700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 300",
      "CO2 (g/mi)": "313.4700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 300 4MATIC",
      "CO2 (g/mi)": "318.5300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (convertible)",
      "CO2 (g/mi)": "342.1700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (coupe)",
      "CO2 (g/mi)": "345.1100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (coupe)",
      "CO2 (g/mi)": "349.9900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (station wagon)",
      "CO2 (g/mi)": "372.4500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (convertible)",
      "CO2 (g/mi)": "414.8600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 550 (coupe)",
      "CO2 (g/mi)": "404.3800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "564.7500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550 4x4",
      "CO2 (g/mi)": "690.8100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 63 AMG",
      "CO2 (g/mi)": "736.6000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "286.4100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "302.6000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "315.4900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300",
      "CO2 (g/mi)": "319.2200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC",
      "CO2 (g/mi)": "330.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC (coupe)",
      "CO2 (g/mi)": "325.2510000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 400 4MATIC",
      "CO2 (g/mi)": "393.8000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 450 AMG (coupe)",
      "CO2 (g/mi)": "407.7200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 550 e 4MATIC",
      "CO2 (g/mi)": "327.5700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 450 4MATIC",
      "CO2 (g/mi)": "429.7500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 550 4MATIC",
      "CO2 (g/mi)": "504.4600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach S 600",
      "CO2 (g/mi)": "560.3000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach S 650 (convertible)",
      "CO2 (g/mi)": "685.5900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van)",
      "CO2 (g/mi)": "334.2668850",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Passenger Van)",
      "CO2 (g/mi)": "253.8400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "390.7000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "403.8200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "520.5400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550",
      "CO2 (g/mi)": "407.9900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 (convertible)",
      "CO2 (g/mi)": "415.5900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC",
      "CO2 (g/mi)": "429.8200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC (coupe)",
      "CO2 (g/mi)": "418.5100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 4MATIC Maybach",
      "CO2 (g/mi)": "441.5700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 550 e",
      "CO2 (g/mi)": "294.6300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 600",
      "CO2 (g/mi)": "542.9900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC",
      "CO2 (g/mi)": "565.4600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 63 AMG 4MATIC (coupe)",
      "CO2 (g/mi)": "465.1300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 450",
      "CO2 (g/mi)": "342.0500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "256.3100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "448.5700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 300",
      "CO2 (g/mi)": "193.6400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart ForTwo (convertible)",
      "CO2 (g/mi)": "199.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo (Coupe)",
      "CO2 (g/mi)": "213.1370000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo Electric Drive (convertible)",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo Electric Drive (coupe)",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "i-MiEV",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "LANCER AWD",
      "CO2 (g/mi)": "300.2158700",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "196.1790600",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE G4",
      "CO2 (g/mi)": "201.9351300",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "278.8340000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "349.1304700",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "298.7226600",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "213.3379200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 AWD PREMIUM",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM",
      "CO2 (g/mi)": "330.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S AWD SPORT",
      "CO2 (g/mi)": "245.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50S SPORT",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7",
      "CO2 (g/mi)": "388.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7 AWD",
      "CO2 (g/mi)": "262.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 AWD 5.6",
      "CO2 (g/mi)": "460.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX30 AWD Base",
      "CO2 (g/mi)": "210.0459271",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX30 Premium",
      "CO2 (g/mi)": "282.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX50 AWD Journey",
      "CO2 (g/mi)": "409.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 AWD",
      "CO2 (g/mi)": "363.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX60 FWD",
      "CO2 (g/mi)": "256.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX70 AWD",
      "CO2 (g/mi)": "444.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX70 RWD",
      "CO2 (g/mi)": "420.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 2WD",
      "CO2 (g/mi)": "516.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 4WD",
      "CO2 (g/mi)": "539.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50",
      "CO2 (g/mi)": "367.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD",
      "CO2 (g/mi)": "365.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 HYBRID",
      "CO2 (g/mi)": "196.2757315",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 HYBRID AWD",
      "CO2 (g/mi)": "264.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50S",
      "CO2 (g/mi)": "370.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50S AWD",
      "CO2 (g/mi)": "387.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60",
      "CO2 (g/mi)": "366.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD",
      "CO2 (g/mi)": "363.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60a AWD",
      "CO2 (g/mi)": "369.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60S",
      "CO2 (g/mi)": "235.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60S AWD",
      "CO2 (g/mi)": "246.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q70 HYBRID",
      "CO2 (g/mi)": "242.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 AWD",
      "CO2 (g/mi)": "368.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 FWD",
      "CO2 (g/mi)": "238.7095314",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 2WD",
      "CO2 (g/mi)": "507.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 4WD",
      "CO2 (g/mi)": "545.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD",
      "CO2 (g/mi)": "419.1436882",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD FFV",
      "CO2 (g/mi)": "452.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD",
      "CO2 (g/mi)": "472.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD FFV",
      "CO2 (g/mi)": "295.7370973",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "JUKE",
      "CO2 (g/mi)": "188.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "JUKE AWD",
      "CO2 (g/mi)": "205.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA",
      "CO2 (g/mi)": "328.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z Touring",
      "CO2 (g/mi)": "393.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA SL",
      "CO2 (g/mi)": "301.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA SR 2.5",
      "CO2 (g/mi)": "261.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5MT",
      "CO2 (g/mi)": "366.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "511.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE NISMO RS",
      "CO2 (g/mi)": "201.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN JUKE SV",
      "CO2 (g/mi)": "277.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF S",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN LEAF SV",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD  SL",
      "CO2 (g/mi)": "336.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD SL",
      "CO2 (g/mi)": "216.3253593",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 Cargo Van S",
      "CO2 (g/mi)": "358.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 NYC Taxi STD",
      "CO2 (g/mi)": "341.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN QUEST LE",
      "CO2 (g/mi)": "365.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA S",
      "CO2 (g/mi)": "255.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN SENTRA SL",
      "CO2 (g/mi)": "166.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA NOTE S",
      "CO2 (g/mi)": "247.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA NOTE SV",
      "CO2 (g/mi)": "215.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA S",
      "CO2 (g/mi)": "264.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN VERSA SV",
      "CO2 (g/mi)": "212.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 2WD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 4WD",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 4WD PLATINUM",
      "CO2 (g/mi)": "374.9089424",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD",
      "CO2 (g/mi)": "282.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD Hybrid",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD",
      "CO2 (g/mi)": "267.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD Hybrid SL",
      "CO2 (g/mi)": "199.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport",
      "CO2 (g/mi)": "254.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport AWD",
      "CO2 (g/mi)": "199.1313147",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA",
      "CO2 (g/mi)": "255.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA NISMO",
      "CO2 (g/mi)": "192.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 2WD",
      "CO2 (g/mi)": "467.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD",
      "CO2 (g/mi)": "466.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD PRO-4X",
      "CO2 (g/mi)": "507.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "353.2500000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "359.0100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "325.1600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 GTS",
      "CO2 (g/mi)": "352.3900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 GTS Cabriolet",
      "CO2 (g/mi)": "352.7400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "358.7200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "324.4700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "358.2400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera GTS",
      "CO2 (g/mi)": "340.9400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera GTS Cabriolet",
      "CO2 (g/mi)": "351.9400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "359.1400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "359.4900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4",
      "CO2 (g/mi)": "363.6600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4 GTS",
      "CO2 (g/mi)": "357.9600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4S",
      "CO2 (g/mi)": "364.1100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "378.6600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Coupe",
      "CO2 (g/mi)": "377.7800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "310.1900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "327.6300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "386.9000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "439.3600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Platinum",
      "CO2 (g/mi)": "408.1600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "419.9900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S e-Hybrid",
      "CO2 (g/mi)": "335.7700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "306.4114200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan",
      "CO2 (g/mi)": "249.6599932",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan GTS",
      "CO2 (g/mi)": "426.5000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "418.4900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo",
      "CO2 (g/mi)": "275.7519138",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo Kit",
      "CO2 (g/mi)": "435.8700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "325.7600000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 Executive",
      "CO2 (g/mi)": "334.1900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "336.3400000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "382.8800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Rimac",
      "Represented Test Veh Model": "Concept_One",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Dawn",
      "CO2 (g/mi)": "603.6100000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "628.1900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "348.2900000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom EWB",
      "CO2 (g/mi)": "538.7700000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "584.8800000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "634.2795781",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "300.1000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "283.1214290",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "231.3477200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA 4-Door",
      "CO2 (g/mi)": "234.5877730",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "264.2692390",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK",
      "CO2 (g/mi)": "275.6808450",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "438.4891980",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX STI",
      "CO2 (g/mi)": "416.3772380",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "XV Crosstrek",
      "CO2 (g/mi)": "264.9277220",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "86",
      "CO2 (g/mi)": "288.6383830",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Long Range",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "100D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "60D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "60R",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75R",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "90D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P90D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "100D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "60D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "90D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "CT 200h",
      "CO2 (g/mi)": "153.6949500",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "222.8797967",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "337.2546768",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 200t F SPORT",
      "CO2 (g/mi)": "336.1858146",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "354.0594128",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "365.8044844",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 F SPORT",
      "CO2 (g/mi)": "229.9275437",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "300.3077200",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS F",
      "CO2 (g/mi)": "272.8677435",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "516.2117185",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 200t",
      "CO2 (g/mi)": "314.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350",
      "CO2 (g/mi)": "436.0199670",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 350 AWD",
      "CO2 (g/mi)": "457.4575183",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 AWD",
      "CO2 (g/mi)": "454.7875086",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L",
      "CO2 (g/mi)": "432.5436445",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 460 L AWD",
      "CO2 (g/mi)": "458.9144360",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.2030260",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "203.0984779",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "425.9731312",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "227.9272582",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "240.0782630",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "214.0406074",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iM",
      "CO2 (g/mi)": "254.4780754",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "447.2603826",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "297.6840424",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "285.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid LE",
      "CO2 (g/mi)": "156.5325481",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "Camry Hybrid XLE",
      "CO2 (g/mi)": "157.2902683",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "246.1944050",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA LE ECO",
      "CO2 (g/mi)": "150.9532104",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "416.3827594",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "358.4739663",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD LE",
      "CO2 (g/mi)": "347.0155130",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "284.9191000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LE Plus",
      "CO2 (g/mi)": "279.3281515",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER LE/XLE/SE/LTD",
      "CO2 (g/mi)": "333.2856397",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "549.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "123.7047548",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "167.7650525",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Eco",
      "CO2 (g/mi)": "153.2872691",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS PRIME",
      "CO2 (g/mi)": "180.4342403",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS v",
      "CO2 (g/mi)": "148.3199728",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "293.4932214",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "218.0924634",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 HYBRID AWD",
      "CO2 (g/mi)": "197.1758551",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 Limited AWD",
      "CO2 (g/mi)": "315.5786047",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "550.6731501",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "374.2080431",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "566.5345276",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "380.4200000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "403.2300000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "270.3917020",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "281.7765016",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD D-CAB V6 MT OFF-ROAD",
      "CO2 (g/mi)": "319.0533243",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD FFV",
      "CO2 (g/mi)": "352.7597544",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "560.4281712",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "549.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "CC",
      "CO2 (g/mi)": "307.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "386.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "PASSAT CC 4MOTION",
      "CO2 (g/mi)": "265.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "356.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Touareg",
      "CO2 (g/mi)": "416.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "277.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 e-tron",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 ultra",
      "CO2 (g/mi)": "285.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "213.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "430.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A3",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A6",
      "CO2 (g/mi)": "272.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi TT",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Huracan",
      "CO2 (g/mi)": "540.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "448.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "389.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "490.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S3",
      "CO2 (g/mi)": "356.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S6",
      "CO2 (g/mi)": "408.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8 Plus",
      "CO2 (g/mi)": "422.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "415.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT RS",
      "CO2 (g/mi)": "384.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTS",
      "CO2 (g/mi)": "314.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga",
      "CO2 (g/mi)": "596.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT Supersports",
      "CO2 (g/mi)": "714.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Mulsanne Speed",
      "CO2 (g/mi)": "642.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan",
      "CO2 (g/mi)": "336.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "188.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "e-Golf",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "174.5461889",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf Alltrack",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf R",
      "CO2 (g/mi)": "334.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "290.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 Inscription T5 FWD",
      "CO2 (g/mi)": "270.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 Polestar AWD",
      "CO2 (g/mi)": "227.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD",
      "CO2 (g/mi)": "308.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD Inscription",
      "CO2 (g/mi)": "303.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "195.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T5 FWD",
      "CO2 (g/mi)": "296.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T6 AWD",
      "CO2 (g/mi)": "319.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 CC T5 AWD",
      "CO2 (g/mi)": "318.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90 CC T6 AWD",
      "CO2 (g/mi)": "315.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "218.3736256",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 FWD",
      "CO2 (g/mi)": "307.1842762",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "230.2093372",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 AWD",
      "CO2 (g/mi)": "394.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 FWD",
      "CO2 (g/mi)": "381.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T6 AWD",
      "CO2 (g/mi)": "413.0000000",
    },
    {
      "Model Year": "2017",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T8 AWD",
      "CO2 (g/mi)": "240.0000000",
    },
  ],
  2018: [
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11",
      "CO2 (g/mi)": "466.8700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11 V8",
      "CO2 (g/mi)": "386.6600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide S",
      "CO2 (g/mi)": "511.9300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vanquish",
      "CO2 (g/mi)": "536.1800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT",
      "CO2 (g/mi)": "510.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Convertible",
      "CO2 (g/mi)": "195.2600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Coupe",
      "CO2 (g/mi)": "337.1654796",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i xDrive Convertible",
      "CO2 (g/mi)": "301.3100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i xDrive Coupe",
      "CO2 (g/mi)": "292.7719933",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i",
      "CO2 (g/mi)": "291.8700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "320i xDrive",
      "CO2 (g/mi)": "299.0400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d",
      "CO2 (g/mi)": "241.1100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive",
      "CO2 (g/mi)": "246.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "328d xDrive Sports Wagon",
      "CO2 (g/mi)": "177.5800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330e",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i",
      "CO2 (g/mi)": "286.9500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive",
      "CO2 (g/mi)": "297.4300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Gran Turismo",
      "CO2 (g/mi)": "302.3700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Sports Wagon",
      "CO2 (g/mi)": "308.7500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i",
      "CO2 (g/mi)": "304.5600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive",
      "CO2 (g/mi)": "302.9800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive Gran Turismo",
      "CO2 (g/mi)": "323.4998000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Convertible",
      "CO2 (g/mi)": "293.0300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Coupe",
      "CO2 (g/mi)": "286.5300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Gran Coupe",
      "CO2 (g/mi)": "293.8100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Convertible",
      "CO2 (g/mi)": "317.4800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Coupe",
      "CO2 (g/mi)": "298.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Gran Coupe",
      "CO2 (g/mi)": "303.4200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Convertible",
      "CO2 (g/mi)": "321.6900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Coupe",
      "CO2 (g/mi)": "320.8518782",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Gran Coupe",
      "CO2 (g/mi)": "309.1500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Convertible",
      "CO2 (g/mi)": "334.1400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Coupe",
      "CO2 (g/mi)": "203.6838967",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Gran Coupe",
      "CO2 (g/mi)": "321.2500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e xDrive",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i",
      "CO2 (g/mi)": "281.4700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i xDrive",
      "CO2 (g/mi)": "299.1900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540d xDrive",
      "CO2 (g/mi)": "299.2400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i",
      "CO2 (g/mi)": "342.1100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i xDrive",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.5600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Convertible",
      "CO2 (g/mi)": "361.1900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Gran Turismo",
      "CO2 (g/mi)": "353.6508000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.2500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Convertible",
      "CO2 (g/mi)": "458.9600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740e xDrive",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i",
      "CO2 (g/mi)": "316.1800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i xDrive",
      "CO2 (g/mi)": "356.2900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "401.2950194",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i xDrive",
      "CO2 (g/mi)": "408.4672002",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 xDrive",
      "CO2 (g/mi)": "460.4939000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 BEV",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3 REX",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s (94Ah)",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s REX",
      "CO2 (g/mi)": "189.4700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2",
      "CO2 (g/mi)": "341.3400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i",
      "CO2 (g/mi)": "312.2200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i Convertible",
      "CO2 (g/mi)": "322.8400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive",
      "CO2 (g/mi)": "319.7018000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive Convertible",
      "CO2 (g/mi)": "324.6900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "431.7019000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Convertible",
      "CO2 (g/mi)": "442.6620925",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "406.6300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M550i xDrive",
      "CO2 (g/mi)": "250.7258000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.3900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M760i xDrive",
      "CO2 (g/mi)": "534.2102000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "297.3500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "305.5200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 sDrive 28i",
      "CO2 (g/mi)": "305.9010000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 xDrive 28i",
      "CO2 (g/mi)": "324.0306000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 M40i",
      "CO2 (g/mi)": "356.9575647",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive30i",
      "CO2 (g/mi)": "318.0900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 M40i",
      "CO2 (g/mi)": "369.9900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive 28i",
      "CO2 (g/mi)": "345.5600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M",
      "CO2 (g/mi)": "491.6200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive35i",
      "CO2 (g/mi)": "372.2200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35d",
      "CO2 (g/mi)": "243.0306358",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive35i",
      "CO2 (g/mi)": "376.6880000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive40e",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "503.7440585",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 sDrive35i",
      "CO2 (g/mi)": "374.0300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive 50i",
      "CO2 (g/mi)": "327.4629234",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "376.2900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "450.2800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JOHN COOPER WORKS COUNTRYMAN ALL4",
      "CO2 (g/mi)": "309.8708000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "272.0300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman ALL4",
      "CO2 (g/mi)": "202.6000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "252.9800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "277.0100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman ALL4",
      "CO2 (g/mi)": "308.7500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 2 DOOR",
      "CO2 (g/mi)": "174.7547433",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 4 DOOR",
      "CO2 (g/mi)": "239.7700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (3-doors)",
      "CO2 (g/mi)": "190.9800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (5-doors)",
      "CO2 (g/mi)": "265.2428420",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "187.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman ALL4",
      "CO2 (g/mi)": "336.8100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "266.2218692",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "287.5400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman ALL4",
      "CO2 (g/mi)": "300.2400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "Mini Cooper SE Countryman ALL4",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI JOHN COOPER WORKS CLUBMAN ALL4",
      "CO2 (g/mi)": "293.6900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI JOHN COOPER WORKS CONVERTIBLE",
      "CO2 (g/mi)": "190.8100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI John Cooper Works Hardtop",
      "CO2 (g/mi)": "271.9708968",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.3201400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia",
      "CO2 (g/mi)": "292.9918000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia AWD",
      "CO2 (g/mi)": "308.0348100",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio AWD",
      "CO2 (g/mi)": "320.2688100",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "406.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.5133500",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica",
      "CO2 (g/mi)": "366.5736700",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica Hybrid",
      "CO2 (g/mi)": "386.6835000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.5665300",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
      "CO2 (g/mi)": "431.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.5503600",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.3954300",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "413.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.3990000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango AWD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "510.2874757",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango SRT AWD",
      "CO2 (g/mi)": "562.3241400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "411.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "124 Spider",
      "CO2 (g/mi)": "258.6946290",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "183.3460000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X",
      "CO2 (g/mi)": "276.1264700",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X AWD",
      "CO2 (g/mi)": "329.2636600",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee",
      "CO2 (g/mi)": "339.4883900",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "252.8690000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "382.9957700",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "206.9866687",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "384.1057600",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X2",
      "CO2 (g/mi)": "306.4890200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "321.3667976",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "359.7397000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "384.4514900",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.0799600",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee TrackHawk 4x4",
      "CO2 (g/mi)": "644.5683800",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "201.8611563",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "276.0878200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4WD",
      "CO2 (g/mi)": "447.3415500",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4X4",
      "CO2 (g/mi)": "256.3254208",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler Unlimited 4X4",
      "CO2 (g/mi)": "418.9974300",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X2",
      "CO2 (g/mi)": "261.2366638",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "423.4857178",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 GTB",
      "CO2 (g/mi)": "448.4425486",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "812 Superfast",
      "CO2 (g/mi)": "605.5068000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "California T",
      "CO2 (g/mi)": "448.8910000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso",
      "CO2 (g/mi)": "641.1826000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso T",
      "CO2 (g/mi)": "505.9614200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "1.0L EcoSport",
      "CO2 (g/mi)": "337.0470000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "C-Max (HEV)",
      "CO2 (g/mi)": "152.7182648",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EcoSport",
      "CO2 (g/mi)": "295.6700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge",
      "CO2 (g/mi)": "344.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape",
      "CO2 (g/mi)": "341.3180000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "318.3360000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "330.6130000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "254.5780000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "Explorer",
      "CO2 (g/mi)": "470.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer AWD",
      "CO2 (g/mi)": "247.2180000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
      "CO2 (g/mi)": "379.5378552",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "442.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, FWD",
      "CO2 (g/mi)": "421.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150",
      "CO2 (g/mi)": "360.0240000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X4 SUPER CREW CAB",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Regular Cab",
      "CO2 (g/mi)": "361.8080000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Cab",
      "CO2 (g/mi)": "262.0693515",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 SuperCab",
      "CO2 (g/mi)": "274.0690000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4x2",
      "CO2 (g/mi)": "240.6479950",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4x4",
      "CO2 (g/mi)": "374.0700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Cab 4X2",
      "CO2 (g/mi)": "353.8440000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Cab 4X4",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Crew Cab 4X2",
      "CO2 (g/mi)": "357.1480000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "174.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fiesta ST",
      "CO2 (g/mi)": "263.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "452.2200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS",
      "CO2 (g/mi)": "279.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Focus RS",
      "CO2 (g/mi)": "356.4520000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FOCUS ST",
      "CO2 (g/mi)": "309.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion",
      "CO2 (g/mi)": "294.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "141.5150000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (PHEV)",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion FWD",
      "CO2 (g/mi)": "303.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "GT",
      "CO2 (g/mi)": "589.7090000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ",
      "CO2 (g/mi)": "227.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
      "CO2 (g/mi)": "528.2120000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility",
      "CO2 (g/mi)": "450.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Special Service Police",
      "CO2 (g/mi)": "350.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T150 Transit Wagon MDPV",
      "CO2 (g/mi)": "494.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T250 Transit Van MDPV",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TAURUS",
      "CO2 (g/mi)": "401.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "460.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "401.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FFV",
      "CO2 (g/mi)": "231.4430000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON LWB FFV",
      "CO2 (g/mi)": "225.9560000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT T150 WAGON FFV",
      "CO2 (g/mi)": "496.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Continental",
      "CO2 (g/mi)": "230.1460000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKC",
      "CO2 (g/mi)": "368.4450000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "426.4880000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX AWD",
      "CO2 (g/mi)": "423.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKX FWD",
      "CO2 (g/mi)": "247.5320000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator",
      "CO2 (g/mi)": "449.2490000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "CASCADA",
      "CO2 (g/mi)": "387.6000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE",
      "CO2 (g/mi)": "244.8000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "210.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION AWD",
      "CO2 (g/mi)": "372.6000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION FWD",
      "CO2 (g/mi)": "215.8640000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "287.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "211.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "318.0245022",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL AWD",
      "CO2 (g/mi)": "326.7050000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL TOURX  AWD",
      "CO2 (g/mi)": "329.6880000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS",
      "CO2 (g/mi)": "309.3480000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS AWD",
      "CO2 (g/mi)": "318.8690000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS-V",
      "CO2 (g/mi)": "420.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6",
      "CO2 (g/mi)": "317.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 AWD",
      "CO2 (g/mi)": "243.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 HYBRID",
      "CO2 (g/mi)": "278.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS",
      "CO2 (g/mi)": "318.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN",
      "CO2 (g/mi)": "327.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS SEDAN AWD",
      "CO2 (g/mi)": "227.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS-V",
      "CO2 (g/mi)": "505.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "488.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD",
      "CO2 (g/mi)": "525.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5",
      "CO2 (g/mi)": "361.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 AWD",
      "CO2 (g/mi)": "385.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS",
      "CO2 (g/mi)": "390.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "276.6212495",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "489.6120000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BOLT",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C15 SILVERADO 2WD",
      "CO2 (g/mi)": "267.0153485",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 SUBURBAN 2WD",
      "CO2 (g/mi)": "442.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "320.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "385.9980000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO ZR2 4WD",
      "CO2 (g/mi)": "495.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "425.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "248.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX",
      "CO2 (g/mi)": "266.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "206.8721378",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "282.9838867",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "334.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K15 SILVERADO 4WD",
      "CO2 (g/mi)": "430.3440000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 SUBURBAN 4WD",
      "CO2 (g/mi)": "521.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "293.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "253.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "256.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC 5",
      "CO2 (g/mi)": "200.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "256.8000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE",
      "CO2 (g/mi)": "348.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE AWD",
      "CO2 (g/mi)": "415.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX",
      "CO2 (g/mi)": "267.9090000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "145.3020000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA AWD",
      "CO2 (g/mi)": "394.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA FWD",
      "CO2 (g/mi)": "397.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON 2WD",
      "CO2 (g/mi)": "368.8000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON 4WD",
      "CO2 (g/mi)": "407.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON CAB CHASSIS 2WD",
      "CO2 (g/mi)": "483.7737122",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K15 SIERRA 4WD",
      "CO2 (g/mi)": "473.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K1500 YUKON XL 4WD",
      "CO2 (g/mi)": "532.2890000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN AWD",
      "CO2 (g/mi)": "340.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN FWD",
      "CO2 (g/mi)": "200.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "273.0900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "NSX",
      "CO2 (g/mi)": "291.8200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 2WD",
      "CO2 (g/mi)": "354.1600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX 4WD",
      "CO2 (g/mi)": "369.9700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "214.0488335",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX HYBRID",
      "CO2 (g/mi)": "231.0800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX",
      "CO2 (g/mi)": "186.2668184",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "234.7600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "227.0500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2.0L",
      "CO2 (g/mi)": "238.5600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 1.5L",
      "CO2 (g/mi)": "234.3100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 1.5L",
      "CO2 (g/mi)": "225.8500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 2.0L",
      "CO2 (g/mi)": "244.0100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR",
      "CO2 (g/mi)": "248.0200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR Type-R",
      "CO2 (g/mi)": "327.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC Si",
      "CO2 (g/mi)": "242.2900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Fuel Cell",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Plug-in Hybrid",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 1.5L TC",
      "CO2 (g/mi)": "253.0500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2.4L",
      "CO2 (g/mi)": "278.4100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "217.3500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EX",
      "CO2 (g/mi)": "171.4900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT LX",
      "CO2 (g/mi)": "232.0400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "HR-V 2WD",
      "CO2 (g/mi)": "271.7600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "HR-V 4WD",
      "CO2 (g/mi)": "194.5819198",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX AWD",
      "CO2 (g/mi)": "361.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX FWD",
      "CO2 (g/mi)": "358.3700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX HYBRID",
      "CO2 (g/mi)": "257.2100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY",
      "CO2 (g/mi)": "378.9200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY FWD",
      "CO2 (g/mi)": "364.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 6AT",
      "CO2 (g/mi)": "358.7800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 9AT",
      "CO2 (g/mi)": "349.8300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 9AT",
      "CO2 (g/mi)": "251.3700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE AWD",
      "CO2 (g/mi)": "381.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE FWD",
      "CO2 (g/mi)": "374.6500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "TLX V6 AWD",
      "CO2 (g/mi)": "355.5300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "TLX V6 FWD",
      "CO2 (g/mi)": "359.0700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "250.3819000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "286.0435000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "G80",
      "CO2 (g/mi)": "411.9397000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "G90",
      "CO2 (g/mi)": "412.6748814",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ PHEV",
      "CO2 (g/mi)": "124.4560000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "KONA",
      "CO2 (g/mi)": "185.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "389.6984000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Sport",
      "CO2 (g/mi)": "352.5065000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Ultimate",
      "CO2 (g/mi)": "422.8205000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "290.2820000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata Hybrid",
      "CO2 (g/mi)": "159.8366000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA PLUG-IN HYBRID",
      "CO2 (g/mi)": "236.0684000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "247.8189000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "328.4947000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Fe",
      "CO2 (g/mi)": "272.6336000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Hybrid",
      "CO2 (g/mi)": "220.8169000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA PLUG-IN HYBRID",
      "CO2 (g/mi)": "230.4345000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "E-Pace 250PS",
      "CO2 (g/mi)": "326.3589000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "E-Pace 300PS",
      "CO2 (g/mi)": "334.4797000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-PACE",
      "CO2 (g/mi)": "215.1800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE",
      "CO2 (g/mi)": "354.2846000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type AWD",
      "CO2 (g/mi)": "391.0100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Convertible",
      "CO2 (g/mi)": "301.8080000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Manual",
      "CO2 (g/mi)": "463.8200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE",
      "CO2 (g/mi)": "339.0044000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE AWD",
      "CO2 (g/mi)": "316.9184000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "348.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "298.3083000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF Sportbrake",
      "CO2 (g/mi)": "389.7826000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "424.3200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ AWD LWB",
      "CO2 (g/mi)": "424.9700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "483.1100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL",
      "CO2 (g/mi)": "390.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery",
      "CO2 (g/mi)": "450.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport 250PS",
      "CO2 (g/mi)": "339.9661000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport 300PS",
      "CO2 (g/mi)": "349.7078000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "437.9219000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover 3.0 PZEV",
      "CO2 (g/mi)": "429.0500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover LWB",
      "CO2 (g/mi)": "549.8691000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "248.8020274",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport SVR",
      "CO2 (g/mi)": "496.6958000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover SVA",
      "CO2 (g/mi)": "524.5657000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Velar",
      "CO2 (g/mi)": "334.0794000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Velar",
      "CO2 (g/mi)": "391.1078000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque 250PS",
      "CO2 (g/mi)": "323.0326000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque 300PS",
      "CO2 (g/mi)": "340.3003000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque Cabriolet 250PS",
      "CO2 (g/mi)": "331.9339000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Karma",
      "Represented Test Veh Model": "Revero",
      "CO2 (g/mi)": "395.6302000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ACCENT",
      "CO2 (g/mi)": "262.5710033",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "347.3516000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "CK",
      "CO2 (g/mi)": "326.8496000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "278.1662000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Forte5",
      "CO2 (g/mi)": "277.4187664",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900",
      "CO2 (g/mi)": "481.6413000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "K900 EX",
      "CO2 (g/mi)": "421.5964000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "NIRO",
      "CO2 (g/mi)": "205.7378000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Niro Plug-in",
      "CO2 (g/mi)": "140.1986000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "243.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona",
      "CO2 (g/mi)": "402.4325000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SX",
      "CO2 (g/mi)": "391.9028000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sedona SXL",
      "CO2 (g/mi)": "433.0131000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "248.8973000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "293.6600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul Electric",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "375.9552580",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Koenigsegg",
      "Represented Test Veh Model": "CC-X Agera",
      "CO2 (g/mi)": "669.9600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR",
      "CO2 (g/mi)": "784.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6 AWD",
      "CO2 (g/mi)": "446.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S RWD 405HP",
      "CO2 (g/mi)": "439.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "427.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "560.2580000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO SPORT",
      "CO2 (g/mi)": "560.1360000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE",
      "CO2 (g/mi)": "487.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE S",
      "CO2 (g/mi)": "495.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "490.6000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "449.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "455.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-3",
      "CO2 (g/mi)": "195.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "285.8510000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-9",
      "CO2 (g/mi)": "340.5880000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "214.9380000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "244.1310000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda6",
      "CO2 (g/mi)": "293.7800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "263.4460000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC",
      "CO2 (g/mi)": "351.3200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (convertible)",
      "CO2 (g/mi)": "364.1839674",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (coupe)",
      "CO2 (g/mi)": "352.8500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63",
      "CO2 (g/mi)": "416.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 (convertible)",
      "CO2 (g/mi)": "424.9100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 43 4MATIC",
      "CO2 (g/mi)": "250.8600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 S 4MATIC",
      "CO2 (g/mi)": "467.0530000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 S 4MATIC (station wagon)",
      "CO2 (g/mi)": "457.7320000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G 63",
      "CO2 (g/mi)": "613.8300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G65",
      "CO2 (g/mi)": "758.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC",
      "CO2 (g/mi)": "395.3600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC (coupe)",
      "CO2 (g/mi)": "393.1700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 4MATIC",
      "CO2 (g/mi)": "290.0900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 4MATIC (coupe)",
      "CO2 (g/mi)": "454.7500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 S 4MATIC (coupe)",
      "CO2 (g/mi)": "456.4300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 43 4MATIC",
      "CO2 (g/mi)": "406.6800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 43 4MATIC (coupe)",
      "CO2 (g/mi)": "406.7400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63 S (coupe)",
      "CO2 (g/mi)": "532.5400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT (roadster)",
      "CO2 (g/mi)": "446.2650000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT C (roadster)",
      "CO2 (g/mi)": "470.1916000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT R (coupe)",
      "CO2 (g/mi)": "472.1826000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT S",
      "CO2 (g/mi)": "295.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC",
      "CO2 (g/mi)": "425.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (convertible)",
      "CO2 (g/mi)": "481.6200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (coupe)",
      "CO2 (g/mi)": "420.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65",
      "CO2 (g/mi)": "572.9100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65 (convertible)",
      "CO2 (g/mi)": "647.0800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65 (coupe)",
      "CO2 (g/mi)": "549.4200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SL 65",
      "CO2 (g/mi)": "655.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SLC 43",
      "CO2 (g/mi)": "342.8300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "288.1582800",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (convertible)",
      "CO2 (g/mi)": "310.6829000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (coupe)",
      "CO2 (g/mi)": "202.7031000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "296.6210000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (convertible)",
      "CO2 (g/mi)": "319.9220000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (coupe)",
      "CO2 (g/mi)": "309.6680000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 350e",
      "CO2 (g/mi)": "237.3000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "165.6696395",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "289.4300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "304.6500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550",
      "CO2 (g/mi)": "395.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 550 4MATIC",
      "CO2 (g/mi)": "411.6600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 63 AMG 4MATIC",
      "CO2 (g/mi)": "457.9700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 300",
      "CO2 (g/mi)": "313.4700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 300 4MATIC",
      "CO2 (g/mi)": "326.4300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (convertible)",
      "CO2 (g/mi)": "351.6800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 (coupe)",
      "CO2 (g/mi)": "350.7100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC",
      "CO2 (g/mi)": "355.9500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (convertible)",
      "CO2 (g/mi)": "357.2500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (coupe)",
      "CO2 (g/mi)": "350.7400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 400 4MATIC (station wagon)",
      "CO2 (g/mi)": "372.4500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "564.7500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550 4x4",
      "CO2 (g/mi)": "690.8100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GL 63 AMG",
      "CO2 (g/mi)": "541.0500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "286.4100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "294.2000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "315.4900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300",
      "CO2 (g/mi)": "319.2200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC",
      "CO2 (g/mi)": "330.2500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC (coupe)",
      "CO2 (g/mi)": "325.2510000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 350e 4MATIC",
      "CO2 (g/mi)": "278.9500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 550 e 4MATIC",
      "CO2 (g/mi)": "327.5700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 450 4MATIC",
      "CO2 (g/mi)": "429.7500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 550 4MATIC",
      "CO2 (g/mi)": "504.4600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach S 650",
      "CO2 (g/mi)": "552.0100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van)",
      "CO2 (g/mi)": "343.3650000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van, LWB)",
      "CO2 (g/mi)": "336.0870000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Passenger Van)",
      "CO2 (g/mi)": "371.2940990",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350",
      "CO2 (g/mi)": "390.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 350 4MATIC",
      "CO2 (g/mi)": "403.8200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "ML 63 AMG",
      "CO2 (g/mi)": "529.3600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 450",
      "CO2 (g/mi)": "377.2800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 450 4MATIC",
      "CO2 (g/mi)": "382.5800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560",
      "CO2 (g/mi)": "392.9900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC",
      "CO2 (g/mi)": "228.5800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (convertible)",
      "CO2 (g/mi)": "415.5100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (coupe)",
      "CO2 (g/mi)": "406.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC Maybach",
      "CO2 (g/mi)": "251.2400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 450",
      "CO2 (g/mi)": "342.0500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "256.3100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 63 AMG",
      "CO2 (g/mi)": "448.5700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLK 300",
      "CO2 (g/mi)": "193.6400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo Electric Drive (convertible)",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo Electric Drive (coupe)",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS 2WD",
      "CO2 (g/mi)": "332.3484400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS 4WD",
      "CO2 (g/mi)": "349.6972400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS ES 2WD",
      "CO2 (g/mi)": "315.2418400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS ES 4WD",
      "CO2 (g/mi)": "334.8980400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "196.1790600",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE G4",
      "CO2 (g/mi)": "201.9351300",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "271.8395400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "288.3114100",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER PHEV",
      "CO2 (g/mi)": "230.6314400",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "298.7226600",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "213.3379200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 AWD PREMIUM",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM",
      "CO2 (g/mi)": "306.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7",
      "CO2 (g/mi)": "388.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 3.7 AWD",
      "CO2 (g/mi)": "262.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q70 AWD 5.6",
      "CO2 (g/mi)": "460.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX30 AWD Base",
      "CO2 (g/mi)": "210.0459271",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX30 Premium",
      "CO2 (g/mi)": "282.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 2WD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 4WD",
      "CO2 (g/mi)": "533.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD RED SPORT",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 HYBRID",
      "CO2 (g/mi)": "196.2757315",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 HYBRID AWD",
      "CO2 (g/mi)": "264.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 RED SPORT",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60",
      "CO2 (g/mi)": "365.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD RED SPORT",
      "CO2 (g/mi)": "377.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 RED SPORT",
      "CO2 (g/mi)": "226.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q70 HYBRID",
      "CO2 (g/mi)": "242.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 AWD",
      "CO2 (g/mi)": "242.0857527",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 FWD",
      "CO2 (g/mi)": "238.7095314",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX80 4WD",
      "CO2 (g/mi)": "539.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA",
      "CO2 (g/mi)": "263.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA SR",
      "CO2 (g/mi)": "256.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 2WD",
      "CO2 (g/mi)": "507.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 4WD",
      "CO2 (g/mi)": "530.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD",
      "CO2 (g/mi)": "419.1436882",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD FFV",
      "CO2 (g/mi)": "452.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD",
      "CO2 (g/mi)": "472.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD FFV",
      "CO2 (g/mi)": "295.7370973",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Kicks",
      "CO2 (g/mi)": "170.5723145",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA",
      "CO2 (g/mi)": "336.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN 370Z Touring",
      "CO2 (g/mi)": "393.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN ALTIMA SL",
      "CO2 (g/mi)": "301.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN FRONTIER 2WD S 4-Cyl 5MT",
      "CO2 (g/mi)": "366.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN GT-R",
      "CO2 (g/mi)": "511.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD  SL",
      "CO2 (g/mi)": "336.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN MURANO AWD SL",
      "CO2 (g/mi)": "216.3253593",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 NYC Taxi STD",
      "CO2 (g/mi)": "341.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NV200 Cargo Van",
      "CO2 (g/mi)": "351.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 2WD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 4WD",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD",
      "CO2 (g/mi)": "286.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD Hybrid",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD",
      "CO2 (g/mi)": "267.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD Hybrid SL",
      "CO2 (g/mi)": "199.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport",
      "CO2 (g/mi)": "254.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport AWD",
      "CO2 (g/mi)": "199.1313147",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA",
      "CO2 (g/mi)": "255.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA NISMO",
      "CO2 (g/mi)": "192.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 2WD",
      "CO2 (g/mi)": "467.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD",
      "CO2 (g/mi)": "466.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD PRO-4X",
      "CO2 (g/mi)": "507.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "VERSA",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Pagani Automobili",
      "Represented Test Veh Model": "PT4",
      "CO2 (g/mi)": "689.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "353.2500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "359.0100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "325.1600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 GTS",
      "CO2 (g/mi)": "352.3900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 GTS Cabriolet",
      "CO2 (g/mi)": "352.7400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "358.7200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "324.4700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "358.2400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera GTS",
      "CO2 (g/mi)": "340.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera GTS Cabriolet",
      "CO2 (g/mi)": "351.9400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "359.1400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "359.4900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera T",
      "CO2 (g/mi)": "442.1500000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT2RS",
      "CO2 (g/mi)": "464.8700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "478.2900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3R",
      "CO2 (g/mi)": "513.7700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4",
      "CO2 (g/mi)": "363.6600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4 GTS",
      "CO2 (g/mi)": "357.9600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4S",
      "CO2 (g/mi)": "364.1100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "378.6600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Coupe",
      "CO2 (g/mi)": "377.7800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Exclusive",
      "CO2 (g/mi)": "415.7200000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "310.1900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster GTS",
      "CO2 (g/mi)": "352.4300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "327.6300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "386.9000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "439.3600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Platinum",
      "CO2 (g/mi)": "408.1600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "419.9900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S e-Hybrid",
      "CO2 (g/mi)": "335.7700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "306.4114200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman GTS",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan",
      "CO2 (g/mi)": "249.6599932",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan GTS",
      "CO2 (g/mi)": "426.5000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "418.4900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo",
      "CO2 (g/mi)": "275.7519138",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo Kit",
      "CO2 (g/mi)": "435.8700000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "325.7600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 e-Hybrid ST",
      "CO2 (g/mi)": "355.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 Executive",
      "CO2 (g/mi)": "334.1900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 ST",
      "CO2 (g/mi)": "340.2600000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "336.3400000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S ST",
      "CO2 (g/mi)": "359.2900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "382.8800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo S e-Hybrid ST",
      "CO2 (g/mi)": "373.7000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo ST",
      "CO2 (g/mi)": "403.4100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Dawn",
      "CO2 (g/mi)": "603.6100000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "623.8045000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "628.1900000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Phantom",
      "CO2 (g/mi)": "615.0706000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "584.8800000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "683.4000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "RUF",
      "Represented Test Veh Model": "TURBO 12/CTR 3/CTR 2017",
      "CO2 (g/mi)": "436.1000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "283.1214290",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ tS",
      "CO2 (g/mi)": "335.6724820",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK",
      "CO2 (g/mi)": "253.7383310",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "231.3477200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA 4-Door",
      "CO2 (g/mi)": "234.5877730",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "264.2692390",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK",
      "CO2 (g/mi)": "275.6808450",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "330.1747100",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX STI",
      "CO2 (g/mi)": "425.0919020",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "86",
      "CO2 (g/mi)": "288.6383830",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Long Range",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Long Range AWD",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "100D",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75R",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "100D",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "222.8797967",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "337.2546768",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 200t F SPORT",
      "CO2 (g/mi)": "336.1858146",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "354.0594128",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "365.8044844",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 F SPORT",
      "CO2 (g/mi)": "229.9275437",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 450h",
      "CO2 (g/mi)": "300.3077200",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS F",
      "CO2 (g/mi)": "272.8677435",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "516.2117185",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 200t",
      "CO2 (g/mi)": "314.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500",
      "CO2 (g/mi)": "448.0265971",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500h",
      "CO2 (g/mi)": "314.9970977",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500",
      "CO2 (g/mi)": "368.0296296",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500 AWD",
      "CO2 (g/mi)": "391.4409874",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500h",
      "CO2 (g/mi)": "377.0087149",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500h AWD",
      "CO2 (g/mi)": "284.8068966",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "562.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.2030260",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "203.0984779",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC 350 AWD",
      "CO2 (g/mi)": "383.7962877",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "425.9731312",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "227.9272582",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "240.0782630",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "214.0406074",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "SCION",
      "Represented Test Veh Model": "iM",
      "CO2 (g/mi)": "254.4780754",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "447.2603826",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "297.6840424",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "C-HR",
      "CO2 (g/mi)": "328.8941905",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "143.4359198",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID LE",
      "CO2 (g/mi)": "193.1451720",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID XLE/SE",
      "CO2 (g/mi)": "212.3416743",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY LE/SE",
      "CO2 (g/mi)": "245.6115125",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XLE/XSE",
      "CO2 (g/mi)": "248.2167202",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XSE",
      "CO2 (g/mi)": "303.9800778",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "246.1944050",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA LE ECO",
      "CO2 (g/mi)": "150.9532104",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "416.3827594",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "358.4739663",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD LE",
      "CO2 (g/mi)": "347.0155130",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "284.9191000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LE Plus",
      "CO2 (g/mi)": "279.3281515",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER LE/XLE/SE/LTD",
      "CO2 (g/mi)": "333.2856397",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "549.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "123.7047548",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "167.7650525",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Eco",
      "CO2 (g/mi)": "153.2872691",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS PRIME",
      "CO2 (g/mi)": "180.4342403",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "293.4932214",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "218.0924634",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 HYBRID AWD",
      "CO2 (g/mi)": "197.1758551",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 Limited AWD",
      "CO2 (g/mi)": "315.5786047",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "545.8558090",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "570.1310668",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD FFV",
      "CO2 (g/mi)": "567.2733599",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "403.2300000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "270.3917020",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "281.7765016",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD D-CAB V6 MT OFF-ROAD",
      "CO2 (g/mi)": "319.0533243",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "336.2534306",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "347.3930333",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "386.3947322",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "288.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 e-tron",
      "CO2 (g/mi)": "271.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "291.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 ultra",
      "CO2 (g/mi)": "285.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6",
      "CO2 (g/mi)": "213.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "430.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A3",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi A6",
      "CO2 (g/mi)": "272.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi TT",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "448.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "389.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "525.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS5",
      "CO2 (g/mi)": "380.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS7",
      "CO2 (g/mi)": "671.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S3",
      "CO2 (g/mi)": "217.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4",
      "CO2 (g/mi)": "351.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S6",
      "CO2 (g/mi)": "448.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8 Plus",
      "CO2 (g/mi)": "422.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "270.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT RS",
      "CO2 (g/mi)": "401.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTS",
      "CO2 (g/mi)": "314.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga",
      "CO2 (g/mi)": "596.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT Supersports",
      "CO2 (g/mi)": "714.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Mulsanne Speed",
      "CO2 (g/mi)": "642.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Bugatti Chiron",
      "CO2 (g/mi)": "855.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan Superleggera",
      "CO2 (g/mi)": "559.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Atlas",
      "CO2 (g/mi)": "320.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "302.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "e-Golf",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "182.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf Alltrack",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf R",
      "CO2 (g/mi)": "313.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "GTI",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "285.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "279.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan 4Motion",
      "CO2 (g/mi)": "387.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan Limited",
      "CO2 (g/mi)": "362.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 Inscription T5 AWD",
      "CO2 (g/mi)": "308.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 Inscription T5 FWD",
      "CO2 (g/mi)": "271.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 Polestar AWD",
      "CO2 (g/mi)": "227.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "195.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T5 AWD",
      "CO2 (g/mi)": "294.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T5 FWD",
      "CO2 (g/mi)": "289.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T6 AWD",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T8 AWD",
      "CO2 (g/mi)": "183.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 CC T5 AWD",
      "CO2 (g/mi)": "318.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 Polestar AWD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90CC T5 AWD",
      "CO2 (g/mi)": "305.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90CC T6 AWD",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "317.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "232.7135370",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T8 AWD",
      "CO2 (g/mi)": "267.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 AWD",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 FWD",
      "CO2 (g/mi)": "309.0000000",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T6 AWD",
      "CO2 (g/mi)": "235.2103144",
    },
    {
      "Model Year": "2018",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T8 AWD",
      "CO2 (g/mi)": "265.0000000",
    },
  ],
  2019: [
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11",
      "CO2 (g/mi)": "466.8700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11 V8",
      "CO2 (g/mi)": "386.6600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBS",
      "CO2 (g/mi)": "499.6900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Rapide S",
      "CO2 (g/mi)": "511.9300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vanquish",
      "CO2 (g/mi)": "536.1800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vantage V8",
      "CO2 (g/mi)": "393.7600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Convertible",
      "CO2 (g/mi)": "195.2600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Coupe",
      "CO2 (g/mi)": "337.1654796",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i xDrive Convertible",
      "CO2 (g/mi)": "301.3100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i xDrive Coupe",
      "CO2 (g/mi)": "292.7719933",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i",
      "CO2 (g/mi)": "259.6720000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive",
      "CO2 (g/mi)": "276.6410000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Gran Turismo",
      "CO2 (g/mi)": "302.3700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Sports Wagon",
      "CO2 (g/mi)": "308.7500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive Gran Turismo",
      "CO2 (g/mi)": "323.4998000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Convertible",
      "CO2 (g/mi)": "293.0300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Coupe",
      "CO2 (g/mi)": "286.5300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Gran Coupe",
      "CO2 (g/mi)": "293.8100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Convertible",
      "CO2 (g/mi)": "317.4800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Coupe",
      "CO2 (g/mi)": "298.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Gran Coupe",
      "CO2 (g/mi)": "303.4200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Convertible",
      "CO2 (g/mi)": "321.6900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Coupe",
      "CO2 (g/mi)": "320.8518782",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Gran Coupe",
      "CO2 (g/mi)": "309.1500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Convertible",
      "CO2 (g/mi)": "334.1400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Coupe",
      "CO2 (g/mi)": "203.6838967",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Gran Coupe",
      "CO2 (g/mi)": "321.2500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e xDrive",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i",
      "CO2 (g/mi)": "281.4700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i xDrive",
      "CO2 (g/mi)": "299.1900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i",
      "CO2 (g/mi)": "342.1100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i xDrive",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i Convertible",
      "CO2 (g/mi)": "340.5600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Convertible",
      "CO2 (g/mi)": "361.1900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "640i xDrive Gran Turismo",
      "CO2 (g/mi)": "353.6508000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i Convertible",
      "CO2 (g/mi)": "405.2500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "650i xDrive Convertible",
      "CO2 (g/mi)": "458.9600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740e xDrive",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i",
      "CO2 (g/mi)": "316.1800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i xDrive",
      "CO2 (g/mi)": "356.2900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i",
      "CO2 (g/mi)": "401.2950194",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i xDrive",
      "CO2 (g/mi)": "408.4672002",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 LWB xDrive",
      "CO2 (g/mi)": "492.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7 xDrive",
      "CO2 (g/mi)": "460.4939000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s REX",
      "CO2 (g/mi)": "197.2565000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I8 Roadster",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2 Competition",
      "CO2 (g/mi)": "364.8300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i",
      "CO2 (g/mi)": "312.2200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i Convertible",
      "CO2 (g/mi)": "379.6500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive",
      "CO2 (g/mi)": "319.7018000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive Convertible",
      "CO2 (g/mi)": "324.6900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "431.7019000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Convertible",
      "CO2 (g/mi)": "442.6620925",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M5",
      "CO2 (g/mi)": "406.6300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M550i xDrive",
      "CO2 (g/mi)": "250.7258000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M6 Convertible",
      "CO2 (g/mi)": "496.3900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M760i xDrive",
      "CO2 (g/mi)": "534.2102000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Convertible",
      "CO2 (g/mi)": "405.1206000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Coupe",
      "CO2 (g/mi)": "388.1100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "297.3500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "305.5200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 M35i",
      "CO2 (g/mi)": "302.0400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 sDrive 28i",
      "CO2 (g/mi)": "305.9010000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 xDrive 28i",
      "CO2 (g/mi)": "324.0306000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 M40i",
      "CO2 (g/mi)": "356.9575647",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 sDrive30i",
      "CO2 (g/mi)": "201.6728848",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive30i",
      "CO2 (g/mi)": "318.0900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 M40i",
      "CO2 (g/mi)": "347.2500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive30i",
      "CO2 (g/mi)": "332.0200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M",
      "CO2 (g/mi)": "491.6200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive40i",
      "CO2 (g/mi)": "352.7224000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "420.9600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 sDrive35i",
      "CO2 (g/mi)": "374.0300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive 50i",
      "CO2 (g/mi)": "327.4629234",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive35i",
      "CO2 (g/mi)": "376.2900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive50i",
      "CO2 (g/mi)": "450.2800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 xDrive40i",
      "CO2 (g/mi)": "359.2810974",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 xDrive50i",
      "CO2 (g/mi)": "465.8257000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive30i",
      "CO2 (g/mi)": "275.0360000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JOHN COOPER WORKS COUNTRYMAN ALL4",
      "CO2 (g/mi)": "309.8708000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman",
      "CO2 (g/mi)": "272.0300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Clubman ALL4",
      "CO2 (g/mi)": "202.6000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Convertible",
      "CO2 (g/mi)": "252.9800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman",
      "CO2 (g/mi)": "277.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper Countryman ALL4",
      "CO2 (g/mi)": "308.7500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 2 DOOR",
      "CO2 (g/mi)": "174.7547433",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI COOPER HARDTOP 4 DOOR",
      "CO2 (g/mi)": "180.4500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (3-doors)",
      "CO2 (g/mi)": "190.9800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S (5-doors)",
      "CO2 (g/mi)": "265.2428420",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman",
      "CO2 (g/mi)": "187.3000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Clubman ALL4",
      "CO2 (g/mi)": "336.8100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Convertible",
      "CO2 (g/mi)": "266.2218692",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman",
      "CO2 (g/mi)": "287.5400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "Mini Cooper S Countryman ALL4",
      "CO2 (g/mi)": "300.2400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "Mini Cooper SE Countryman ALL4",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI JOHN COOPER WORKS CLUBMAN ALL4",
      "CO2 (g/mi)": "293.6900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI JOHN COOPER WORKS CONVERTIBLE",
      "CO2 (g/mi)": "190.8100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "MINI John Cooper Works Hardtop",
      "CO2 (g/mi)": "271.9708968",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.3201400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia",
      "CO2 (g/mi)": "292.9918000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia AWD",
      "CO2 (g/mi)": "308.0348100",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio",
      "CO2 (g/mi)": "299.0857400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio AWD",
      "CO2 (g/mi)": "320.2688100",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300",
      "CO2 (g/mi)": "406.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.5133500",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica",
      "CO2 (g/mi)": "366.5736700",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica Hybrid",
      "CO2 (g/mi)": "260.8730000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "410.5665300",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Avenger",
      "CO2 (g/mi)": "431.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.5503600",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.3954300",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "413.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.3990000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger SRT",
      "CO2 (g/mi)": "507.8463000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango AWD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "510.2874757",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango SRT AWD",
      "CO2 (g/mi)": "562.3241400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Journey",
      "CO2 (g/mi)": "411.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "124 Spider",
      "CO2 (g/mi)": "258.6946290",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500 Abarth",
      "CO2 (g/mi)": "247.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500e",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X AWD",
      "CO2 (g/mi)": "296.6402600",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "331.5532042",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "343.6912100",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "319.3632000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "354.2852200",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X2",
      "CO2 (g/mi)": "306.4890200",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "321.3667976",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "371.7277400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "384.4514900",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.0799600",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee TrackHawk 4x4",
      "CO2 (g/mi)": "644.5683800",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "320.0806735",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "331.5249654",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade Trailhawk 4x4",
      "CO2 (g/mi)": "355.8560000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4X4",
      "CO2 (g/mi)": "256.3254208",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler Unlimited 4X4",
      "CO2 (g/mi)": "418.9974300",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X2",
      "CO2 (g/mi)": "261.2366638",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "423.4857178",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 HFE 4X2",
      "CO2 (g/mi)": "346.1058655",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 GTB",
      "CO2 (g/mi)": "448.4425486",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 Special Series Coupe",
      "CO2 (g/mi)": "506.0203000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 Special Series Spider",
      "CO2 (g/mi)": "506.9471000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "812 Superfast",
      "CO2 (g/mi)": "605.5068000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso",
      "CO2 (g/mi)": "641.1826000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso T",
      "CO2 (g/mi)": "505.9614200",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "Portofino",
      "CO2 (g/mi)": "458.7116000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "1.0L EcoSport",
      "CO2 (g/mi)": "248.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EcoSport",
      "CO2 (g/mi)": "294.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge",
      "CO2 (g/mi)": "337.5990000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge AWD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape",
      "CO2 (g/mi)": "341.3180000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape AWD",
      "CO2 (g/mi)": "318.3360000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "352.2820000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "419.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "FORD",
      "Represented Test Veh Model": "Explorer",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer AWD",
      "CO2 (g/mi)": "247.2180000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FWD",
      "CO2 (g/mi)": "379.5378552",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, AWD",
      "CO2 (g/mi)": "442.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer Police FFV, FWD",
      "CO2 (g/mi)": "421.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150",
      "CO2 (g/mi)": "255.5360000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X4 SUPER CREW CAB",
      "CO2 (g/mi)": "380.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Regular Cab",
      "CO2 (g/mi)": "361.8080000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Cab",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 SuperCab",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4x2",
      "CO2 (g/mi)": "240.6479950",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4x4",
      "CO2 (g/mi)": "367.3660000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Cab 4X2",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Cab 4X4",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Crew Cab 4X2",
      "CO2 (g/mi)": "357.1480000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FIESTA",
      "CO2 (g/mi)": "174.5000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fiesta ST",
      "CO2 (g/mi)": "261.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FLEX",
      "CO2 (g/mi)": "404.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion",
      "CO2 (g/mi)": "292.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "141.5150000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (PHEV)",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FUSION FWD",
      "CO2 (g/mi)": "204.8040000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "GT",
      "CO2 (g/mi)": "589.7090000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ",
      "CO2 (g/mi)": "365.4020000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
      "CO2 (g/mi)": "528.2120000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor FFV",
      "CO2 (g/mi)": "463.6880000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Responder Hybrid Sedan FHEV",
      "CO2 (g/mi)": "158.9550000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger - Chassis Cab",
      "CO2 (g/mi)": "306.8520000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger - Super Crew Cab",
      "CO2 (g/mi)": "351.4940000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T150 Transit Wagon MDPV",
      "CO2 (g/mi)": "342.5960000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "T250 Transit Van MDPV",
      "CO2 (g/mi)": "359.8990235",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TAURUS",
      "CO2 (g/mi)": "379.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus FFV",
      "CO2 (g/mi)": "372.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police AWD",
      "CO2 (g/mi)": "460.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV AWD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Taurus Police FFV FWD",
      "CO2 (g/mi)": "395.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FFV",
      "CO2 (g/mi)": "192.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FWD",
      "CO2 (g/mi)": "288.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON LWB",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT T150",
      "CO2 (g/mi)": "513.1750000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT T150 WAGON FFV",
      "CO2 (g/mi)": "353.8370000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Continental",
      "CO2 (g/mi)": "230.1460000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKC",
      "CO2 (g/mi)": "369.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKT",
      "CO2 (g/mi)": "426.4880000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKZ (HEV)",
      "CO2 (g/mi)": "171.0780000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Nautilus",
      "CO2 (g/mi)": "355.5860000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator",
      "CO2 (g/mi)": "453.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "CASCADA",
      "CO2 (g/mi)": "340.4950000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE",
      "CO2 (g/mi)": "196.3340000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "207.0742266",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE FWD",
      "CO2 (g/mi)": "197.1990000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION AWD",
      "CO2 (g/mi)": "385.6630000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION FWD",
      "CO2 (g/mi)": "215.8640000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE",
      "CO2 (g/mi)": "287.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "LACROSSE AWD",
      "CO2 (g/mi)": "350.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "318.0245022",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL TOUR X AWD",
      "CO2 (g/mi)": "326.7050000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ATS-V",
      "CO2 (g/mi)": "420.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6",
      "CO2 (g/mi)": "299.3060000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 AWD",
      "CO2 (g/mi)": "397.8780000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS",
      "CO2 (g/mi)": "318.0930000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS AWD",
      "CO2 (g/mi)": "338.3870000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CTS-V",
      "CO2 (g/mi)": "526.5800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "500.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD",
      "CO2 (g/mi)": "529.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT4 AWD",
      "CO2 (g/mi)": "323.5170000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT4 FWD",
      "CO2 (g/mi)": "288.3160000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5",
      "CO2 (g/mi)": "361.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 AWD",
      "CO2 (g/mi)": "385.1000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS",
      "CO2 (g/mi)": "390.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS AWD",
      "CO2 (g/mi)": "458.5060000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XTS HEARSE",
      "CO2 (g/mi)": "488.7660000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BLAZER AWD",
      "CO2 (g/mi)": "382.6606420",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BLAZER FWD",
      "CO2 (g/mi)": "362.1830000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BOLT",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C10 SILVERADO 2WD",
      "CO2 (g/mi)": "355.3560000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD",
      "CO2 (g/mi)": "459.4870000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "320.3000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "385.9980000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO ZR2 4WD",
      "CO2 (g/mi)": "482.4560000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "266.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CRUZE",
      "CO2 (g/mi)": "236.7490000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX",
      "CO2 (g/mi)": "267.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "284.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "282.9838867",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K10 SILVERADO 4WD",
      "CO2 (g/mi)": "447.8280000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K10 SILVERADO 4WD TRAILBOSS",
      "CO2 (g/mi)": "497.5870000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 SUBURBAN 4WD",
      "CO2 (g/mi)": "516.0990000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "477.6780000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "233.8630000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "271.2330000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC 5",
      "CO2 (g/mi)": "270.9510000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "230.0980000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK ACTIV",
      "CO2 (g/mi)": "227.7240000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE",
      "CO2 (g/mi)": "348.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE AWD",
      "CO2 (g/mi)": "397.3730000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX AWD",
      "CO2 (g/mi)": "337.2340000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX FWD",
      "CO2 (g/mi)": "189.4820000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "VOLT",
      "CO2 (g/mi)": "151.4750000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA AWD",
      "CO2 (g/mi)": "369.3570000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA FWD",
      "CO2 (g/mi)": "355.8330000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "C10 SIERRA 2WD",
      "CO2 (g/mi)": "455.3320000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "CANYON CAB CHASSIS 2WD",
      "CO2 (g/mi)": "472.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD",
      "CO2 (g/mi)": "475.0710000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN AWD",
      "CO2 (g/mi)": "340.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN FWD",
      "CO2 (g/mi)": "200.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "282.7700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX AWD A-spec",
      "CO2 (g/mi)": "365.8800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "NSX",
      "CO2 (g/mi)": "291.8200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX AWD",
      "CO2 (g/mi)": "326.0200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX AWD A-SPEC",
      "CO2 (g/mi)": "367.0400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX FWD",
      "CO2 (g/mi)": "221.1000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX FWD A-SPEC",
      "CO2 (g/mi)": "223.3600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "214.0488335",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX HYBRID",
      "CO2 (g/mi)": "231.0800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX",
      "CO2 (g/mi)": "298.9800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "234.7600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "182.3800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 1.5L",
      "CO2 (g/mi)": "239.8000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 2.0L",
      "CO2 (g/mi)": "246.9700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 1.5L",
      "CO2 (g/mi)": "227.9900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 2.0L",
      "CO2 (g/mi)": "310.0800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR",
      "CO2 (g/mi)": "248.0200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR Type-R",
      "CO2 (g/mi)": "327.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC Si",
      "CO2 (g/mi)": "242.2900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Fuel Cell",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Plug-in Hybrid",
      "CO2 (g/mi)": "197.1600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 1.5L TC",
      "CO2 (g/mi)": "253.0500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 2.4L",
      "CO2 (g/mi)": "278.4100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "256.2400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EX",
      "CO2 (g/mi)": "171.4900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT LX",
      "CO2 (g/mi)": "232.0400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Honda",
      "Represented Test Veh Model": "HR-V AWD",
      "CO2 (g/mi)": "204.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Honda",
      "Represented Test Veh Model": "HR-V FWD",
      "CO2 (g/mi)": "181.8900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT",
      "CO2 (g/mi)": "207.6000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX AWD",
      "CO2 (g/mi)": "361.9400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX FWD",
      "CO2 (g/mi)": "217.3631376",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX HYBRID",
      "CO2 (g/mi)": "257.2100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY",
      "CO2 (g/mi)": "378.9200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY FWD",
      "CO2 (g/mi)": "364.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PASSPORT",
      "CO2 (g/mi)": "377.4300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 6AT",
      "CO2 (g/mi)": "358.7800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 9AT",
      "CO2 (g/mi)": "349.8300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 9AT",
      "CO2 (g/mi)": "251.3700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE AWD",
      "CO2 (g/mi)": "381.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE FWD",
      "CO2 (g/mi)": "374.6500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "TLX V6 AWD",
      "CO2 (g/mi)": "355.5300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "TLX V6 FWD",
      "CO2 (g/mi)": "359.0700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "G70",
      "CO2 (g/mi)": "384.5252000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "250.3819000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "284.6599000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "G80",
      "CO2 (g/mi)": "411.9397000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "G90",
      "CO2 (g/mi)": "412.6748814",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ PHEV",
      "CO2 (g/mi)": "124.4560000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "KONA",
      "CO2 (g/mi)": "185.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Kona Electric",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "NEXO",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "252.8576000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe Ultimate",
      "CO2 (g/mi)": "422.8205000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe XL",
      "CO2 (g/mi)": "397.8486890",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe XL Ultimate",
      "CO2 (g/mi)": "408.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "195.3419000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Sonata Hybrid",
      "CO2 (g/mi)": "159.8366000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA PLUG-IN HYBRID",
      "CO2 (g/mi)": "236.0684000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "324.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "VELOSTER",
      "CO2 (g/mi)": "264.4397212",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Veloster N",
      "CO2 (g/mi)": "319.5907000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Hybrid",
      "CO2 (g/mi)": "220.8169000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA PLUG-IN HYBRID",
      "CO2 (g/mi)": "230.4345000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "E-Pace 250PS",
      "CO2 (g/mi)": "326.3589000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "E-Pace 300PS",
      "CO2 (g/mi)": "334.4797000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-PACE",
      "CO2 (g/mi)": "215.1800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-PACE SVR",
      "CO2 (g/mi)": "442.2758000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE",
      "CO2 (g/mi)": "354.2846000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type AWD",
      "CO2 (g/mi)": "391.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Convertible",
      "CO2 (g/mi)": "301.8080000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Manual",
      "CO2 (g/mi)": "463.8200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE SVR GEN 2",
      "CO2 (g/mi)": "515.0703000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "I-PACE",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE",
      "CO2 (g/mi)": "339.0044000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE AWD",
      "CO2 (g/mi)": "316.9184000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE Project 8",
      "CO2 (g/mi)": "438.9564000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "348.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "298.3083000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD SPORTBRAKE",
      "CO2 (g/mi)": "327.9447000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF Sportbrake",
      "CO2 (g/mi)": "389.7826000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ",
      "CO2 (g/mi)": "424.3200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ AWD LWB",
      "CO2 (g/mi)": "424.9700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJ Supercharged",
      "CO2 (g/mi)": "483.1100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XJL",
      "CO2 (g/mi)": "390.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery",
      "CO2 (g/mi)": "450.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport 250PS",
      "CO2 (g/mi)": "339.9661000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport 300PS",
      "CO2 (g/mi)": "349.7078000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "437.9219000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover 3.0 PZEV",
      "CO2 (g/mi)": "429.0500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover LWB",
      "CO2 (g/mi)": "549.8691000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "430.6100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport SVR",
      "CO2 (g/mi)": "496.6958000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover SVA",
      "CO2 (g/mi)": "524.5657000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Velar",
      "CO2 (g/mi)": "334.0794000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Velar",
      "CO2 (g/mi)": "391.1078000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque 250PS",
      "CO2 (g/mi)": "323.0326000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque 300PS",
      "CO2 (g/mi)": "340.3003000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque Cabriolet 250PS",
      "CO2 (g/mi)": "331.9339000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Karma",
      "Represented Test Veh Model": "Revero",
      "CO2 (g/mi)": "395.6302000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "ACCENT",
      "CO2 (g/mi)": "262.5710033",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "347.3516000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "CK",
      "CO2 (g/mi)": "377.3507588",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "238.5518000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "K900",
      "CO2 (g/mi)": "390.8722000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "NIRO",
      "CO2 (g/mi)": "205.7378000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Niro Electric",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Niro Plug-in",
      "CO2 (g/mi)": "140.1986000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "335.6313000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "243.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SEDONA",
      "CO2 (g/mi)": "257.1772000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "242.3363000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "293.6600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Soul Electric",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "375.9552580",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Stinger",
      "CO2 (g/mi)": "326.8496000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6 AWD",
      "CO2 (g/mi)": "446.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "427.5000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Granturismo Conv",
      "CO2 (g/mi)": "549.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GRANTURISMO CONVERTIBLE",
      "CO2 (g/mi)": "318.6140000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE",
      "CO2 (g/mi)": "487.3000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE GTS",
      "CO2 (g/mi)": "534.1000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE S",
      "CO2 (g/mi)": "495.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE TROFEO",
      "CO2 (g/mi)": "354.1000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "490.6000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE S",
      "CO2 (g/mi)": "449.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "455.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-3",
      "CO2 (g/mi)": "193.6960000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "285.8510000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-9",
      "CO2 (g/mi)": "340.5880000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "214.9380000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda3",
      "CO2 (g/mi)": "268.4770000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda6",
      "CO2 (g/mi)": "293.7800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "260.2570000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "570S Coupe",
      "CO2 (g/mi)": "468.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "720S Coupe",
      "CO2 (g/mi)": "467.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "720S Spider",
      "CO2 (g/mi)": "463.5000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "Senna",
      "CO2 (g/mi)": "464.7100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "A 220",
      "CO2 (g/mi)": "281.7603000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "A 220 4MATIC",
      "CO2 (g/mi)": "183.2511007",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC",
      "CO2 (g/mi)": "375.4200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (convertible)",
      "CO2 (g/mi)": "385.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (coupe)",
      "CO2 (g/mi)": "378.0500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63  S (convertible)",
      "CO2 (g/mi)": "418.8044430",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63  S (coupe)",
      "CO2 (g/mi)": "246.1547868",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 S",
      "CO2 (g/mi)": "399.5008063",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLS53 4MATIC+",
      "CO2 (g/mi)": "331.5000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 4MATIC+ (station wagon)",
      "CO2 (g/mi)": "443.9725409",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 S 4MATIC",
      "CO2 (g/mi)": "489.5012950",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E53 4MATIC+",
      "CO2 (g/mi)": "327.5134277",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E53 4MATIC+ (Convertible)",
      "CO2 (g/mi)": "345.5000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E53 4MATIC+ (Coupe)",
      "CO2 (g/mi)": "337.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G 63",
      "CO2 (g/mi)": "553.5800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC",
      "CO2 (g/mi)": "368.9686000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC (coupe)",
      "CO2 (g/mi)": "371.8746000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 4MATIC",
      "CO2 (g/mi)": "434.9300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 S 4MATIC",
      "CO2 (g/mi)": "455.5700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 43 4MATIC",
      "CO2 (g/mi)": "429.0018077",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 43 4MATIC (coupe)",
      "CO2 (g/mi)": "428.2500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63",
      "CO2 (g/mi)": "601.6602000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63 S",
      "CO2 (g/mi)": "538.4921000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLS 63",
      "CO2 (g/mi)": "561.0170000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT (roadster)",
      "CO2 (g/mi)": "450.9868000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 53 4MATIC+",
      "CO2 (g/mi)": "373.0500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 63 4MATIC+",
      "CO2 (g/mi)": "315.7800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 63 S 4MATIC+",
      "CO2 (g/mi)": "476.6700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT C (roadster)",
      "CO2 (g/mi)": "461.7313431",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT R (coupe)",
      "CO2 (g/mi)": "480.8593946",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT S",
      "CO2 (g/mi)": "450.5925000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC",
      "CO2 (g/mi)": "425.9400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (convertible)",
      "CO2 (g/mi)": "481.6200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (coupe)",
      "CO2 (g/mi)": "420.9000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65",
      "CO2 (g/mi)": "572.9100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65 (convertible)",
      "CO2 (g/mi)": "647.0800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65 (coupe)",
      "CO2 (g/mi)": "549.4200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SL 63",
      "CO2 (g/mi)": "464.1800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SLC 43",
      "CO2 (g/mi)": "352.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "302.3217000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (convertible)",
      "CO2 (g/mi)": "333.0821000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (coupe)",
      "CO2 (g/mi)": "324.4029000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "309.9675000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (convertible)",
      "CO2 (g/mi)": "337.6327000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (coupe)",
      "CO2 (g/mi)": "321.6710000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "165.6696395",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "289.4300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "304.6500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 450",
      "CO2 (g/mi)": "287.6100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 450 4MATIC",
      "CO2 (g/mi)": "296.7000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 300",
      "CO2 (g/mi)": "322.8834880",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 300 4MATIC",
      "CO2 (g/mi)": "326.1446691",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 (convertible)",
      "CO2 (g/mi)": "355.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 (coupe)",
      "CO2 (g/mi)": "353.9700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC",
      "CO2 (g/mi)": "355.5300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (convertible)",
      "CO2 (g/mi)": "368.8100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (coupe)",
      "CO2 (g/mi)": "371.8100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (station wagon)",
      "CO2 (g/mi)": "370.9300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "550.1100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "286.4100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "294.2000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 45 AMG 4MATIC",
      "CO2 (g/mi)": "315.4900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300",
      "CO2 (g/mi)": "316.9166723",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC",
      "CO2 (g/mi)": "324.3766403",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC (coupe)",
      "CO2 (g/mi)": "329.3958723",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 350e 4MATIC",
      "CO2 (g/mi)": "278.9500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 400 4MATIC",
      "CO2 (g/mi)": "406.2700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 450 4MATIC",
      "CO2 (g/mi)": "441.6179000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 550 4MATIC",
      "CO2 (g/mi)": "529.6917000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach S 650",
      "CO2 (g/mi)": "552.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van)",
      "CO2 (g/mi)": "343.3650000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van, LWB)",
      "CO2 (g/mi)": "336.0870000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Passenger Van)",
      "CO2 (g/mi)": "371.2940990",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 450",
      "CO2 (g/mi)": "377.2800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 450 4MATIC",
      "CO2 (g/mi)": "382.5800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560",
      "CO2 (g/mi)": "224.3400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC",
      "CO2 (g/mi)": "228.5800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (convertible)",
      "CO2 (g/mi)": "415.5100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (coupe)",
      "CO2 (g/mi)": "234.2400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC Maybach",
      "CO2 (g/mi)": "251.2400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560e",
      "CO2 (g/mi)": "413.5190000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 450",
      "CO2 (g/mi)": "350.7645000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "405.4900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLC 300",
      "CO2 (g/mi)": "293.0700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo Electric Drive (convertible)",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Smart Fortwo Electric Drive (coupe)",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS 2WD",
      "CO2 (g/mi)": "332.3484400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS 4WD",
      "CO2 (g/mi)": "349.6972400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS ES 2WD",
      "CO2 (g/mi)": "315.2418400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS ES 4WD",
      "CO2 (g/mi)": "334.8980400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "196.1705900",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE G4",
      "CO2 (g/mi)": "198.2625800",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "271.8395400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "288.3114100",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER PHEV",
      "CO2 (g/mi)": "230.6314400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "297.1703000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "292.9984400",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 AWD PREMIUM",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI Q50 PREMIUM",
      "CO2 (g/mi)": "330.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX30 AWD Base",
      "CO2 (g/mi)": "210.0459271",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX30 Premium",
      "CO2 (g/mi)": "282.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 2WD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "INFINITI QX80 4WD",
      "CO2 (g/mi)": "533.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD RED SPORT",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 RED SPORT",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60",
      "CO2 (g/mi)": "365.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD RED SPORT",
      "CO2 (g/mi)": "377.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 RED SPORT",
      "CO2 (g/mi)": "226.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q70",
      "CO2 (g/mi)": "450.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q70 4WD",
      "CO2 (g/mi)": "406.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q70 AWD",
      "CO2 (g/mi)": "464.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50",
      "CO2 (g/mi)": "291.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50 AWD",
      "CO2 (g/mi)": "304.4867494",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 AWD",
      "CO2 (g/mi)": "242.0857527",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 FWD",
      "CO2 (g/mi)": "238.7095314",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX80 4WD",
      "CO2 (g/mi)": "539.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "370Z",
      "CO2 (g/mi)": "247.1689065",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "370Z Roadster",
      "CO2 (g/mi)": "390.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA",
      "CO2 (g/mi)": "231.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA SR/PLATINUM",
      "CO2 (g/mi)": "166.1728464",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 2WD",
      "CO2 (g/mi)": "507.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 4WD",
      "CO2 (g/mi)": "530.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD",
      "CO2 (g/mi)": "448.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD FFV",
      "CO2 (g/mi)": "452.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD",
      "CO2 (g/mi)": "472.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD FFV",
      "CO2 (g/mi)": "453.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "GT-R",
      "CO2 (g/mi)": "440.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Kicks",
      "CO2 (g/mi)": "170.5723145",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF SV/SL",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA",
      "CO2 (g/mi)": "337.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO AWD",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO FWD",
      "CO2 (g/mi)": "347.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NISSAN NV200 NYC Taxi STD",
      "CO2 (g/mi)": "341.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NV200 Cargo Van",
      "CO2 (g/mi)": "351.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NV200 NYC Taxi",
      "CO2 (g/mi)": "304.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 2WD",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 4WD",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD",
      "CO2 (g/mi)": "286.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD Hybrid",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD",
      "CO2 (g/mi)": "266.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD Hybrid SL",
      "CO2 (g/mi)": "199.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport",
      "CO2 (g/mi)": "250.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport AWD",
      "CO2 (g/mi)": "205.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA",
      "CO2 (g/mi)": "246.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA NISMO",
      "CO2 (g/mi)": "192.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 2WD",
      "CO2 (g/mi)": "467.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD",
      "CO2 (g/mi)": "466.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD PRO-4X",
      "CO2 (g/mi)": "507.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "VERSA",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "353.2500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "359.0100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "325.1600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 GTS",
      "CO2 (g/mi)": "352.3900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 GTS Cabriolet",
      "CO2 (g/mi)": "352.7400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "358.7200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "324.4700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "358.2400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera GTS",
      "CO2 (g/mi)": "340.9400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera GTS Cabriolet",
      "CO2 (g/mi)": "351.9400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "359.1400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "359.4900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera T",
      "CO2 (g/mi)": "442.1500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT2RS",
      "CO2 (g/mi)": "464.8700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3",
      "CO2 (g/mi)": "478.2900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3R",
      "CO2 (g/mi)": "513.7700000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 GT3RS",
      "CO2 (g/mi)": "488.6100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Speedster",
      "CO2 (g/mi)": "530.0200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4",
      "CO2 (g/mi)": "363.6600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4 GTS",
      "CO2 (g/mi)": "357.9600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa 4S",
      "CO2 (g/mi)": "364.1100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "378.6600000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Coupe",
      "CO2 (g/mi)": "377.7800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Exclusive",
      "CO2 (g/mi)": "430.0500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "310.1900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster GTS",
      "CO2 (g/mi)": "352.4300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "327.6300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "372.3000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne e-Hybrid",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "386.4500000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "470.8000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman GTS",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan",
      "CO2 (g/mi)": "357.1885000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "366.0800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "350.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4",
      "CO2 (g/mi)": "363.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 e-Hybrid ST",
      "CO2 (g/mi)": "327.1000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 Executive",
      "CO2 (g/mi)": "356.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "370.2100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S ST",
      "CO2 (g/mi)": "373.7200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS",
      "CO2 (g/mi)": "439.6200000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS ST",
      "CO2 (g/mi)": "452.3400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "382.8800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo S e-Hybrid ST",
      "CO2 (g/mi)": "285.6000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo ST",
      "CO2 (g/mi)": "403.4100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Cullinan",
      "CO2 (g/mi)": "619.0624000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Dawn",
      "CO2 (g/mi)": "603.6100000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "623.8045000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "628.1900000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "584.8800000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "683.4000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "573.8400000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "RUF",
      "Represented Test Veh Model": "TURBO 12/CTR 3/CTR 2017",
      "CO2 (g/mi)": "436.1000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "86",
      "CO2 (g/mi)": "331.1700100",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "ASCENT",
      "CO2 (g/mi)": "241.1467276",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "ASCENT LIMITED/TOURING",
      "CO2 (g/mi)": "352.6695260",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "283.1214290",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK",
      "CO2 (g/mi)": "253.7383310",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "259.4156300",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA 4-Door",
      "CO2 (g/mi)": "234.5877730",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "Impreza 5-Door",
      "CO2 (g/mi)": "257.5776281",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "264.2692390",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK",
      "CO2 (g/mi)": "275.6808450",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "330.1747100",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "86",
      "CO2 (g/mi)": "288.6383830",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "STI",
      "Represented Test Veh Model": "S209",
      "CO2 (g/mi)": "312.7665267",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Standard Range RWD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model S Long Range",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model S Performance (19" Wheel)',
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model S Performance (21" Wheels)',
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model S Standard Range",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model X Long Range",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model X Performance (20" Wheels)',
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model X Performance (22" Wheels)',
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model X Standard Range",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Long Range",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Long Range AWD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Mid Range RWD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Standard Range Plus RWD",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "100D",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model S",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "100D",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "75D",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Tesla Model X",
      "Represented Test Veh Model": "P100D",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "188.1122182",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "309.3614464",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350 F SPORT",
      "CO2 (g/mi)": "320.9854330",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 200t F SPORT",
      "CO2 (g/mi)": "336.1858146",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "354.0594128",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "365.8044844",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 F SPORT",
      "CO2 (g/mi)": "229.9275437",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS F",
      "CO2 (g/mi)": "272.8677435",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "516.2117185",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 200t",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 300",
      "CO2 (g/mi)": "332.8047045",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500",
      "CO2 (g/mi)": "256.0687830",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500h",
      "CO2 (g/mi)": "314.9970977",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500",
      "CO2 (g/mi)": "369.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500 AWD",
      "CO2 (g/mi)": "391.4409874",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500h",
      "CO2 (g/mi)": "377.0087149",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500h AWD",
      "CO2 (g/mi)": "284.8068966",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "562.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.2030260",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "203.0984779",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC 350 AWD",
      "CO2 (g/mi)": "383.7962877",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "425.9731312",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "227.9272582",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "240.0782630",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "214.0406074",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 200",
      "CO2 (g/mi)": "227.1603912",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 250h",
      "CO2 (g/mi)": "220.4927919",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 250h AWD",
      "CO2 (g/mi)": "161.2221927",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "447.2603826",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "297.6840424",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON",
      "CO2 (g/mi)": "201.3013712",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON HYBRID",
      "CO2 (g/mi)": "200.2891170",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON HYBRID XLE",
      "CO2 (g/mi)": "209.0477833",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON XLE",
      "CO2 (g/mi)": "187.6459986",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "C-HR",
      "CO2 (g/mi)": "328.8941905",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "143.4359198",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID LE",
      "CO2 (g/mi)": "180.0303654",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID XLE/SE",
      "CO2 (g/mi)": "212.3416743",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY LE/SE",
      "CO2 (g/mi)": "245.6115125",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XLE/XSE",
      "CO2 (g/mi)": "238.7715202",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XSE",
      "CO2 (g/mi)": "192.3534168",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "246.1944050",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HATCHBACK",
      "CO2 (g/mi)": "155.7985377",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HATCHBACK MANUAL",
      "CO2 (g/mi)": "239.9560813",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA LE ECO",
      "CO2 (g/mi)": "150.9532104",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "416.3827594",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "358.4739663",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD LE",
      "CO2 (g/mi)": "347.0155130",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "284.9191000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LE Plus",
      "CO2 (g/mi)": "279.3281515",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER LE/XLE/SE/LTD",
      "CO2 (g/mi)": "333.2856397",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUISER WAGON 4WD",
      "CO2 (g/mi)": "549.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "123.7047548",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS AWD",
      "CO2 (g/mi)": "193.4888283",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS c",
      "CO2 (g/mi)": "167.7650525",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Eco",
      "CO2 (g/mi)": "153.2872691",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS PRIME",
      "CO2 (g/mi)": "180.4342403",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "177.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "261.6353989",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 HYBRID AWD",
      "CO2 (g/mi)": "207.6229349",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "545.8558090",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "570.1310668",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "403.2300000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "361.7924411",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "417.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD D-CAB V6 MT OFF-ROAD",
      "CO2 (g/mi)": "319.0533243",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "336.2534306",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "347.3930333",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD FFV",
      "CO2 (g/mi)": "386.3947322",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "YARIS",
      "CO2 (g/mi)": "175.8659619",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "277.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 Cabriolet quattro",
      "CO2 (g/mi)": "315.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 quattro",
      "CO2 (g/mi)": "209.5740814",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "291.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "392.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Ultra",
      "CO2 (g/mi)": "283.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 Quattro (C8)",
      "CO2 (g/mi)": "286.5399475",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "562.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "374.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "e-tron 55 quattro",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "442.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "398.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "389.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q8",
      "CO2 (g/mi)": "425.7593119",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS3",
      "CO2 (g/mi)": "457.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS5",
      "CO2 (g/mi)": "410.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4",
      "CO2 (g/mi)": "217.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "270.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT",
      "CO2 (g/mi)": "212.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTRS",
      "CO2 (g/mi)": "390.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTS",
      "CO2 (g/mi)": "364.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga V8",
      "CO2 (g/mi)": "505.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Mulsanne Speed",
      "CO2 (g/mi)": "787.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Bugatti Chiron",
      "CO2 (g/mi)": "855.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Aventador SVJ",
      "CO2 (g/mi)": "811.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan performante",
      "CO2 (g/mi)": "571.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan spyder",
      "CO2 (g/mi)": "556.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Urus",
      "CO2 (g/mi)": "572.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Arteon",
      "CO2 (g/mi)": "363.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Atlas",
      "CO2 (g/mi)": "419.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Audi S3",
      "CO2 (g/mi)": "386.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Beetle",
      "CO2 (g/mi)": "297.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "e-Golf",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "267.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf Alltrack",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf GTI",
      "CO2 (g/mi)": "307.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf R",
      "CO2 (g/mi)": "389.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "284.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta GLI",
      "CO2 (g/mi)": "306.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "279.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "212.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "290.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "327.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T8 AWD",
      "CO2 (g/mi)": "232.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T5 AWD",
      "CO2 (g/mi)": "311.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T8 AWD",
      "CO2 (g/mi)": "183.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60 T6 AWD",
      "CO2 (g/mi)": "328.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60CC T5 AWD",
      "CO2 (g/mi)": "318.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90 T6 AWD",
      "CO2 (g/mi)": "335.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90CC T5 AWD",
      "CO2 (g/mi)": "317.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90CC T6 AWD",
      "CO2 (g/mi)": "341.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 T4 FWD",
      "CO2 (g/mi)": "296.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 T5 AWD",
      "CO2 (g/mi)": "302.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "348.9216217",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 FWD",
      "CO2 (g/mi)": "319.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "360.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T8 AWD",
      "CO2 (g/mi)": "276.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 FWD",
      "CO2 (g/mi)": "324.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T6 AWD",
      "CO2 (g/mi)": "362.0000000",
    },
    {
      "Model Year": "2019",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T8 AWD",
      "CO2 (g/mi)": "286.0000000",
    },
  ],
  2020: [
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11",
      "CO2 (g/mi)": "466.8700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11 V8",
      "CO2 (g/mi)": "386.6600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBS",
      "CO2 (g/mi)": "499.6900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vantage Manual",
      "CO2 (g/mi)": "516.2900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vantage V8",
      "CO2 (g/mi)": "393.7600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i xDrive Gran Coupe",
      "CO2 (g/mi)": "296.4722894",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Convertible",
      "CO2 (g/mi)": "195.2600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Coupe",
      "CO2 (g/mi)": "337.1654796",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230I XDRIVE CONVERTIBLE",
      "CO2 (g/mi)": "348.3918656",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230I XDRIVE COUPE",
      "CO2 (g/mi)": "315.3233514",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i",
      "CO2 (g/mi)": "259.6720000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive",
      "CO2 (g/mi)": "276.6410000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive Gran Turismo",
      "CO2 (g/mi)": "184.5605410",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "340i xDrive Gran Turismo",
      "CO2 (g/mi)": "323.4998000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Convertible",
      "CO2 (g/mi)": "293.0300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Coupe",
      "CO2 (g/mi)": "286.5300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Gran Coupe",
      "CO2 (g/mi)": "293.8100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Convertible",
      "CO2 (g/mi)": "317.4800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Coupe",
      "CO2 (g/mi)": "298.4000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i XDRIVE GRAN COUPE",
      "CO2 (g/mi)": "326.7662396",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Convertible",
      "CO2 (g/mi)": "321.6900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Coupe",
      "CO2 (g/mi)": "320.8518782",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i Gran Coupe",
      "CO2 (g/mi)": "213.0612640",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Convertible",
      "CO2 (g/mi)": "360.4845082",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Coupe",
      "CO2 (g/mi)": "203.6838967",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "440i xDrive Gran Coupe",
      "CO2 (g/mi)": "321.2500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e",
      "CO2 (g/mi)": "263.2377000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e xDrive",
      "CO2 (g/mi)": "319.0262079",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i",
      "CO2 (g/mi)": "269.1896539",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i xDrive",
      "CO2 (g/mi)": "290.3739059",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i",
      "CO2 (g/mi)": "313.0445251",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i xDrive",
      "CO2 (g/mi)": "321.6950301",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i",
      "CO2 (g/mi)": "315.9856000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i xDrive",
      "CO2 (g/mi)": "227.7684937",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "745e xDrive",
      "CO2 (g/mi)": "361.0436333",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i xDrive",
      "CO2 (g/mi)": "419.1860000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i Convertible",
      "CO2 (g/mi)": "317.3106167",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i Coupe",
      "CO2 (g/mi)": "303.8518103",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i Gran Coupe",
      "CO2 (g/mi)": "314.0062541",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i xDrive Convertible",
      "CO2 (g/mi)": "348.7821891",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i xDrive Coupe",
      "CO2 (g/mi)": "334.1453375",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7",
      "CO2 (g/mi)": "493.9261106",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s REX",
      "CO2 (g/mi)": "197.2565000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I8 Roadster",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2 Competition",
      "CO2 (g/mi)": "364.8300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2 CS Coupe",
      "CO2 (g/mi)": "358.0317000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i xDrive",
      "CO2 (g/mi)": "300.0346692",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i",
      "CO2 (g/mi)": "312.2200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i Convertible",
      "CO2 (g/mi)": "379.6500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i Coupe",
      "CO2 (g/mi)": "376.6216000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive",
      "CO2 (g/mi)": "319.7018000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive Convertible",
      "CO2 (g/mi)": "324.6900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M3",
      "CO2 (g/mi)": "431.7019000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M340I",
      "CO2 (g/mi)": "297.6440000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M340I XDRIVE",
      "CO2 (g/mi)": "301.7613000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Convertible",
      "CO2 (g/mi)": "442.6620925",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M550i xDrive",
      "CO2 (g/mi)": "414.0612377",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M760i xDrive",
      "CO2 (g/mi)": "545.2692000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Convertible",
      "CO2 (g/mi)": "405.1206000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Coupe",
      "CO2 (g/mi)": "388.1100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Gran Coupe",
      "CO2 (g/mi)": "263.5801227",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "MINI COOPER SE HARDTOP 2 DOOR",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Supra 3.0",
      "CO2 (g/mi)": "201.0424000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "187.9065409",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "200.2363476",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 M35i",
      "CO2 (g/mi)": "286.0316247",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 sDrive28i",
      "CO2 (g/mi)": "190.5540209",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 M",
      "CO2 (g/mi)": "290.9430000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 sDrive30i",
      "CO2 (g/mi)": "272.5113088",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive30e",
      "CO2 (g/mi)": "285.1688000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive30i",
      "CO2 (g/mi)": "296.6065014",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 M40i",
      "CO2 (g/mi)": "333.7261000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive30i",
      "CO2 (g/mi)": "228.6842041",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M50i",
      "CO2 (g/mi)": "297.0123672",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive40i",
      "CO2 (g/mi)": "336.1050000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive40i",
      "CO2 (g/mi)": "352.7224000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive50i",
      "CO2 (g/mi)": "420.9600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 M50i",
      "CO2 (g/mi)": "427.8052019",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 sDrive40i",
      "CO2 (g/mi)": "321.5020000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive40i",
      "CO2 (g/mi)": "366.5765240",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 M50i",
      "CO2 (g/mi)": "468.4765306",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 xDrive40i",
      "CO2 (g/mi)": "359.2810974",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 xDrive50i",
      "CO2 (g/mi)": "465.8257000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive30i",
      "CO2 (g/mi)": "275.0360000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M5 Competition",
      "CO2 (g/mi)": "284.0087891",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M8 Competition Convertible",
      "CO2 (g/mi)": "419.7576000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M8 Competition Coupe",
      "CO2 (g/mi)": "404.7367000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M8 Competition Gran Coupe",
      "CO2 (g/mi)": "409.9707000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "X5 M Competition",
      "CO2 (g/mi)": "465.1407000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER CONVERTIBLE",
      "CO2 (g/mi)": "232.1158412",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER COUNTRYMAN",
      "CO2 (g/mi)": "253.0061328",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER COUNTRYMAN ALL4",
      "CO2 (g/mi)": "283.1120000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER HARDTOP 2 DOOR",
      "CO2 (g/mi)": "157.6474475",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER HARDTOP 4 DOOR",
      "CO2 (g/mi)": "233.0043410",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S CLUBMAN",
      "CO2 (g/mi)": "266.5447245",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S CLUBMAN ALL4",
      "CO2 (g/mi)": "296.8189240",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER S CONVERTIBLE",
      "CO2 (g/mi)": "257.8351000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S COUNTRYMAN",
      "CO2 (g/mi)": "280.6281408",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S COUNTRYMAN ALL4",
      "CO2 (g/mi)": "196.5951595",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER S HARDTOP 2 DOOR",
      "CO2 (g/mi)": "251.5483706",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER S HARDTOP 4 DOOR",
      "CO2 (g/mi)": "266.2491007",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JCW CLUBMAN ALL4",
      "CO2 (g/mi)": "297.3652108",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JCW COUNTRYMAN ALL4",
      "CO2 (g/mi)": "292.3655012",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JOHN COOPER WORKS CONVERTIBLE",
      "CO2 (g/mi)": "271.0630362",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JOHN COOPER WORKS HARDTOP",
      "CO2 (g/mi)": "264.1020689",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "Mini Cooper SE Countryman ALL4",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BYD",
      "Represented Test Veh Model": "e6",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "Alfa 4c",
      "CO2 (g/mi)": "325.3201400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia",
      "CO2 (g/mi)": "405.9376300",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia AWD",
      "CO2 (g/mi)": "308.0348100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio",
      "CO2 (g/mi)": "299.0857400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio AWD",
      "CO2 (g/mi)": "419.7914200",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "300 Awd",
      "CO2 (g/mi)": "490.5133500",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica",
      "CO2 (g/mi)": "366.5736700",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica AWD",
      "CO2 (g/mi)": "416.5676400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica Hybrid",
      "CO2 (g/mi)": "260.8730000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Town & Country",
      "CO2 (g/mi)": "413.6258900",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.5503600",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT Widebody",
      "CO2 (g/mi)": "603.3490100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.3954300",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "413.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.3990000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger SRT",
      "CO2 (g/mi)": "689.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger SRT Widebody",
      "CO2 (g/mi)": "589.9163500",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango AWD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "510.2874757",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango SRT AWD",
      "CO2 (g/mi)": "562.3241400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "JOURNEY 2WD",
      "CO2 (g/mi)": "381.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "124 Spider",
      "CO2 (g/mi)": "258.6946290",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500L",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X AWD",
      "CO2 (g/mi)": "296.6402600",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "331.5532042",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "343.6912100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "319.3632000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "354.2852200",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X2",
      "CO2 (g/mi)": "306.4890200",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "321.3667976",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Gladiator Pickup 4x4",
      "CO2 (g/mi)": "413.9886475",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "371.7277400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "380.9087000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.0799600",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee TrackHawk 4x4",
      "CO2 (g/mi)": "644.5683800",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "320.0806735",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "331.5249654",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade Trailhawk 4x4",
      "CO2 (g/mi)": "355.8560000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4X4",
      "CO2 (g/mi)": "256.3254208",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler Unlimited 4x4",
      "CO2 (g/mi)": "247.4974670",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
      "CO2 (g/mi)": "420.1881700",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X2",
      "CO2 (g/mi)": "353.9187927",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "375.5136719",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 HFE 4X2",
      "CO2 (g/mi)": "346.1058655",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 Special Series Coupe",
      "CO2 (g/mi)": "506.0203000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "488 Special Series Spider",
      "CO2 (g/mi)": "506.9471000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "812 Superfast",
      "CO2 (g/mi)": "605.5068000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F8 Tributo",
      "CO2 (g/mi)": "336.1608000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso",
      "CO2 (g/mi)": "641.1826000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "GTC4Lusso T",
      "CO2 (g/mi)": "505.9614200",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "Portofino",
      "CO2 (g/mi)": "458.7116000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "1.0L EcoSport",
      "CO2 (g/mi)": "284.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EcoSport",
      "CO2 (g/mi)": "299.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge",
      "CO2 (g/mi)": "337.5990000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Edge AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape",
      "CO2 (g/mi)": "306.1790000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FHEV",
      "CO2 (g/mi)": "142.6500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape FWD",
      "CO2 (g/mi)": "249.4390000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Escape PHEV",
      "CO2 (g/mi)": "145.4760000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "419.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer",
      "CO2 (g/mi)": "402.6060000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FHEV",
      "CO2 (g/mi)": "257.0150000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150",
      "CO2 (g/mi)": "444.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 4X4 SUPER CREW CAB",
      "CO2 (g/mi)": "388.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Regular Cab",
      "CO2 (g/mi)": "361.8080000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 Super Cab",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150 SuperCab",
      "CO2 (g/mi)": "386.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 4x4",
      "CO2 (g/mi)": "374.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Cab 4X2",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Cab 4X4",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Crew Cab 4X2",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Crew Cab 4x4",
      "CO2 (g/mi)": "421.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ford Explorer",
      "CO2 (g/mi)": "329.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion",
      "CO2 (g/mi)": "292.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (HEV)",
      "CO2 (g/mi)": "141.5150000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Fusion (PHEV)",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "FUSION FWD",
      "CO2 (g/mi)": "335.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "GT",
      "CO2 (g/mi)": "589.7090000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "MKZ",
      "CO2 (g/mi)": "365.4020000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility",
      "CO2 (g/mi)": "425.1110000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility HEV",
      "CO2 (g/mi)": "264.2520000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Responder Hybrid Sedan FHEV",
      "CO2 (g/mi)": "158.9550000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger - Chassis Cab",
      "CO2 (g/mi)": "306.8520000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger - Super Crew Cab",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Shelby GT350 Mustang",
      "CO2 (g/mi)": "526.9430000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Shelby GT500 Mustang",
      "CO2 (g/mi)": "653.3680000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Transit AWD Wagon Low Roof",
      "CO2 (g/mi)": "510.4960000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FFV",
      "CO2 (g/mi)": "286.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FWD",
      "CO2 (g/mi)": "288.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON LWB",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Transit RWD Wagon Low Roof",
      "CO2 (g/mi)": "307.0022800",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Transit RWD Wagon Med Roof",
      "CO2 (g/mi)": "347.4900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Aviator",
      "CO2 (g/mi)": "394.0910000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Aviator PHEV",
      "CO2 (g/mi)": "325.1970000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Continental",
      "CO2 (g/mi)": "230.1460000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Corsair",
      "CO2 (g/mi)": "320.5610000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Explorer Police",
      "CO2 (g/mi)": "275.3026421",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "MKZ (HEV)",
      "CO2 (g/mi)": "171.0780000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator",
      "CO2 (g/mi)": "456.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "207.0742266",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE FWD",
      "CO2 (g/mi)": "197.1990000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE GX AWD",
      "CO2 (g/mi)": "319.7750000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE GX FWD",
      "CO2 (g/mi)": "261.4416199",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION AWD",
      "CO2 (g/mi)": "385.6630000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION FWD",
      "CO2 (g/mi)": "215.8640000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL",
      "CO2 (g/mi)": "318.0245022",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL AWD",
      "CO2 (g/mi)": "376.5250000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "REGAL TOUR X AWD",
      "CO2 (g/mi)": "326.7050000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4",
      "CO2 (g/mi)": "298.8140000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4 AWD",
      "CO2 (g/mi)": "308.8450000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4 V",
      "CO2 (g/mi)": "354.7300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4 V AWD",
      "CO2 (g/mi)": "353.7140000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT5",
      "CO2 (g/mi)": "303.5630000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT5 AWD",
      "CO2 (g/mi)": "210.3889465",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT5 V",
      "CO2 (g/mi)": "379.2520000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT6 AWD",
      "CO2 (g/mi)": "374.8490000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 2WD",
      "CO2 (g/mi)": "500.9000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD",
      "CO2 (g/mi)": "532.2000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT4 AWD",
      "CO2 (g/mi)": "348.2910000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT4 FWD",
      "CO2 (g/mi)": "288.3160000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 AWD",
      "CO2 (g/mi)": "367.7420000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 FWD",
      "CO2 (g/mi)": "342.0140000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT6 AWD",
      "CO2 (g/mi)": "408.5600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT6 FWD",
      "CO2 (g/mi)": "405.5470000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BLAZER FWD",
      "CO2 (g/mi)": "362.1830000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BOLT EV",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C10 SILVERADO 2WD",
      "CO2 (g/mi)": "355.3560000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C1500 TAHOE 2WD",
      "CO2 (g/mi)": "459.4870000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "320.3000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "385.9980000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO ZR2 4WD",
      "CO2 (g/mi)": "482.4560000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "490.4250000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "356.1350000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "314.3680000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "IMPALA",
      "CO2 (g/mi)": "225.8000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K10 SILVERADO 4WD",
      "CO2 (g/mi)": "447.8280000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 SUBURBAN 4WD",
      "CO2 (g/mi)": "516.0990000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K1500 TAHOE 4WD",
      "CO2 (g/mi)": "477.6780000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "233.8630000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 2WD",
      "CO2 (g/mi)": "459.0910000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 2WD CAB CHASSIS",
      "CO2 (g/mi)": "497.7500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 4WD",
      "CO2 (g/mi)": "447.8280000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 4WD TRAILBOSS",
      "CO2 (g/mi)": "498.0750000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SONIC",
      "CO2 (g/mi)": "271.2330000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "230.0980000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK ACTIV",
      "CO2 (g/mi)": "227.7240000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE",
      "CO2 (g/mi)": "393.4560000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE AWD",
      "CO2 (g/mi)": "397.3730000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX FWD",
      "CO2 (g/mi)": "189.4820000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA AWD",
      "CO2 (g/mi)": "350.7840000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA FWD",
      "CO2 (g/mi)": "332.0860000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "C10 SIERRA 2WD",
      "CO2 (g/mi)": "236.4670000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD",
      "CO2 (g/mi)": "438.6730000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD AT4",
      "CO2 (g/mi)": "482.7304993",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD CAB CHASSIS",
      "CO2 (g/mi)": "515.6460000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "SIERRA 2WD",
      "CO2 (g/mi)": "440.1940000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "SIERRA 4WD",
      "CO2 (g/mi)": "447.6280000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "SIERRA 4WD AT4",
      "CO2 (g/mi)": "514.5030000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN AWD",
      "CO2 (g/mi)": "338.5850000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN FWD",
      "CO2 (g/mi)": "322.8430000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "282.7700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "MDX AWD A-spec",
      "CO2 (g/mi)": "365.8800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "NSX",
      "CO2 (g/mi)": "291.8200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX AWD",
      "CO2 (g/mi)": "326.0200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX AWD A-SPEC",
      "CO2 (g/mi)": "367.0400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX FWD",
      "CO2 (g/mi)": "221.1000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX FWD A-SPEC",
      "CO2 (g/mi)": "223.3600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX",
      "CO2 (g/mi)": "214.0488335",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RLX HYBRID",
      "CO2 (g/mi)": "231.0800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX",
      "CO2 (g/mi)": "298.9800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "233.6500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "182.3800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR",
      "CO2 (g/mi)": "247.9800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 1.5L",
      "CO2 (g/mi)": "239.8000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 2DR COUPE 2.0L",
      "CO2 (g/mi)": "246.9700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 1.5L",
      "CO2 (g/mi)": "227.9900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 2.0L",
      "CO2 (g/mi)": "310.0800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR",
      "CO2 (g/mi)": "253.0200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Fuel Cell",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Plug-in Hybrid",
      "CO2 (g/mi)": "197.1600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 1.5L TC",
      "CO2 (g/mi)": "228.3300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V AWD",
      "CO2 (g/mi)": "157.2700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT",
      "CO2 (g/mi)": "256.2400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT EX",
      "CO2 (g/mi)": "171.4900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "FIT LX",
      "CO2 (g/mi)": "232.0400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Honda",
      "Represented Test Veh Model": "HR-V AWD",
      "CO2 (g/mi)": "204.0100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Honda",
      "Represented Test Veh Model": "HR-V FWD",
      "CO2 (g/mi)": "181.8900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT",
      "CO2 (g/mi)": "207.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX AWD",
      "CO2 (g/mi)": "361.9400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX FWD",
      "CO2 (g/mi)": "217.3631376",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "MDX HYBRID",
      "CO2 (g/mi)": "257.2100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY FWD",
      "CO2 (g/mi)": "364.9000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PASSPORT",
      "CO2 (g/mi)": "377.4300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 6AT",
      "CO2 (g/mi)": "358.7800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 9AT",
      "CO2 (g/mi)": "349.8300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 9AT",
      "CO2 (g/mi)": "251.3700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE AWD",
      "CO2 (g/mi)": "381.2100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "RIDGELINE FWD",
      "CO2 (g/mi)": "244.1383057",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "TLX V6 AWD",
      "CO2 (g/mi)": "355.5300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "TLX V6 FWD",
      "CO2 (g/mi)": "359.0700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "G70",
      "CO2 (g/mi)": "384.5252000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "G90",
      "CO2 (g/mi)": "415.8562000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "214.1880000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "263.9405000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Elantra GT",
      "CO2 (g/mi)": "284.6599000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra SE",
      "CO2 (g/mi)": "141.1708000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "G80",
      "CO2 (g/mi)": "411.9397000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Ioniq Electric",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ PHEV",
      "CO2 (g/mi)": "185.4710000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "KONA",
      "CO2 (g/mi)": "185.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Kona Electric",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "NEXO",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Palisade",
      "CO2 (g/mi)": "263.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "364.2861000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "281.2236000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "324.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "VELOSTER",
      "CO2 (g/mi)": "264.4397212",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Veloster N",
      "CO2 (g/mi)": "319.5907000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Venue",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "E-Pace 250PS",
      "CO2 (g/mi)": "326.3589000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "E-Pace 300PS",
      "CO2 (g/mi)": "334.4797000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-PACE",
      "CO2 (g/mi)": "401.1294000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-PACE SVR",
      "CO2 (g/mi)": "442.2758000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE",
      "CO2 (g/mi)": "354.2846000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type AWD",
      "CO2 (g/mi)": "391.0100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Convertible",
      "CO2 (g/mi)": "301.8080000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE SVR GEN 2",
      "CO2 (g/mi)": "515.0703000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "I-PACE",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE",
      "CO2 (g/mi)": "292.4193000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE AWD",
      "CO2 (g/mi)": "316.9184000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "273.2429000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "298.3083000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD SPORTBRAKE",
      "CO2 (g/mi)": "327.9447000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF Sportbrake",
      "CO2 (g/mi)": "389.7826000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "Defender",
      "CO2 (g/mi)": "429.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery",
      "CO2 (g/mi)": "450.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport",
      "CO2 (g/mi)": "380.5956000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport MHEV",
      "CO2 (g/mi)": "369.2328000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "352.6191000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover LWB",
      "CO2 (g/mi)": "549.8691000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "362.2860000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport SVR",
      "CO2 (g/mi)": "496.6958000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover SVA",
      "CO2 (g/mi)": "524.5657000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Velar",
      "CO2 (g/mi)": "334.0794000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Velar",
      "CO2 (g/mi)": "391.1078000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "VELAR SV-D",
      "CO2 (g/mi)": "459.8928000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque 240PS",
      "CO2 (g/mi)": "354.1257000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque 300PS",
      "CO2 (g/mi)": "341.5360000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Karma",
      "Represented Test Veh Model": "Revero GT",
      "CO2 (g/mi)": "271.0977400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ",
      "CO2 (g/mi)": "168.6289000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Cadenza",
      "CO2 (g/mi)": "345.6699000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "CK",
      "CO2 (g/mi)": "377.3507588",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "276.3792000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "K900",
      "CO2 (g/mi)": "390.8722000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "NIRO",
      "CO2 (g/mi)": "205.7378000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Niro Electric",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Niro Plug-in",
      "CO2 (g/mi)": "207.9213000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Optima",
      "CO2 (g/mi)": "335.6313000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Optima Hybrid",
      "CO2 (g/mi)": "231.7301000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "OPTIMA PLUG-IN HYBRID",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "145.9129100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SEDONA",
      "CO2 (g/mi)": "257.1772000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "242.3363000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "285.0269000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul Electric",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Stinger",
      "CO2 (g/mi)": "326.8496000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Telluride",
      "CO2 (g/mi)": "259.3989000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora 400",
      "CO2 (g/mi)": "452.8408000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora GT",
      "CO2 (g/mi)": "408.1608700",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "Ghibli S Q4 V6 AWD",
      "CO2 (g/mi)": "446.9000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "GHIBLI V6 RWD",
      "CO2 (g/mi)": "427.5000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE",
      "CO2 (g/mi)": "487.3000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "LEVANTE GTS",
      "CO2 (g/mi)": "534.1000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE GTS",
      "CO2 (g/mi)": "490.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MASERATI",
      "Represented Test Veh Model": "QUATTROPORTE SQ4 V6",
      "CO2 (g/mi)": "455.2000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-3",
      "CO2 (g/mi)": "193.6960000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-30",
      "CO2 (g/mi)": "277.3340000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "285.8510000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-9",
      "CO2 (g/mi)": "340.5880000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "214.9380000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda3",
      "CO2 (g/mi)": "268.4770000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda6",
      "CO2 (g/mi)": "293.7800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "260.2570000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "570S Coupe",
      "CO2 (g/mi)": "468.2000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "720S Coupe",
      "CO2 (g/mi)": "467.7000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "720S Spider",
      "CO2 (g/mi)": "463.5000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "GT",
      "CO2 (g/mi)": "464.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "McLaren",
      "Represented Test Veh Model": "Speedtail",
      "CO2 (g/mi)": "597.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "A 220",
      "CO2 (g/mi)": "281.7603000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "A 220 4MATIC",
      "CO2 (g/mi)": "183.2511007",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG A 35 4MATIC",
      "CO2 (g/mi)": "197.4700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC",
      "CO2 (g/mi)": "375.4200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (convertible)",
      "CO2 (g/mi)": "385.0100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (coupe)",
      "CO2 (g/mi)": "378.0500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63  S (convertible)",
      "CO2 (g/mi)": "418.8044430",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63  S (coupe)",
      "CO2 (g/mi)": "246.1547868",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 S",
      "CO2 (g/mi)": "399.5008063",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLA 35 4MATIC",
      "CO2 (g/mi)": "304.5100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLA 45 4MATIC+",
      "CO2 (g/mi)": "349.8400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLS53 4MATIC+",
      "CO2 (g/mi)": "331.5000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 4MATIC+ (station wagon)",
      "CO2 (g/mi)": "443.9725409",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 S 4MATIC",
      "CO2 (g/mi)": "489.5012950",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E53 4MATIC+",
      "CO2 (g/mi)": "327.5134277",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E53 4MATIC+ (Convertible)",
      "CO2 (g/mi)": "345.5000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E53 4MATIC+ (Coupe)",
      "CO2 (g/mi)": "337.7000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G 63",
      "CO2 (g/mi)": "553.5800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC",
      "CO2 (g/mi)": "388.3900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC coupe",
      "CO2 (g/mi)": "389.2100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 S 4MATIC",
      "CO2 (g/mi)": "452.5700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT (roadster)",
      "CO2 (g/mi)": "450.9868000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 53 4MATIC+",
      "CO2 (g/mi)": "373.0500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 63 4MATIC+",
      "CO2 (g/mi)": "315.7800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 63 S 4MATIC+",
      "CO2 (g/mi)": "476.6700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT C (roadster)",
      "CO2 (g/mi)": "480.2420000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT R (coupe)",
      "CO2 (g/mi)": "480.8593946",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC",
      "CO2 (g/mi)": "425.9400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (convertible)",
      "CO2 (g/mi)": "481.6200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (coupe)",
      "CO2 (g/mi)": "420.9000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 65",
      "CO2 (g/mi)": "572.9100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG SLC 43",
      "CO2 (g/mi)": "352.0100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "283.6580000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (convertible)",
      "CO2 (g/mi)": "333.0821000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (coupe)",
      "CO2 (g/mi)": "317.6850000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "309.9675000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (convertible)",
      "CO2 (g/mi)": "337.6327000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (coupe)",
      "CO2 (g/mi)": "321.6710000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "277.8200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "185.4400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 450",
      "CO2 (g/mi)": "287.6100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 450 4MATIC",
      "CO2 (g/mi)": "296.7000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "300.9890000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "317.5250000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 (convertible)",
      "CO2 (g/mi)": "355.2000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 (coupe)",
      "CO2 (g/mi)": "353.9700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC",
      "CO2 (g/mi)": "355.5300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (convertible)",
      "CO2 (g/mi)": "368.8100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (coupe)",
      "CO2 (g/mi)": "371.8100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (station wagon)",
      "CO2 (g/mi)": "370.9300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "550.1100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "282.2800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "204.3997803",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLB 250",
      "CO2 (g/mi)": "302.8470000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLB 250 4MATIC",
      "CO2 (g/mi)": "296.2350000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300",
      "CO2 (g/mi)": "217.3475000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC",
      "CO2 (g/mi)": "226.4808700",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC (Coupe)",
      "CO2 (g/mi)": "327.9410200",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 350e 4MATIC",
      "CO2 (g/mi)": "274.9500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 350",
      "CO2 (g/mi)": "357.3800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 350 4MATIC",
      "CO2 (g/mi)": "362.6400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 450 4MATIC",
      "CO2 (g/mi)": "364.2900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 580 4MATIC",
      "CO2 (g/mi)": "299.6700000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 450 4MATIC",
      "CO2 (g/mi)": "365.1600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 580 4MATIC",
      "CO2 (g/mi)": "429.5600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Maybach S 650",
      "CO2 (g/mi)": "552.0100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van)",
      "CO2 (g/mi)": "349.3200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van, LWB)",
      "CO2 (g/mi)": "343.7000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Passenger Van)",
      "CO2 (g/mi)": "367.8800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 450",
      "CO2 (g/mi)": "377.2800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 450 4MATIC",
      "CO2 (g/mi)": "382.5800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560",
      "CO2 (g/mi)": "224.3400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC",
      "CO2 (g/mi)": "228.5800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (convertible)",
      "CO2 (g/mi)": "415.5100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (coupe)",
      "CO2 (g/mi)": "234.2400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC Maybach",
      "CO2 (g/mi)": "251.2400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560e",
      "CO2 (g/mi)": "413.5190000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 450",
      "CO2 (g/mi)": "360.7268040",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SL 550",
      "CO2 (g/mi)": "405.4900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "SLC 300",
      "CO2 (g/mi)": "295.9900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS 2WD",
      "CO2 (g/mi)": "332.3484400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS 4WD",
      "CO2 (g/mi)": "349.6972400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS ES 2WD",
      "CO2 (g/mi)": "315.2418400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "ECLIPSE CROSS ES 4WD",
      "CO2 (g/mi)": "334.8980400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "196.1705900",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE G4",
      "CO2 (g/mi)": "198.2625800",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 2WD",
      "CO2 (g/mi)": "271.8395400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER 4WD",
      "CO2 (g/mi)": "288.3114100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER PHEV",
      "CO2 (g/mi)": "230.6314400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "281.1288000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "292.9984400",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD",
      "CO2 (g/mi)": "375.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD RED SPORT",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 RED SPORT",
      "CO2 (g/mi)": "359.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60",
      "CO2 (g/mi)": "365.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 AWD RED SPORT",
      "CO2 (g/mi)": "377.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 RED SPORT",
      "CO2 (g/mi)": "226.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50",
      "CO2 (g/mi)": "295.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50 AWD",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 AWD",
      "CO2 (g/mi)": "242.0857527",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX60 FWD",
      "CO2 (g/mi)": "238.7095314",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX80 2WD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX80 4WD",
      "CO2 (g/mi)": "548.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "370Z",
      "CO2 (g/mi)": "247.1689065",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "370Z Roadster",
      "CO2 (g/mi)": "390.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA",
      "CO2 (g/mi)": "231.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA SR/PLATINUM",
      "CO2 (g/mi)": "166.1728464",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 2WD",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ARMADA 4WD",
      "CO2 (g/mi)": "541.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 2WD SV",
      "CO2 (g/mi)": "384.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD PRO-4X",
      "CO2 (g/mi)": "403.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "FRONTIER 4WD SV",
      "CO2 (g/mi)": "405.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "GT-R",
      "CO2 (g/mi)": "444.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Kicks",
      "CO2 (g/mi)": "215.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF SV/SL",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA",
      "CO2 (g/mi)": "337.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO AWD",
      "CO2 (g/mi)": "355.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO FWD",
      "CO2 (g/mi)": "347.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "NV200 Cargo Van",
      "CO2 (g/mi)": "351.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 2WD",
      "CO2 (g/mi)": "356.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 4WD",
      "CO2 (g/mi)": "360.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "PATHFINDER 4WD PLATINUM",
      "CO2 (g/mi)": "374.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD",
      "CO2 (g/mi)": "286.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD",
      "CO2 (g/mi)": "266.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport",
      "CO2 (g/mi)": "253.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Rogue Sport AWD",
      "CO2 (g/mi)": "272.2087430",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Sentra",
      "CO2 (g/mi)": "229.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Sentra SR",
      "CO2 (g/mi)": "162.2371884",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 2WD",
      "CO2 (g/mi)": "447.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD",
      "CO2 (g/mi)": "459.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD PRO-4X",
      "CO2 (g/mi)": "485.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "VERSA",
      "CO2 (g/mi)": "170.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Pagani Automobili",
      "Represented Test Veh Model": "Huayra Roadster BC",
      "CO2 (g/mi)": "755.3000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "718 Cayman GT4",
      "CO2 (g/mi)": "432.6800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "718 Spyder",
      "CO2 (g/mi)": "281.9600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "250.5300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "252.8600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "375.3300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "376.9226000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "265.7252000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "273.1644897",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "380.9968000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "383.2400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "238.4000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "258.2500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "372.3000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Coupe",
      "CO2 (g/mi)": "379.5300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne e-Hybrid Coupe",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "386.4500000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S Coupe",
      "CO2 (g/mi)": "400.8200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "470.8000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo Coupe",
      "CO2 (g/mi)": "481.5600000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo S e-Hybrid",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman S",
      "CO2 (g/mi)": "366.2400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan",
      "CO2 (g/mi)": "357.1885000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan GTS",
      "CO2 (g/mi)": "397.7800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "366.0800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo",
      "CO2 (g/mi)": "399.4300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera",
      "CO2 (g/mi)": "350.4000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4",
      "CO2 (g/mi)": "363.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 e-Hybrid ST",
      "CO2 (g/mi)": "327.1000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4 Executive",
      "CO2 (g/mi)": "356.4000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S Executive",
      "CO2 (g/mi)": "370.2100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera 4S ST",
      "CO2 (g/mi)": "373.7200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS",
      "CO2 (g/mi)": "439.6200000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera GTS ST",
      "CO2 (g/mi)": "452.3400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo Executive",
      "CO2 (g/mi)": "382.8800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo S e-Hybrid ST",
      "CO2 (g/mi)": "285.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Panamera Turbo ST",
      "CO2 (g/mi)": "403.4100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Taycan 4S Perf Battery Plus",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Taycan Turbo",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Taycan Turbo S",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Cullinan",
      "CO2 (g/mi)": "619.0624000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Cullinan Black Badge",
      "CO2 (g/mi)": "623.7959037",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Dawn",
      "CO2 (g/mi)": "603.6100000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "623.8045000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost EWB",
      "CO2 (g/mi)": "628.1900000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "584.8800000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "744.6000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Roush",
      "Represented Test Veh Model": "Stage 3 Mustang",
      "CO2 (g/mi)": "573.8400000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "RUF",
      "Represented Test Veh Model": "TURBO 12/CTR 3/CTR 2017",
      "CO2 (g/mi)": "436.1000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "86",
      "CO2 (g/mi)": "331.1700100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "ASCENT",
      "CO2 (g/mi)": "241.1467276",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "ASCENT LIMITED/TOURING",
      "CO2 (g/mi)": "352.6695260",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ",
      "CO2 (g/mi)": "283.1214290",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "BRZ tS",
      "CO2 (g/mi)": "335.6724820",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK",
      "CO2 (g/mi)": "308.8570690",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK AWD",
      "CO2 (g/mi)": "248.2726140",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "259.4156300",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA 4-Door",
      "CO2 (g/mi)": "234.5877730",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "Impreza 5-Door",
      "CO2 (g/mi)": "257.5776281",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "251.5702240",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "262.6977510",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "330.1747100",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "86",
      "CO2 (g/mi)": "288.6383830",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Long Range AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model":
        'Model 3 Long Range AWD Performance (18" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model":
        'Model 3 Long Range AWD Performance (19" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model":
        'Model 3 Long Range AWD Performance (20" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Standard Range Plus RWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Standard Range RWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model S Long Range",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model S Long Range Plus",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model S Performance (19" Wheel)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model S Performance (21" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model S Standard Range",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model X Long Range",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model X Long Range Plus",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model X Performance (20" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model X Performance (22" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model X Standard Range",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model Y Long Range AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model Y Performance AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model Y Performance AWD (21" Wheels)',
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Long Range",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Tesla Model 3",
      "Represented Test Veh Model": "Mid Range RWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "188.1122182",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "309.3614464",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350 F SPORT",
      "CO2 (g/mi)": "320.9854330",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350",
      "CO2 (g/mi)": "354.0594128",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "365.8044844",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 F SPORT",
      "CO2 (g/mi)": "229.9275437",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS F",
      "CO2 (g/mi)": "272.8677435",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "335.8560296",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 300",
      "CO2 (g/mi)": "332.8047045",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500",
      "CO2 (g/mi)": "256.0687830",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500h",
      "CO2 (g/mi)": "314.9970977",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500",
      "CO2 (g/mi)": "369.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500 AWD",
      "CO2 (g/mi)": "391.4409874",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500h",
      "CO2 (g/mi)": "377.0087149",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500h AWD",
      "CO2 (g/mi)": "289.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "593.7789944",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.2030260",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "203.0984779",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC 350",
      "CO2 (g/mi)": "348.7059821",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC 350 AWD",
      "CO2 (g/mi)": "383.7962877",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "264.7903519",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "227.9272582",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "240.0782630",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "214.0406074",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 200",
      "CO2 (g/mi)": "227.1603912",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 250h",
      "CO2 (g/mi)": "220.4927919",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 250h AWD",
      "CO2 (g/mi)": "161.2221927",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "306.8214576",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "318.3059360",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON",
      "CO2 (g/mi)": "201.3013712",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON HYBRID",
      "CO2 (g/mi)": "200.2891170",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON HYBRID XLE",
      "CO2 (g/mi)": "209.0477833",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON XLE",
      "CO2 (g/mi)": "187.6459986",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "C-HR",
      "CO2 (g/mi)": "328.8941905",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "143.4359198",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY AWD LE/SE",
      "CO2 (g/mi)": "174.5514762",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID LE",
      "CO2 (g/mi)": "180.0303654",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID XLE/SE",
      "CO2 (g/mi)": "212.3416743",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY LE/SE",
      "CO2 (g/mi)": "246.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XLE/XSE",
      "CO2 (g/mi)": "248.2167202",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XSE",
      "CO2 (g/mi)": "192.3534168",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "231.8515293",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HATCHBACK",
      "CO2 (g/mi)": "155.7985377",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HATCHBACK MANUAL",
      "CO2 (g/mi)": "239.9560813",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HYBRID",
      "CO2 (g/mi)": "167.6613704",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA XLE",
      "CO2 (g/mi)": "167.9284982",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA XSE",
      "CO2 (g/mi)": "210.4449624",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "214.9655638",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "350.3817166",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID",
      "CO2 (g/mi)": "234.8789354",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "239.4927739",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LTD/PLAT",
      "CO2 (g/mi)": "245.3413808",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUSER WAGON 4WD",
      "CO2 (g/mi)": "361.4580823",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "123.7047548",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS AWD",
      "CO2 (g/mi)": "193.4888283",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Eco",
      "CO2 (g/mi)": "153.2872691",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS PRIME",
      "CO2 (g/mi)": "180.4342403",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "173.5263854",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "183.8557185",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD TRD OFFROAD",
      "CO2 (g/mi)": "274.9860179",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 HYBRID AWD",
      "CO2 (g/mi)": "207.6229349",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "545.8558090",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "570.1310668",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "239.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "403.2300000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "361.7924411",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "417.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD D-CAB V6 MT OFF-ROAD",
      "CO2 (g/mi)": "319.0533243",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "531.6561360",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "555.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3",
      "CO2 (g/mi)": "265.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 Cabriolet quattro",
      "CO2 (g/mi)": "315.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A3 quattro",
      "CO2 (g/mi)": "357.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "252.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "297.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 Allroad",
      "CO2 (g/mi)": "379.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 Quattro (C8)",
      "CO2 (g/mi)": "286.5399475",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "562.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8 e-tron",
      "CO2 (g/mi)": "340.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "492.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi e-tron 55 quattro Sportback",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "442.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "347.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5 e-tron",
      "CO2 (g/mi)": "426.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "414.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q8",
      "CO2 (g/mi)": "482.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "546.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS3",
      "CO2 (g/mi)": "340.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RSQ8",
      "CO2 (g/mi)": "518.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4 Sedan",
      "CO2 (g/mi)": "234.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S7",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8",
      "CO2 (g/mi)": "513.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "393.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ7",
      "CO2 (g/mi)": "486.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ8",
      "CO2 (g/mi)": "480.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT",
      "CO2 (g/mi)": "212.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTRS",
      "CO2 (g/mi)": "429.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTS",
      "CO2 (g/mi)": "364.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga",
      "CO2 (g/mi)": "393.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga V8",
      "CO2 (g/mi)": "505.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga W12",
      "CO2 (g/mi)": "615.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT Convertible W12",
      "CO2 (g/mi)": "586.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Mulsanne Speed",
      "CO2 (g/mi)": "787.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Bugatti Chiron",
      "CO2 (g/mi)": "855.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Bugatti Divo",
      "CO2 (g/mi)": "846.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "AVENTADOR S",
      "CO2 (g/mi)": "863.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Aventador SVJ",
      "CO2 (g/mi)": "811.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan performante",
      "CO2 (g/mi)": "504.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Sian",
      "CO2 (g/mi)": "891.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Urus",
      "CO2 (g/mi)": "572.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Arteon",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Atlas",
      "CO2 (g/mi)": "414.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Atlas Cross Sport AWD",
      "CO2 (g/mi)": "382.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Audi S3",
      "CO2 (g/mi)": "386.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "272.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf GTI",
      "CO2 (g/mi)": "366.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "263.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta GLI",
      "CO2 (g/mi)": "292.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "302.5395813",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan",
      "CO2 (g/mi)": "311.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan AWD",
      "CO2 (g/mi)": "343.5201721",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Polestar",
      "Represented Test Veh Model": "Polestar 1",
      "CO2 (g/mi)": "321.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "176.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "192.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T8 AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T6 AWD",
      "CO2 (g/mi)": "328.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T8 AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60CC T5 AWD",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90CC T6 AWD",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 T4 FWD",
      "CO2 (g/mi)": "296.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 T5 AWD",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "343.8108521",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 FWD",
      "CO2 (g/mi)": "321.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "347.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T8 AWD",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 FWD",
      "CO2 (g/mi)": "325.0000000",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T6 AWD",
      "CO2 (g/mi)": "241.0446990",
    },
    {
      "Model Year": "2020",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T8 AWD",
    },
  ],
  2021: [
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11",
      "CO2 (g/mi)": "466.8700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DB11 V8",
      "CO2 (g/mi)": "386.6600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBS",
      "CO2 (g/mi)": "499.6900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "DBX",
      "CO2 (g/mi)": "524.2220000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vantage Manual",
      "CO2 (g/mi)": "516.2900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Aston Martin",
      "Represented Test Veh Model": "Vantage V8",
      "CO2 (g/mi)": "393.7600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i Gran Coupe",
      "CO2 (g/mi)": "278.7595253",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "228i xDrive Gran Coupe",
      "CO2 (g/mi)": "296.4722894",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Convertible",
      "CO2 (g/mi)": "195.2600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230i Coupe",
      "CO2 (g/mi)": "337.1654796",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230I XDRIVE CONVERTIBLE",
      "CO2 (g/mi)": "348.3918656",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "230I XDRIVE COUPE",
      "CO2 (g/mi)": "315.3233514",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330e",
      "CO2 (g/mi)": "359.4342713",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330e xDrive",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i",
      "CO2 (g/mi)": "259.6720000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "330i xDrive",
      "CO2 (g/mi)": "276.6410000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i Coupe",
      "CO2 (g/mi)": "260.1399804",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "430i xDrive Coupe",
      "CO2 (g/mi)": "288.2270587",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e",
      "CO2 (g/mi)": "316.5432000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530e xDrive",
      "CO2 (g/mi)": "335.4582000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i",
      "CO2 (g/mi)": "272.5854124",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "530i xDrive",
      "CO2 (g/mi)": "292.7068635",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i",
      "CO2 (g/mi)": "276.7645000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "540i xDrive",
      "CO2 (g/mi)": "295.3375000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i",
      "CO2 (g/mi)": "315.9856000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "740i xDrive",
      "CO2 (g/mi)": "227.7684937",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "745e xDrive",
      "CO2 (g/mi)": "361.0436333",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "750i xDrive",
      "CO2 (g/mi)": "419.1860000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i Convertible",
      "CO2 (g/mi)": "317.3106167",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i Coupe",
      "CO2 (g/mi)": "303.8518103",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i Gran Coupe",
      "CO2 (g/mi)": "314.0062541",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i xDrive Convertible",
      "CO2 (g/mi)": "348.7821891",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "840i xDrive Coupe",
      "CO2 (g/mi)": "334.1453375",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Alpina B7",
      "CO2 (g/mi)": "493.9261106",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "ALPINA XB7",
      "CO2 (g/mi)": "517.5380588",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "I3s",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M2 Competition",
      "CO2 (g/mi)": "364.8300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M235i xDrive",
      "CO2 (g/mi)": "300.0346692",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i",
      "CO2 (g/mi)": "312.2200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i CONVERTIBLE",
      "CO2 (g/mi)": "391.8114982",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i Coupe",
      "CO2 (g/mi)": "376.6216000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive",
      "CO2 (g/mi)": "319.7018000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M240i xDrive Convertible",
      "CO2 (g/mi)": "324.6900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M340i",
      "CO2 (g/mi)": "294.0200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M340i xDrive",
      "CO2 (g/mi)": "294.6267000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Competition Coupe",
      "CO2 (g/mi)": "376.5071000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M4 Coupe",
      "CO2 (g/mi)": "435.2430000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M440i xDrive Coupe",
      "CO2 (g/mi)": "194.8899708",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M550i xDrive",
      "CO2 (g/mi)": "407.3651114",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M760i xDrive",
      "CO2 (g/mi)": "545.2692000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Convertible",
      "CO2 (g/mi)": "405.1206000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Coupe",
      "CO2 (g/mi)": "388.1100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "M850i xDrive Gran Coupe",
      "CO2 (g/mi)": "263.5801227",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "MINI COOPER SE HARDTOP 2 DOOR",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "SUPRA 2.0",
      "CO2 (g/mi)": "185.3949000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Supra 3.0",
      "CO2 (g/mi)": "309.7663676",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 sDrive28i",
      "CO2 (g/mi)": "187.9065409",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X1 xDrive28i",
      "CO2 (g/mi)": "200.2363476",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 M35i",
      "CO2 (g/mi)": "286.0316247",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X2 sDrive28i",
      "CO2 (g/mi)": "190.5540209",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 M",
      "CO2 (g/mi)": "290.9430000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 sDrive30i",
      "CO2 (g/mi)": "272.5113088",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X3 xDrive30e",
      "CO2 (g/mi)": "285.1688000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 M40i",
      "CO2 (g/mi)": "333.7261000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X4 xDrive30i",
      "CO2 (g/mi)": "228.6842041",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 M50i",
      "CO2 (g/mi)": "297.0123672",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 sDrive40i",
      "CO2 (g/mi)": "237.7282423",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive40i",
      "CO2 (g/mi)": "331.6142000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X5 xDrive45e",
      "CO2 (g/mi)": "419.5224557",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 M50i",
      "CO2 (g/mi)": "427.8052019",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 sDrive40i",
      "CO2 (g/mi)": "324.4779000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X6 xDrive40i",
      "CO2 (g/mi)": "330.9803000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 M50i",
      "CO2 (g/mi)": "468.4765306",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "X7 xDrive40i",
      "CO2 (g/mi)": "358.1179000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 M40I",
      "CO2 (g/mi)": "301.9849401",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMW",
      "Represented Test Veh Model": "Z4 sDrive30i",
      "CO2 (g/mi)": "275.0360000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M5 Competition",
      "CO2 (g/mi)": "284.0087891",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M8 Competition Convertible",
      "CO2 (g/mi)": "419.7576000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M8 Competition Coupe",
      "CO2 (g/mi)": "404.7367000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "M8 Competition Gran Coupe",
      "CO2 (g/mi)": "409.9707000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BMX",
      "Represented Test Veh Model": "X5 M Competition",
      "CO2 (g/mi)": "468.4913000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER CONVERTIBLE",
      "CO2 (g/mi)": "236.7964414",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER COUNTRYMAN",
      "CO2 (g/mi)": "253.0061328",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER COUNTRYMAN ALL4",
      "CO2 (g/mi)": "290.1238526",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER HARDTOP 2 DOOR",
      "CO2 (g/mi)": "157.6474475",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER HARDTOP 4 DOOR",
      "CO2 (g/mi)": "233.0043410",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S CLUBMAN",
      "CO2 (g/mi)": "309.9639914",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S CLUBMAN ALL4",
      "CO2 (g/mi)": "296.8189240",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER S CONVERTIBLE",
      "CO2 (g/mi)": "176.7142282",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S COUNTRYMAN",
      "CO2 (g/mi)": "280.6281408",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "COOPER S COUNTRYMAN ALL4",
      "CO2 (g/mi)": "196.5951595",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER S HARDTOP 2 DOOR",
      "CO2 (g/mi)": "251.5483706",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "COOPER S HARDTOP 4 DOOR",
      "CO2 (g/mi)": "266.2491007",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JCW CLUBMAN ALL4",
      "CO2 (g/mi)": "297.3652108",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JCW COUNTRYMAN ALL4",
      "CO2 (g/mi)": "292.3655012",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JOHN COOPER WORKS CONVERTIBLE",
      "CO2 (g/mi)": "271.0630362",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "John Cooper Works GP",
      "CO2 (g/mi)": "286.3796321",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mini",
      "Represented Test Veh Model": "JOHN COOPER WORKS HARDTOP",
      "CO2 (g/mi)": "264.1020689",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MINI",
      "Represented Test Veh Model": "Mini Cooper SE Countryman ALL4",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia",
      "CO2 (g/mi)": "405.9376300",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Giulia AWD",
      "CO2 (g/mi)": "308.0348100",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio",
      "CO2 (g/mi)": "299.0857400",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Alfa Romeo",
      "Represented Test Veh Model": "Stelvio AWD",
      "CO2 (g/mi)": "419.7914200",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica",
      "CO2 (g/mi)": "366.5736700",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica AWD",
      "CO2 (g/mi)": "425.7041500",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Chrysler",
      "Represented Test Veh Model": "Pacifica Hybrid",
      "CO2 (g/mi)": "260.8730000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger",
      "CO2 (g/mi)": "510.5503600",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT Widebody",
      "CO2 (g/mi)": "603.3490100",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Challenger SRT8",
      "CO2 (g/mi)": "552.3954300",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger",
      "CO2 (g/mi)": "370.3176000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger AWD",
      "CO2 (g/mi)": "233.3990000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger SRT",
      "CO2 (g/mi)": "689.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Charger SRT Widebody",
      "CO2 (g/mi)": "589.9163500",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango AWD",
      "CO2 (g/mi)": "514.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango RWD",
      "CO2 (g/mi)": "510.2874757",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Dodge",
      "Represented Test Veh Model": "Durango SRT AWD",
      "CO2 (g/mi)": "562.3241400",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Fiat",
      "Represented Test Veh Model": "500X AWD",
      "CO2 (g/mi)": "296.6402600",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4X4",
      "CO2 (g/mi)": "331.5532042",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee 4x4 Active Drive II",
      "CO2 (g/mi)": "343.6912100",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee FWD",
      "CO2 (g/mi)": "319.3632000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Cherokee Trailhawk 4X4",
      "CO2 (g/mi)": "384.1057600",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X2",
      "CO2 (g/mi)": "313.9006900",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Compass 4X4",
      "CO2 (g/mi)": "321.3667976",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Gladiator 4X4",
      "CO2 (g/mi)": "257.7553900",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Gladiator Pickup 4x4",
      "CO2 (g/mi)": "413.9886475",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X2",
      "CO2 (g/mi)": "371.7277400",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee 4X4",
      "CO2 (g/mi)": "380.9087000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Grand Cherokee SRT8",
      "CO2 (g/mi)": "563.0799600",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x2",
      "CO2 (g/mi)": "320.0806735",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade 4x4",
      "CO2 (g/mi)": "331.5249654",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Renegade Trailhawk 4x4",
      "CO2 (g/mi)": "219.2700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4dr 4X4",
      "CO2 (g/mi)": "366.4124400",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler 4X4",
      "CO2 (g/mi)": "256.3254208",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jeep",
      "Represented Test Veh Model": "Wrangler Unlimited 4x4",
      "CO2 (g/mi)": "247.4974670",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 2WD",
      "CO2 (g/mi)": "420.1881700",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X2",
      "CO2 (g/mi)": "353.9187927",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 4X4",
      "CO2 (g/mi)": "375.5136719",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 HFE 4X2",
      "CO2 (g/mi)": "346.1058655",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "1500 TRX 4x4",
      "CO2 (g/mi)": "700.7535200",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "RAM",
      "Represented Test Veh Model": "Promaster City",
      "CO2 (g/mi)": "334.4049683",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "812 GTS",
      "CO2 (g/mi)": "618.4892000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "812 Superfast",
      "CO2 (g/mi)": "605.5068000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F8 Spider",
      "CO2 (g/mi)": "525.0488000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "F8 Tributo",
      "CO2 (g/mi)": "336.1608000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "Portofino",
      "CO2 (g/mi)": "458.7116000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "Portofino M",
      "CO2 (g/mi)": "452.3416000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "Roma",
      "CO2 (g/mi)": "440.7326000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ferrari",
      "Represented Test Veh Model": "SF90 Stradale Coupe",
      "CO2 (g/mi)": "346.5893400",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "1.0L EcoSport",
      "CO2 (g/mi)": "249.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Bronco Sport",
      "CO2 (g/mi)": "270.6560000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "EcoSport",
      "CO2 (g/mi)": "299.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Expedition",
      "CO2 (g/mi)": "279.5190000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer",
      "CO2 (g/mi)": "399.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Explorer FHEV",
      "CO2 (g/mi)": "295.4260000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F-150",
      "CO2 (g/mi)": "390.8281200",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150",
      "CO2 (g/mi)": "431.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 FHEV",
      "CO2 (g/mi)": "284.3170000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Crew Cab 4X2",
      "CO2 (g/mi)": "242.6718000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "F150 Super Crew Cab 4X4",
      "CO2 (g/mi)": "434.8170000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ford Explorer",
      "CO2 (g/mi)": "334.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "GT",
      "CO2 (g/mi)": "589.7090000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mach-E",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mach-E California Route 1",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang",
      "CO2 (g/mi)": "458.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Mustang Mach-E AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility",
      "CO2 (g/mi)": "425.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Police Interceptor Utility HEV",
      "CO2 (g/mi)": "264.2520000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger - Chassis Cab",
      "CO2 (g/mi)": "306.8520000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "Ranger - Super Crew Cab",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FFV",
      "CO2 (g/mi)": "275.4871989",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT VAN FWD",
      "CO2 (g/mi)": "284.9910000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Ford",
      "Represented Test Veh Model": "TRANSIT CONNECT WAGON LWB",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Aviator",
      "CO2 (g/mi)": "416.9650000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Aviator PHEV",
      "CO2 (g/mi)": "325.1970000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Corsair",
      "CO2 (g/mi)": "320.5610000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Explorer Police",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Lincoln",
      "Represented Test Veh Model": "Navigator",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE AWD",
      "CO2 (g/mi)": "207.0742266",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE FWD",
      "CO2 (g/mi)": "197.1990000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE GX AWD",
      "CO2 (g/mi)": "319.7750000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENCORE GX FWD",
      "CO2 (g/mi)": "293.5240000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUICK",
      "Represented Test Veh Model": "ENVISION FWD",
      "CO2 (g/mi)": "293.9840000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4",
      "CO2 (g/mi)": "298.8140000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4 AWD",
      "CO2 (g/mi)": "308.8450000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT4 V AWD",
      "CO2 (g/mi)": "342.3850000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT5",
      "CO2 (g/mi)": "303.5630000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "CT5 AWD",
      "CO2 (g/mi)": "210.3889465",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "ESCALADE 4WD",
      "CO2 (g/mi)": "398.1500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT4 AWD",
      "CO2 (g/mi)": "309.1740000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT4 FWD",
      "CO2 (g/mi)": "288.6800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 AWD",
      "CO2 (g/mi)": "317.8200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT5 FWD",
      "CO2 (g/mi)": "306.4900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT6 AWD",
      "CO2 (g/mi)": "334.8540000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CADILLAC",
      "Represented Test Veh Model": "XT6 FWD",
      "CO2 (g/mi)": "328.5620000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BLAZER AWD",
      "CO2 (g/mi)": "370.8430000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BLAZER FWD",
      "CO2 (g/mi)": "362.1830000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "BOLT EV",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "C10 SILVERADO 2WD",
      "CO2 (g/mi)": "355.3560000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CAMARO",
      "CO2 (g/mi)": "356.6150000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 2WD",
      "CO2 (g/mi)": "366.2100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO 4WD",
      "CO2 (g/mi)": "389.2990000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "COLORADO ZR2 4WD",
      "CO2 (g/mi)": "482.4560000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "CORVETTE",
      "CO2 (g/mi)": "490.4250000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX AWD",
      "CO2 (g/mi)": "205.2860000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "EQUINOX FWD",
      "CO2 (g/mi)": "258.5720000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K10 SILVERADO 4WD",
      "CO2 (g/mi)": "447.8280000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "K10 SILVERADO 4WD TRAILBOSS",
      "CO2 (g/mi)": "497.5870000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "MALIBU",
      "CO2 (g/mi)": "223.9960000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 2WD",
      "CO2 (g/mi)": "459.0910000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 2WD CAB CHASSIS",
      "CO2 (g/mi)": "505.0170000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 4WD",
      "CO2 (g/mi)": "481.9550000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SILVERADO 4WD TRAILBOSS",
      "CO2 (g/mi)": "498.0750000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK",
      "CO2 (g/mi)": "230.0980000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SPARK ACTIV",
      "CO2 (g/mi)": "159.0410000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "SUBURBAN 4WD",
      "CO2 (g/mi)": "466.8870000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TAHOE 2WD",
      "CO2 (g/mi)": "374.1960000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TAHOE 4WD",
      "CO2 (g/mi)": "412.5049133",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAILBLAZER AWD",
      "CO2 (g/mi)": "310.3500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAILBLAZER FWD",
      "CO2 (g/mi)": "181.0992332",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE",
      "CO2 (g/mi)": "393.4560000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAVERSE AWD",
      "CO2 (g/mi)": "397.3730000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "CHEVROLET",
      "Represented Test Veh Model": "TRAX FWD",
      "CO2 (g/mi)": "189.4820000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA AWD",
      "CO2 (g/mi)": "313.6600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "ACADIA FWD",
      "CO2 (g/mi)": "308.8460000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "C10 SIERRA 2WD",
      "CO2 (g/mi)": "236.4670000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD",
      "CO2 (g/mi)": "475.0710000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD AT4",
      "CO2 (g/mi)": "491.8000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "K10 SIERRA 4WD CAB CHASSIS",
      "CO2 (g/mi)": "515.6460000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "SIERRA 2WD",
      "CO2 (g/mi)": "440.1940000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "SIERRA 4WD",
      "CO2 (g/mi)": "433.7830000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN AWD",
      "CO2 (g/mi)": "280.3000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "TERRAIN FWD",
      "CO2 (g/mi)": "269.3000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "YUKON 2WD",
      "CO2 (g/mi)": "387.2000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "YUKON XL 2WD",
      "CO2 (g/mi)": "501.3520000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "GMC",
      "Represented Test Veh Model": "YUKON XL 4WD",
      "CO2 (g/mi)": "332.1300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "ILX",
      "CO2 (g/mi)": "282.7700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX AWD",
      "CO2 (g/mi)": "326.0200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX AWD A-SPEC",
      "CO2 (g/mi)": "375.9500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX FWD",
      "CO2 (g/mi)": "221.1000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "RDX FWD A-SPEC",
      "CO2 (g/mi)": "223.3600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX AWD",
      "CO2 (g/mi)": "333.8500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX AWD ASPEC",
      "CO2 (g/mi)": "334.5100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX FWD",
      "CO2 (g/mi)": "316.8200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "ACURA",
      "Represented Test Veh Model": "TLX FWD ASPEC",
      "CO2 (g/mi)": "320.4300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD",
      "CO2 (g/mi)": "306.4000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ACCORD HYBRID",
      "CO2 (g/mi)": "182.3800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 1.5L",
      "CO2 (g/mi)": "227.9900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 4DR SEDAN 2.0L",
      "CO2 (g/mi)": "310.0800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CIVIC 5DR",
      "CO2 (g/mi)": "253.0200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Fuel Cell",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "Clarity Plug-in Hybrid",
      "CO2 (g/mi)": "197.1600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V 1.5L TC",
      "CO2 (g/mi)": "228.3300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "CR-V AWD",
      "CO2 (g/mi)": "157.2700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Honda",
      "Represented Test Veh Model": "HR-V AWD",
      "CO2 (g/mi)": "204.0100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Honda",
      "Represented Test Veh Model": "HR-V FWD",
      "CO2 (g/mi)": "181.8900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "INSIGHT",
      "CO2 (g/mi)": "207.6000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "ODYSSEY FWD",
      "CO2 (g/mi)": "364.9000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PASSPORT",
      "CO2 (g/mi)": "377.4300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT",
      "CO2 (g/mi)": "366.7400000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 2WD 9AT",
      "CO2 (g/mi)": "349.8300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HONDA",
      "Represented Test Veh Model": "PILOT 4WD 9AT",
      "CO2 (g/mi)": "251.3700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "G70",
      "CO2 (g/mi)": "384.5252000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "G80",
      "CO2 (g/mi)": "313.0748000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "G90",
      "CO2 (g/mi)": "428.3110000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Genesis",
      "Represented Test Veh Model": "GV80",
      "CO2 (g/mi)": "335.7918000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Accent",
      "CO2 (g/mi)": "214.1880000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra",
      "CO2 (g/mi)": "203.1251000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra Hybrid",
      "CO2 (g/mi)": "130.7470000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Elantra Hybrid Blue",
      "CO2 (g/mi)": "123.0819000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ",
      "CO2 (g/mi)": "111.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Ioniq Electric",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "IONIQ PHEV",
      "CO2 (g/mi)": "124.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "KONA",
      "CO2 (g/mi)": "185.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Kona Electric",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "NEXO",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Palisade",
      "CO2 (g/mi)": "263.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Santa Fe",
      "CO2 (g/mi)": "282.5064000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Sonata",
      "CO2 (g/mi)": "248.1904552",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "SONATA HYBRID",
      "CO2 (g/mi)": "211.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Tucson",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "VELOSTER",
      "CO2 (g/mi)": "264.4397212",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Hyundai",
      "Represented Test Veh Model": "Veloster N",
      "CO2 (g/mi)": "329.9540000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "HYUNDAI",
      "Represented Test Veh Model": "Venue",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Pace",
      "CO2 (g/mi)": "318.2624000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE",
      "CO2 (g/mi)": "372.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type AWD",
      "CO2 (g/mi)": "391.0100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-Type Convertible",
      "CO2 (g/mi)": "301.8080000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "F-TYPE SVR GEN 2",
      "CO2 (g/mi)": "515.0703000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "I-PACE",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XE AWD",
      "CO2 (g/mi)": "316.9184000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF",
      "CO2 (g/mi)": "273.2429000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Jaguar",
      "Represented Test Veh Model": "XF AWD",
      "CO2 (g/mi)": "300.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Defender",
      "CO2 (g/mi)": "388.0600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Discovery Sport",
      "CO2 (g/mi)": "384.3483000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover",
      "CO2 (g/mi)": "370.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover LWB",
      "CO2 (g/mi)": "549.8691000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport",
      "CO2 (g/mi)": "362.2860000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Sport SVR",
      "CO2 (g/mi)": "496.6958000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover SVA",
      "CO2 (g/mi)": "524.5657000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Land Rover",
      "Represented Test Veh Model": "Range Rover Velar",
      "CO2 (g/mi)": "343.7327000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LAND ROVER",
      "Represented Test Veh Model": "VELAR SV-D",
      "CO2 (g/mi)": "459.8928000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Range Rover",
      "Represented Test Veh Model": "Evoque",
      "CO2 (g/mi)": "362.1579000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Karma",
      "Represented Test Veh Model": "Revero GT",
      "CO2 (g/mi)": "554.9000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "CK",
      "CO2 (g/mi)": "377.3507588",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Forte",
      "CO2 (g/mi)": "276.3792000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "K5",
      "CO2 (g/mi)": "274.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Rio",
      "CO2 (g/mi)": "145.9129100",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SEDONA",
      "CO2 (g/mi)": "257.1772000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Seltos",
      "CO2 (g/mi)": "275.8915000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sorento",
      "CO2 (g/mi)": "289.2956000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "SORENTO HYBRID",
      "CO2 (g/mi)": "165.7687000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul",
      "CO2 (g/mi)": "285.0269000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Soul Electric",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Sportage",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "KIA",
      "Represented Test Veh Model": "Stinger",
      "CO2 (g/mi)": "326.8496000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kia",
      "Represented Test Veh Model": "Telluride",
      "CO2 (g/mi)": "259.3989000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Lotus",
      "Represented Test Veh Model": "Evora GT",
      "CO2 (g/mi)": "408.1608700",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Ghibli",
      "CO2 (g/mi)": "415.8290000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Ghibli S Q4",
      "CO2 (g/mi)": "448.2620000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Ghibli Trofeo",
      "CO2 (g/mi)": "532.4700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Levante",
      "CO2 (g/mi)": "457.2075000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Levante GTS",
      "CO2 (g/mi)": "532.2410000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Maserati",
      "Represented Test Veh Model": "Quattroporte S",
      "CO2 (g/mi)": "440.2840000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-3",
      "CO2 (g/mi)": "193.6960000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-30",
      "CO2 (g/mi)": "277.3340000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-5",
      "CO2 (g/mi)": "285.8510000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "CX-9",
      "CO2 (g/mi)": "340.5880000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA2",
      "CO2 (g/mi)": "214.9380000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MAZDA3",
      "CO2 (g/mi)": "298.1340000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "Mazda6",
      "CO2 (g/mi)": "293.7800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MAZDA",
      "Represented Test Veh Model": "MX-5",
      "CO2 (g/mi)": "260.2570000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "A 220",
      "CO2 (g/mi)": "276.6900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "A 220 4MATIC",
      "CO2 (g/mi)": "281.4800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG A 35 4MATIC",
      "CO2 (g/mi)": "316.4900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC",
      "CO2 (g/mi)": "232.8016663",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (convertible)",
      "CO2 (g/mi)": "369.2120000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 43 4MATIC (coupe)",
      "CO2 (g/mi)": "375.2491000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 S",
      "CO2 (g/mi)": "410.2920000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 S (convertible)",
      "CO2 (g/mi)": "422.3730000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG C 63 S (coupe)",
      "CO2 (g/mi)": "415.0810000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLA 35 4MATIC",
      "CO2 (g/mi)": "316.3310000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLA 45 4MATIC",
      "CO2 (g/mi)": "359.9600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG CLS 53 4MATIC+",
      "CO2 (g/mi)": "337.6100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 53 4MATIC+",
      "CO2 (g/mi)": "317.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 53 4MATIC+ (Convertible)",
      "CO2 (g/mi)": "234.5000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 53 4MATIC+ (Coupe)",
      "CO2 (g/mi)": "334.7000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 S 4MATIC+",
      "CO2 (g/mi)": "457.7300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG E 63 S 4MATIC+ (station wagon)",
      "CO2 (g/mi)": "448.8120000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG G 63",
      "CO2 (g/mi)": "567.0980618",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLA 35 4MATIC",
      "CO2 (g/mi)": "305.8700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLA 45 4MATIC",
      "CO2 (g/mi)": "347.7000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLB 35 4MATIC",
      "CO2 (g/mi)": "329.2500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC",
      "CO2 (g/mi)": "397.3660000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 43 4MATIC (coupe)",
      "CO2 (g/mi)": "408.6150000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 S 4MATIC+",
      "CO2 (g/mi)": "481.8810359",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLC 63 S 4MATIC+ (coupe)",
      "CO2 (g/mi)": "295.5745238",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 53 4MATIC+",
      "CO2 (g/mi)": "398.7100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 53 4MATIC+ (coupe)",
      "CO2 (g/mi)": "382.2700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63 S 4MATIC+",
      "CO2 (g/mi)": "486.7277459",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLE 63 S 4MATIC+ (coupe)",
      "CO2 (g/mi)": "476.4536734",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GLS 63 4MATIC+",
      "CO2 (g/mi)": "499.2700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT",
      "CO2 (g/mi)": "479.3643000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 53 4MATIC+",
      "CO2 (g/mi)": "357.3100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT 63 S 4MATIC+",
      "CO2 (g/mi)": "459.6660901",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT C",
      "CO2 (g/mi)": "484.5707000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG GT R",
      "CO2 (g/mi)": "502.9844000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC (convertible)",
      "CO2 (g/mi)": "500.3642275",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "AMG S 63 4MATIC+ (coupe)",
      "CO2 (g/mi)": "462.2801527",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300",
      "CO2 (g/mi)": "175.3805847",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (convertible)",
      "CO2 (g/mi)": "306.7381951",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 (coupe)",
      "CO2 (g/mi)": "293.9540238",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC",
      "CO2 (g/mi)": "295.8920000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (convertible)",
      "CO2 (g/mi)": "319.6211803",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "C 300 4MATIC (coupe)",
      "CO2 (g/mi)": "300.5658658",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250",
      "CO2 (g/mi)": "270.2600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLA 250 4MATIC",
      "CO2 (g/mi)": "183.9800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 450",
      "CO2 (g/mi)": "306.0630000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "CLS 450 4MATIC",
      "CO2 (g/mi)": "311.4783663",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350",
      "CO2 (g/mi)": "316.2360000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 350 4MATIC",
      "CO2 (g/mi)": "318.2640000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 (convertible)",
      "CO2 (g/mi)": "306.7000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 (coupe)",
      "CO2 (g/mi)": "299.1200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC",
      "CO2 (g/mi)": "308.0600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (convertible)",
      "CO2 (g/mi)": "306.5800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC (coupe)",
      "CO2 (g/mi)": "305.6800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "E 450 4MATIC All-Terrain (wagon)",
      "CO2 (g/mi)": "316.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "G 550",
      "CO2 (g/mi)": "341.3712179",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250",
      "CO2 (g/mi)": "277.9606000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLA 250 4MATIC",
      "CO2 (g/mi)": "287.7503000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLB 250",
      "CO2 (g/mi)": "297.2502900",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLB 250 4MATIC",
      "CO2 (g/mi)": "305.1510000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300",
      "CO2 (g/mi)": "316.3970000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC",
      "CO2 (g/mi)": "335.4265790",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLC 300 4MATIC (Coupe)",
      "CO2 (g/mi)": "314.7930000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 350",
      "CO2 (g/mi)": "363.3700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 350 4MATIC",
      "CO2 (g/mi)": "369.6900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 450 4MATIC",
      "CO2 (g/mi)": "339.3000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLE 580 4MATIC",
      "CO2 (g/mi)": "287.4700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 450 4MATIC",
      "CO2 (g/mi)": "262.6700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 580 4MATIC",
      "CO2 (g/mi)": "441.4700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "GLS 650 4MATIC Maybach",
      "CO2 (g/mi)": "487.6900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Cargo Van)",
      "CO2 (g/mi)": "402.9700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "Metris (Passenger Van)",
      "CO2 (g/mi)": "381.2000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Mercedes-Benz",
      "Represented Test Veh Model": "S 560 4MATIC (convertible)",
      "CO2 (g/mi)": "440.4039745",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE",
      "CO2 (g/mi)": "196.1705900",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "MIRAGE G4",
      "CO2 (g/mi)": "198.2625800",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 2WD",
      "CO2 (g/mi)": "281.1288000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "MITSUBISHI",
      "Represented Test Veh Model": "OUTLANDER SPORT 4WD",
      "CO2 (g/mi)": "292.9984400",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD LUXE",
      "CO2 (g/mi)": "369.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 AWD RED SPORT",
      "CO2 (g/mi)": "365.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 LUXE",
      "CO2 (g/mi)": "343.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q50 RED SPORT",
      "CO2 (g/mi)": "362.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 LUXE",
      "CO2 (g/mi)": "360.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "Q60 RED SPORT",
      "CO2 (g/mi)": "227.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50 AWD LUXE",
      "CO2 (g/mi)": "303.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50 AWD SENSORY",
      "CO2 (g/mi)": "318.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "INFINITI",
      "Represented Test Veh Model": "QX50 LUXE",
      "CO2 (g/mi)": "299.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA",
      "CO2 (g/mi)": "247.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA AWD",
      "CO2 (g/mi)": "168.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA AWD SR/PLATINUM",
      "CO2 (g/mi)": "268.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ALTIMA SR/PLATINUM",
      "CO2 (g/mi)": "271.6768421",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "GT-R",
      "CO2 (g/mi)": "444.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "LEAF SV/SL",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA PLATINUM",
      "CO2 (g/mi)": "328.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA S",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MAXIMA SL",
      "CO2 (g/mi)": "323.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO AWD S",
      "CO2 (g/mi)": "348.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO AWD SL",
      "CO2 (g/mi)": "362.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO AWD SV",
      "CO2 (g/mi)": "350.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO FWD S",
      "CO2 (g/mi)": "214.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO FWD SL",
      "CO2 (g/mi)": "344.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "MURANO FWD SV",
      "CO2 (g/mi)": "339.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD S",
      "CO2 (g/mi)": "186.1898667",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD SV/SL/PLATINUM PLATINUM",
      "CO2 (g/mi)": "266.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD SV/SL/PLATINUM SL",
      "CO2 (g/mi)": "187.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE AWD SV/SL/PLATINUM SV",
      "CO2 (g/mi)": "264.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD S",
      "CO2 (g/mi)": "250.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD SV/SL/PLATINUM PLATINUM",
      "CO2 (g/mi)": "260.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD SV/SL/PLATINUM SL",
      "CO2 (g/mi)": "186.2468567",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "ROGUE FWD SV/SL/PLATINUM SV",
      "CO2 (g/mi)": "257.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Sentra",
      "CO2 (g/mi)": "229.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA S",
      "CO2 (g/mi)": "228.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "Sentra SR",
      "CO2 (g/mi)": "162.2371884",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "SENTRA SV",
      "CO2 (g/mi)": "231.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 2WD SV",
      "CO2 (g/mi)": "301.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD PRO-4X",
      "CO2 (g/mi)": "495.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "TITAN 4WD SV",
      "CO2 (g/mi)": "464.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "NISSAN",
      "Represented Test Veh Model": "VERSA",
      "CO2 (g/mi)": "170.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "718 Cayman GTS 4.0",
      "CO2 (g/mi)": "419.9300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "718 Spyder",
      "CO2 (g/mi)": "420.4500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera",
      "CO2 (g/mi)": "370.3000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4",
      "CO2 (g/mi)": "375.9300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4 Cabriolet",
      "CO2 (g/mi)": "376.3500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S",
      "CO2 (g/mi)": "390.8300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera 4S Cabriolet",
      "CO2 (g/mi)": "268.3400000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Cabriolet",
      "CO2 (g/mi)": "370.1400000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S",
      "CO2 (g/mi)": "264.4100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera S Cabriolet",
      "CO2 (g/mi)": "265.3700000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Carrera Targa 4S",
      "CO2 (g/mi)": "378.5100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Targa",
      "CO2 (g/mi)": "374.7200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo",
      "CO2 (g/mi)": "462.7900000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo Cabriolet",
      "CO2 (g/mi)": "473.5200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S",
      "CO2 (g/mi)": "466.0100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "911 Turbo S Cabriolet",
      "CO2 (g/mi)": "485.5500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster",
      "CO2 (g/mi)": "238.4000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Boxster S",
      "CO2 (g/mi)": "258.2500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne",
      "CO2 (g/mi)": "373.5000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Coupe",
      "CO2 (g/mi)": "379.5300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS",
      "CO2 (g/mi)": "478.4300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne GTS Coupe",
      "CO2 (g/mi)": "463.3500000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S",
      "CO2 (g/mi)": "393.1100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne S Coupe",
      "CO2 (g/mi)": "400.8200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo",
      "CO2 (g/mi)": "470.8000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayenne Turbo Coupe",
      "CO2 (g/mi)": "481.5600000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Cayman S",
      "CO2 (g/mi)": "366.2400000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan",
      "CO2 (g/mi)": "357.1885000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan GTS",
      "CO2 (g/mi)": "397.7800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan S",
      "CO2 (g/mi)": "358.3200000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Macan Turbo",
      "CO2 (g/mi)": "399.4300000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Taycan 4S Perf Battery",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Taycan 4S Perf Battery Plus",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Porsche",
      "Represented Test Veh Model": "Taycan Turbo",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Cullinan",
      "CO2 (g/mi)": "619.0624000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Cullinan Black Badge",
      "CO2 (g/mi)": "623.7959037",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Dawn",
      "CO2 (g/mi)": "603.6100000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Ghost",
      "CO2 (g/mi)": "623.8045000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Rolls Royce",
      "Represented Test Veh Model": "Wraith",
      "CO2 (g/mi)": "584.8800000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Kandi",
      "Represented Test Veh Model": "K23",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "ASCENT",
      "CO2 (g/mi)": "347.1171661",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "ASCENT LIMITED/TOURING",
      "CO2 (g/mi)": "352.6695260",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK",
      "CO2 (g/mi)": "308.8570690",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK AWD",
      "CO2 (g/mi)": "248.2726140",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "CROSSTREK SPORT AWD",
      "CO2 (g/mi)": "177.6966880",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "FORESTER",
      "CO2 (g/mi)": "259.4156300",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "IMPREZA 4-Door",
      "CO2 (g/mi)": "234.5877730",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "Impreza 5-Door",
      "CO2 (g/mi)": "257.5776281",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "LEGACY",
      "CO2 (g/mi)": "251.5702240",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "OUTBACK AWD",
      "CO2 (g/mi)": "262.6977510",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "SUBARU",
      "Represented Test Veh Model": "WRX",
      "CO2 (g/mi)": "326.9003550",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Long Range AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Performance AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model 3 Standard Range Plus RWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model S Long Range Plus",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model S Performance (19" Wheels)',
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model S Performance (21" Wheels)',
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model X Long Range Plus",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model X Performance (20" Wheels)',
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": 'Model X Performance (22" Wheels)',
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model Y Long Range AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Tesla",
      "Represented Test Veh Model": "Model Y Performance AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 300h",
      "CO2 (g/mi)": "188.1122182",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350",
      "CO2 (g/mi)": "309.3614464",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "ES 350 F SPORT",
      "CO2 (g/mi)": "320.9854330",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GS 350 AWD",
      "CO2 (g/mi)": "365.8044844",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "GX 460",
      "CO2 (g/mi)": "335.8560296",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "IS 300",
      "CO2 (g/mi)": "331.0431376",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500",
      "CO2 (g/mi)": "256.0687830",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LC 500h",
      "CO2 (g/mi)": "247.4332664",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500",
      "CO2 (g/mi)": "379.0407207",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LS 500 AWD",
      "CO2 (g/mi)": "398.2698503",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "LX 570",
      "CO2 (g/mi)": "593.7789944",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t",
      "CO2 (g/mi)": "312.0911244",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD",
      "CO2 (g/mi)": "225.4821693",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 200t AWD F SPORT",
      "CO2 (g/mi)": "248.2030260",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "NX 300h AWD",
      "CO2 (g/mi)": "210.1926328",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC 350",
      "CO2 (g/mi)": "348.7059821",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RC F",
      "CO2 (g/mi)": "264.7903519",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350",
      "CO2 (g/mi)": "227.9272582",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 350 AWD",
      "CO2 (g/mi)": "240.0782630",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "RX 450h AWD",
      "CO2 (g/mi)": "214.0406074",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 200",
      "CO2 (g/mi)": "227.1603912",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 250h",
      "CO2 (g/mi)": "220.4927919",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LEXUS",
      "Represented Test Veh Model": "UX 250h AWD",
      "CO2 (g/mi)": "161.2221927",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 2WD",
      "CO2 (g/mi)": "306.8214576",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "4RUNNER 4WD",
      "CO2 (g/mi)": "318.3059360",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON",
      "CO2 (g/mi)": "201.3013712",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON HYBRID",
      "CO2 (g/mi)": "200.2891170",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON HYBRID XLE",
      "CO2 (g/mi)": "209.0477833",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "AVALON XLE",
      "CO2 (g/mi)": "187.6459986",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "C-HR",
      "CO2 (g/mi)": "328.8941905",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY",
      "CO2 (g/mi)": "309.0516813",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY AWD LE/SE",
      "CO2 (g/mi)": "174.5514762",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID LE",
      "CO2 (g/mi)": "180.0303654",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY HYBRID XLE/SE",
      "CO2 (g/mi)": "212.3416743",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY LE/SE",
      "CO2 (g/mi)": "246.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XLE/XSE",
      "CO2 (g/mi)": "248.2167202",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "CAMRY XSE",
      "CO2 (g/mi)": "192.3534168",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA",
      "CO2 (g/mi)": "231.8515293",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HATCHBACK",
      "CO2 (g/mi)": "155.7985377",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HATCHBACK MANUAL",
      "CO2 (g/mi)": "163.6324276",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA HYBRID",
      "CO2 (g/mi)": "167.6613704",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA XLE",
      "CO2 (g/mi)": "160.0674432",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "COROLLA XSE",
      "CO2 (g/mi)": "222.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER",
      "CO2 (g/mi)": "214.9655638",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER AWD",
      "CO2 (g/mi)": "350.3817166",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID",
      "CO2 (g/mi)": "234.8789354",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD",
      "CO2 (g/mi)": "239.4927739",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "HIGHLANDER HYBRID AWD LTD/PLAT",
      "CO2 (g/mi)": "245.3413808",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LAND CRUSER WAGON 4WD",
      "CO2 (g/mi)": "361.4580823",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "LC 500 CONVERTIBLE",
      "CO2 (g/mi)": "252.8616318",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "MIRAI LIMITED",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS",
      "CO2 (g/mi)": "182.9164116",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS AWD",
      "CO2 (g/mi)": "193.4888283",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS Eco",
      "CO2 (g/mi)": "153.2872691",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "PRIUS PRIME",
      "CO2 (g/mi)": "180.4342403",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4",
      "CO2 (g/mi)": "173.5263854",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD",
      "CO2 (g/mi)": "183.8557185",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 AWD TRD OFFROAD",
      "CO2 (g/mi)": "194.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 HYBRID AWD",
      "CO2 (g/mi)": "202.0070316",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "RAV4 PRIME AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 2WD",
      "CO2 (g/mi)": "545.8558090",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SEQUOIA 4WD",
      "CO2 (g/mi)": "570.1310668",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA",
      "CO2 (g/mi)": "187.4766611",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "SIENNA AWD",
      "CO2 (g/mi)": "189.2795028",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 2WD",
      "CO2 (g/mi)": "361.7924411",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD",
      "CO2 (g/mi)": "417.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TACOMA 4WD D-CAB V6 MT OFF-ROAD",
      "CO2 (g/mi)": "319.0533243",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 2WD",
      "CO2 (g/mi)": "531.6561360",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "TUNDRA 4WD",
      "CO2 (g/mi)": "555.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "TOYOTA",
      "Represented Test Veh Model": "VENZA AWD",
      "CO2 (g/mi)": "203.4144299",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4",
      "CO2 (g/mi)": "271.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Allroad",
      "CO2 (g/mi)": "285.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A4 Sedan",
      "CO2 (g/mi)": "305.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 Allroad",
      "CO2 (g/mi)": "379.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 quattro",
      "CO2 (g/mi)": "302.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A6 Quattro (C8)",
      "CO2 (g/mi)": "286.5399475",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A7 55 TFSIe",
      "CO2 (g/mi)": "274.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8",
      "CO2 (g/mi)": "562.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L",
      "CO2 (g/mi)": "492.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "A8L PHEV",
      "CO2 (g/mi)": "398.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Audi e-tron 55 quattro Sportback",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3",
      "CO2 (g/mi)": "348.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q3 40 TFSI quattro",
      "CO2 (g/mi)": "313.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5",
      "CO2 (g/mi)": "292.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q5 55 TFSIe",
      "CO2 (g/mi)": "292.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q7",
      "CO2 (g/mi)": "414.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "Q8",
      "CO2 (g/mi)": "431.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "R8",
      "CO2 (g/mi)": "546.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS5",
      "CO2 (g/mi)": "400.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RS7",
      "CO2 (g/mi)": "304.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "RSQ8",
      "CO2 (g/mi)": "518.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S4",
      "CO2 (g/mi)": "218.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S7",
      "CO2 (g/mi)": "353.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "S8",
      "CO2 (g/mi)": "513.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ5",
      "CO2 (g/mi)": "378.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ7",
      "CO2 (g/mi)": "485.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "SQ8",
      "CO2 (g/mi)": "486.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TT",
      "CO2 (g/mi)": "328.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTRS",
      "CO2 (g/mi)": "361.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "AUDI",
      "Represented Test Veh Model": "TTS",
      "CO2 (g/mi)": "364.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Bentayga V8",
      "CO2 (g/mi)": "505.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BENTLEY",
      "Represented Test Veh Model": "Continental GT Convertible W12",
      "CO2 (g/mi)": "586.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Bugatti Chiron",
      "CO2 (g/mi)": "855.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "BUGATTI",
      "Represented Test Veh Model": "Bugatti Pur Sport",
      "CO2 (g/mi)": "947.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Aventador S",
      "CO2 (g/mi)": "899.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Aventador SVJ",
      "CO2 (g/mi)": "843.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Huracan performante",
      "CO2 (g/mi)": "504.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "LAMBORGHINI",
      "Represented Test Veh Model": "Urus",
      "CO2 (g/mi)": "572.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Arteon 4Motion",
      "CO2 (g/mi)": "387.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Arteon PA",
      "CO2 (g/mi)": "201.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Atlas",
      "CO2 (g/mi)": "414.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Atlas Cross Sport",
      "CO2 (g/mi)": "420.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf",
      "CO2 (g/mi)": "275.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Golf GTI",
      "CO2 (g/mi)": "201.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volkswagen",
      "Represented Test Veh Model": "ID.4 Pro",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta",
      "CO2 (g/mi)": "263.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Jetta GLI",
      "CO2 (g/mi)": "340.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Passat",
      "CO2 (g/mi)": "296.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan AWD",
      "CO2 (g/mi)": "228.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "VOLKSWAGEN",
      "Represented Test Veh Model": "Tiguan FWD",
      "CO2 (g/mi)": "306.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Polestar",
      "Represented Test Veh Model": "Polestar 1",
      "CO2 (g/mi)": "321.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Polestar",
      "Represented Test Veh Model": "Polestar 2",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 AWD",
      "CO2 (g/mi)": "319.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T5 FWD",
      "CO2 (g/mi)": "176.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T6 AWD",
      "CO2 (g/mi)": "192.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S60 T8 AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T6 AWD",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "S90 T8 AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V60CC T5 AWD",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "V90CC T6 AWD",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 P8 AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 T4 FWD",
      "CO2 (g/mi)": "304.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC40 T5 AWD",
      "CO2 (g/mi)": "322.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 AWD",
      "CO2 (g/mi)": "332.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T5 FWD",
      "CO2 (g/mi)": "212.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T6 AWD",
      "CO2 (g/mi)": "347.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC60 T8 AWD",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 AWD",
      "CO2 (g/mi)": "342.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T5 FWD",
      "CO2 (g/mi)": "325.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T6 AWD",
      "CO2 (g/mi)": "362.0000000",
    },
    {
      "Model Year": "2021",
      "Represented Test Veh Make": "Volvo",
      "Represented Test Veh Model": "XC90 T8 AWD",
    },
  ],
};

export default carData;
